/* eslint-disable */
import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export const VideoFragmentDoc = gql`
  fragment Video on Video {
    id
    status
    streamUrl
    thumbnailUrl
  }
`
export const CalendarPartsFragmentDoc = gql`
  fragment CalendarParts on Calendar {
    maxStartDate
    listing {
      id
      concurrentBookings
      snoozed
      listingType {
        slug
      }
    }
    days {
      date
      available
      customPrice
      minimumNights
      price
      requested
      weekendPrice
      discount {
        id
        name
        percentage
        startDate
        endDate
      }
    }
  }
`
export const AdventureFragmentFragmentDoc = gql`
  fragment AdventureFragment on StoryAdventure {
    id
    title
    location {
      name
      lat
      lng
    }
    photos(first: 1) {
      image {
        medium
      }
    }
  }
`
export const BankAccountFragmentFragmentDoc = gql`
  fragment BankAccountFragment on BankAccount {
    id
    bankName
    country
    currency
    default
    last4
    listings {
      id
      title
    }
  }
`
export const CreditCardFieldsFragmentDoc = gql`
  fragment CreditCardFields on CreditCard {
    id
    name
    brand
    last4
    expMonth
    expYear
    country
    default
    expired
  }
`
export const AssignmentListingsFieldFragmentDoc = gql`
  fragment AssignmentListingsField on Assignment {
    id
    listings {
      id
      state
      title
      capacity
      city
      url
      pricingSuffix
      promoImage {
        medium
        large
      }
    }
  }
`
export const AssignmentBookingFieldFragmentDoc = gql`
  fragment AssignmentBookingField on Assignment {
    id
    booking {
      id
      adults
      children
      startDate
      endDate
      totalGuests
      total
      status
      lineItems {
        id
        itemType
        price
        quantity
        amount
      }
      listing {
        id
        pricingSuffix
        extraPersonFee
        city
        state
      }
      conversation {
        id
      }
    }
  }
`
export const AssignmentFragmentDoc = gql`
  fragment Assignment on Assignment {
    id
    status
    statusLabel
    startDate
    endDate
    adultGuests: adults
    childrenGuests: children
    totalGuests
    submittedAt
    invitationExpiresAt
    role
    listing {
      id
      capacity
      state
      title
      city
      url
      pricingSuffix
      promoImage {
        medium
        large
      }
    }
    story {
      id
      status
    }
    storyteller {
      id
      firstName
      lastName
      url
      instagram
      avatar {
        original
        thumbMd
      }
    }
  }
`
export const EditListingAdventureFragmentFragmentDoc = gql`
  fragment EditListingAdventureFragment on Adventure {
    id
    title
    description
    adventureType {
      id
      slug
      name
    }
    photos(first: 1) {
      id
      image {
        medium
        large
      }
    }
    location {
      name
      lat
      lng
    }
    locationType
  }
`
export const ConversationItemFragmentFragmentDoc = gql`
  fragment ConversationItemFragment on Conversation {
    id
    archivable
    archivedAt
    lastMessage {
      id
      body
      createdAt
    }
    booking {
      id
      status
      pendingChangeRequest {
        id
      }
      storytellerBooking
    }
    listing {
      id
      title
    }
    correspondent {
      id
      firstName
      lastName
      avatar {
        original
        thumbMd
      }
    }
  }
`
export const ConversationConnectionFragmentFragmentDoc = gql`
  fragment ConversationConnectionFragment on ConversationConnection {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        ...ConversationItemFragment
      }
    }
  }
  ${ConversationItemFragmentFragmentDoc}
`
export const BucketListThemeFragmentDoc = gql`
  fragment BucketListTheme on BucketListTheme {
    id
    name
    image {
      hero
      large
      medium
      thumb
    }
  }
`
export const BucketListFragmentFragmentDoc = gql`
  fragment BucketListFragment on BucketList {
    id
    name
    includesAccommodation
    theme {
      ...BucketListTheme
    }
  }
  ${BucketListThemeFragmentDoc}
`
export const ListingCardFragmentFragmentDoc = gql`
  fragment ListingCardFragment on Listing {
    id
    url
    title
    price
    pricingSuffix
    nicePricingSuffix
    capacity
    city
    location {
      name
      lat
      lng
    }
    reviewScore
    reviewCount
    currency
    weekendPrice
    listingType {
      slug
    }
    promoImage {
      medium
      large
    }
    instantBookEnabled
    driveTimeMinutes
    accessByBoat
    subcategory {
      id
      name
    }
    cardTag
  }
`
export const StoryCardFragmentFragmentDoc = gql`
  fragment StoryCardFragment on Story {
    id
    title
    url
    videoUrl
    user {
      avatar {
        original
        thumbLg
      }
      firstName
    }
    promoImage {
      medium
      large
    }
    featuredListingImage {
      medium
      large
    }
    cardTag
  }
`
export const StoryFeaturedListingFragmentFragmentDoc = gql`
  fragment StoryFeaturedListingFragment on Listing {
    id
    title
    price
    pricingSuffix
    nicePricingSuffix
    reviewScore
    reviewCount
    currency
    weekendPrice
    listingType {
      slug
    }
    instantBookEnabled
    driveTimeMinutes
    accessByBoat
    url
    capacity
    city
    location {
      name
      lat
      lng
    }
  }
`
export const AdventureCardFragmentFragmentDoc = gql`
  fragment AdventureCardFragment on StoryAdventure {
    id
    title
    description
    adventureType {
      id
      slug
      name
    }
    photos(first: 5) {
      id
      image {
        medium
        large
      }
    }
    location {
      name
      lat
      lng
    }
    locationType
    reviewScore
    story {
      id
      title
      url
      active
    }
    storyteller {
      id
      firstName
      url
      avatar {
        original
        thumb
        thumbLg
      }
    }
    storyUrl
    url
  }
`
export const ListingAdventureFragmentDoc = gql`
  fragment ListingAdventure on ListingAdventure {
    id
    title
    description
    adventureType {
      id
      slug
    }
    photos(first: 5) {
      image {
        medium
      }
    }
    location {
      name
      lat
      lng
    }
    locationType
    reviewScore
    url
  }
`
export const BucketListItemConnectionFragmentDoc = gql`
  fragment BucketListItemConnection on BucketListItemConnection {
    edges {
      node {
        pricing {
          total
          customerServiceFee
          lineItems {
            itemType
            quantity
            price
            amount
          }
        }
        item {
          ... on Listing {
            ...ListingCardFragment
            stories {
              ...StoryCardFragment
            }
          }
          ... on Story {
            ...StoryCardFragment
            featuredListing {
              ...StoryFeaturedListingFragment
            }
          }
          ... on StoryAdventure {
            ...AdventureCardFragment
          }
          ... on ListingAdventure {
            ...ListingAdventure
          }
        }
      }
    }
  }
  ${ListingCardFragmentFragmentDoc}
  ${StoryCardFragmentFragmentDoc}
  ${StoryFeaturedListingFragmentFragmentDoc}
  ${AdventureCardFragmentFragmentDoc}
  ${ListingAdventureFragmentDoc}
`
export const MapResultFragmentFragmentDoc = gql`
  fragment MapResultFragment on MapResult {
    id
    slug
    type
    location: coordinates
  }
`
export const CollectionFragmentDoc = gql`
  fragment Collection on Collection {
    id
    name
    slug
    url
    category
    image {
      medium
      large
    }
    market {
      id
      code
      name
    }
  }
`
export const ListingNearbyAdventureFragmentDoc = gql`
  fragment ListingNearbyAdventure on Adventure {
    id
    title
    description
    title
    url
    photos {
      id
      image {
        medium
        thumb
      }
    }
    adventureType {
      id
      name
      slug
      category
    }
    ... on StoryAdventure {
      story {
        id
        title
      }
      storyUrl
      storyteller {
        id
        firstName
        avatar {
          original
          thumb
          thumbLg
        }
      }
    }
  }
`
export const ListingReviewFragmentDoc = gql`
  fragment ListingReview on ListingReview {
    id
    createdAt
    reviewer {
      firstName
      avatar {
        original
        thumbLg
      }
    }
    content
    fulfillingMoments {
      slug
      name
    }
  }
`
export const CustomerReferralFragmentDoc = gql`
  fragment CustomerReferral on CustomerReferral {
    id
    recipientFirstName
    recipientLastName
    recipientEmail
    message
    status
    createdAt
    sentAt
    completedAt
    shareUrl
    rewardVoucher {
      code
      amount
      balance
      expiresAt
    }
    referralVoucher {
      amount
    }
  }
`
export const AddToBucketListDocument = gql`
  mutation addToBucketList(
    $bucketListId: ID!
    $itemId: ID!
    $itemType: Searchable!
    $source: String!
  ) {
    addToBucketList(
      bucketListId: $bucketListId
      itemId: $itemId
      itemType: $itemType
      source: $source
    ) {
      bucketListItem {
        item {
          ... on Listing {
            id
          }
          ... on StoryAdventure {
            id
          }
          ... on Story {
            id
          }
        }
      }
    }
  }
`
export type GQL_AddToBucketListMutationFn = Apollo.MutationFunction<
  GQL_AddToBucketListMutation,
  GQL_AddToBucketListMutationVariables
>

/**
 * __useAddToBucketListMutation__
 *
 * To run a mutation, you first call `useAddToBucketListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToBucketListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToBucketListMutation, { data, loading, error }] = useAddToBucketListMutation({
 *   variables: {
 *      bucketListId: // value for 'bucketListId'
 *      itemId: // value for 'itemId'
 *      itemType: // value for 'itemType'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useAddToBucketListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_AddToBucketListMutation,
    GQL_AddToBucketListMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_AddToBucketListMutation,
    GQL_AddToBucketListMutationVariables
  >(AddToBucketListDocument, options)
}
export type AddToBucketListMutationHookResult = ReturnType<
  typeof useAddToBucketListMutation
>
export type AddToBucketListMutationResult =
  Apollo.MutationResult<GQL_AddToBucketListMutation>
export type AddToBucketListMutationOptions = Apollo.BaseMutationOptions<
  GQL_AddToBucketListMutation,
  GQL_AddToBucketListMutationVariables
>
export const GetMyBucketListsWithItemDocument = gql`
  query getMyBucketListsWithItem($itemId: ID!, $itemType: Searchable!) {
    currentUser {
      id
      allBucketLists: bucketLists {
        ...BucketListFragment
      }
      bucketListsWithItem: bucketLists(itemId: $itemId, itemType: $itemType) {
        ...BucketListFragment
      }
    }
  }
  ${BucketListFragmentFragmentDoc}
`

/**
 * __useGetMyBucketListsWithItemQuery__
 *
 * To run a query within a React component, call `useGetMyBucketListsWithItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyBucketListsWithItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyBucketListsWithItemQuery({
 *   variables: {
 *      itemId: // value for 'itemId'
 *      itemType: // value for 'itemType'
 *   },
 * });
 */
export function useGetMyBucketListsWithItemQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetMyBucketListsWithItemQuery,
    GQL_GetMyBucketListsWithItemQueryVariables
  > &
    (
      | {
          variables: GQL_GetMyBucketListsWithItemQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetMyBucketListsWithItemQuery,
    GQL_GetMyBucketListsWithItemQueryVariables
  >(GetMyBucketListsWithItemDocument, options)
}
export function useGetMyBucketListsWithItemLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetMyBucketListsWithItemQuery,
    GQL_GetMyBucketListsWithItemQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetMyBucketListsWithItemQuery,
    GQL_GetMyBucketListsWithItemQueryVariables
  >(GetMyBucketListsWithItemDocument, options)
}
// @ts-ignore
export function useGetMyBucketListsWithItemSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetMyBucketListsWithItemQuery,
    GQL_GetMyBucketListsWithItemQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetMyBucketListsWithItemQuery,
  GQL_GetMyBucketListsWithItemQueryVariables
>
export function useGetMyBucketListsWithItemSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetMyBucketListsWithItemQuery,
        GQL_GetMyBucketListsWithItemQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetMyBucketListsWithItemQuery | undefined,
  GQL_GetMyBucketListsWithItemQueryVariables
>
export function useGetMyBucketListsWithItemSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetMyBucketListsWithItemQuery,
        GQL_GetMyBucketListsWithItemQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetMyBucketListsWithItemQuery,
    GQL_GetMyBucketListsWithItemQueryVariables
  >(GetMyBucketListsWithItemDocument, options)
}
export type GetMyBucketListsWithItemQueryHookResult = ReturnType<
  typeof useGetMyBucketListsWithItemQuery
>
export type GetMyBucketListsWithItemLazyQueryHookResult = ReturnType<
  typeof useGetMyBucketListsWithItemLazyQuery
>
export type GetMyBucketListsWithItemSuspenseQueryHookResult = ReturnType<
  typeof useGetMyBucketListsWithItemSuspenseQuery
>
export type GetMyBucketListsWithItemQueryResult = Apollo.QueryResult<
  GQL_GetMyBucketListsWithItemQuery,
  GQL_GetMyBucketListsWithItemQueryVariables
>
export const GetMyUpcomingBookingsWithAdventuresAndListingDocument = gql`
  query getMyUpcomingBookingsWithAdventuresAndListing {
    currentUser {
      id
      upcomingBookings {
        id
        startDate
        endDate
        listing {
          id
          title
          promoImage {
            medium
            thumb
          }
        }
        story {
          id
          promoImage {
            medium
            thumb
          }
        }
        adventures {
          id
        }
      }
    }
  }
`

/**
 * __useGetMyUpcomingBookingsWithAdventuresAndListingQuery__
 *
 * To run a query within a React component, call `useGetMyUpcomingBookingsWithAdventuresAndListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyUpcomingBookingsWithAdventuresAndListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyUpcomingBookingsWithAdventuresAndListingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyUpcomingBookingsWithAdventuresAndListingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GQL_GetMyUpcomingBookingsWithAdventuresAndListingQuery,
    GQL_GetMyUpcomingBookingsWithAdventuresAndListingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetMyUpcomingBookingsWithAdventuresAndListingQuery,
    GQL_GetMyUpcomingBookingsWithAdventuresAndListingQueryVariables
  >(GetMyUpcomingBookingsWithAdventuresAndListingDocument, options)
}
export function useGetMyUpcomingBookingsWithAdventuresAndListingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetMyUpcomingBookingsWithAdventuresAndListingQuery,
    GQL_GetMyUpcomingBookingsWithAdventuresAndListingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetMyUpcomingBookingsWithAdventuresAndListingQuery,
    GQL_GetMyUpcomingBookingsWithAdventuresAndListingQueryVariables
  >(GetMyUpcomingBookingsWithAdventuresAndListingDocument, options)
}
// @ts-ignore
export function useGetMyUpcomingBookingsWithAdventuresAndListingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetMyUpcomingBookingsWithAdventuresAndListingQuery,
    GQL_GetMyUpcomingBookingsWithAdventuresAndListingQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetMyUpcomingBookingsWithAdventuresAndListingQuery,
  GQL_GetMyUpcomingBookingsWithAdventuresAndListingQueryVariables
>
export function useGetMyUpcomingBookingsWithAdventuresAndListingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetMyUpcomingBookingsWithAdventuresAndListingQuery,
        GQL_GetMyUpcomingBookingsWithAdventuresAndListingQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetMyUpcomingBookingsWithAdventuresAndListingQuery | undefined,
  GQL_GetMyUpcomingBookingsWithAdventuresAndListingQueryVariables
>
export function useGetMyUpcomingBookingsWithAdventuresAndListingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetMyUpcomingBookingsWithAdventuresAndListingQuery,
        GQL_GetMyUpcomingBookingsWithAdventuresAndListingQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetMyUpcomingBookingsWithAdventuresAndListingQuery,
    GQL_GetMyUpcomingBookingsWithAdventuresAndListingQueryVariables
  >(GetMyUpcomingBookingsWithAdventuresAndListingDocument, options)
}
export type GetMyUpcomingBookingsWithAdventuresAndListingQueryHookResult =
  ReturnType<typeof useGetMyUpcomingBookingsWithAdventuresAndListingQuery>
export type GetMyUpcomingBookingsWithAdventuresAndListingLazyQueryHookResult =
  ReturnType<typeof useGetMyUpcomingBookingsWithAdventuresAndListingLazyQuery>
export type GetMyUpcomingBookingsWithAdventuresAndListingSuspenseQueryHookResult =
  ReturnType<
    typeof useGetMyUpcomingBookingsWithAdventuresAndListingSuspenseQuery
  >
export type GetMyUpcomingBookingsWithAdventuresAndListingQueryResult =
  Apollo.QueryResult<
    GQL_GetMyUpcomingBookingsWithAdventuresAndListingQuery,
    GQL_GetMyUpcomingBookingsWithAdventuresAndListingQueryVariables
  >
export const GetSelectEscapeIndexesDocument = gql`
  query getSelectEscapeIndexes {
    currentUser {
      id
      bucketListItemsIndex
      bookingAdventuresIndex
    }
  }
`

/**
 * __useGetSelectEscapeIndexesQuery__
 *
 * To run a query within a React component, call `useGetSelectEscapeIndexesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelectEscapeIndexesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelectEscapeIndexesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSelectEscapeIndexesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GQL_GetSelectEscapeIndexesQuery,
    GQL_GetSelectEscapeIndexesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetSelectEscapeIndexesQuery,
    GQL_GetSelectEscapeIndexesQueryVariables
  >(GetSelectEscapeIndexesDocument, options)
}
export function useGetSelectEscapeIndexesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetSelectEscapeIndexesQuery,
    GQL_GetSelectEscapeIndexesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetSelectEscapeIndexesQuery,
    GQL_GetSelectEscapeIndexesQueryVariables
  >(GetSelectEscapeIndexesDocument, options)
}
// @ts-ignore
export function useGetSelectEscapeIndexesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetSelectEscapeIndexesQuery,
    GQL_GetSelectEscapeIndexesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetSelectEscapeIndexesQuery,
  GQL_GetSelectEscapeIndexesQueryVariables
>
export function useGetSelectEscapeIndexesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetSelectEscapeIndexesQuery,
        GQL_GetSelectEscapeIndexesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetSelectEscapeIndexesQuery | undefined,
  GQL_GetSelectEscapeIndexesQueryVariables
>
export function useGetSelectEscapeIndexesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetSelectEscapeIndexesQuery,
        GQL_GetSelectEscapeIndexesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetSelectEscapeIndexesQuery,
    GQL_GetSelectEscapeIndexesQueryVariables
  >(GetSelectEscapeIndexesDocument, options)
}
export type GetSelectEscapeIndexesQueryHookResult = ReturnType<
  typeof useGetSelectEscapeIndexesQuery
>
export type GetSelectEscapeIndexesLazyQueryHookResult = ReturnType<
  typeof useGetSelectEscapeIndexesLazyQuery
>
export type GetSelectEscapeIndexesSuspenseQueryHookResult = ReturnType<
  typeof useGetSelectEscapeIndexesSuspenseQuery
>
export type GetSelectEscapeIndexesQueryResult = Apollo.QueryResult<
  GQL_GetSelectEscapeIndexesQuery,
  GQL_GetSelectEscapeIndexesQueryVariables
>
export const RemoveFromBucketListDocument = gql`
  mutation removeFromBucketList(
    $bucketListId: ID!
    $itemId: ID!
    $itemType: Searchable!
    $source: String!
  ) {
    removeFromBucketList(
      bucketListId: $bucketListId
      itemId: $itemId
      itemType: $itemType
      source: $source
    ) {
      bucketListItem {
        item {
          ... on Listing {
            id
          }
          ... on StoryAdventure {
            id
          }
          ... on Story {
            id
          }
        }
      }
    }
  }
`
export type GQL_RemoveFromBucketListMutationFn = Apollo.MutationFunction<
  GQL_RemoveFromBucketListMutation,
  GQL_RemoveFromBucketListMutationVariables
>

/**
 * __useRemoveFromBucketListMutation__
 *
 * To run a mutation, you first call `useRemoveFromBucketListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFromBucketListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFromBucketListMutation, { data, loading, error }] = useRemoveFromBucketListMutation({
 *   variables: {
 *      bucketListId: // value for 'bucketListId'
 *      itemId: // value for 'itemId'
 *      itemType: // value for 'itemType'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useRemoveFromBucketListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_RemoveFromBucketListMutation,
    GQL_RemoveFromBucketListMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_RemoveFromBucketListMutation,
    GQL_RemoveFromBucketListMutationVariables
  >(RemoveFromBucketListDocument, options)
}
export type RemoveFromBucketListMutationHookResult = ReturnType<
  typeof useRemoveFromBucketListMutation
>
export type RemoveFromBucketListMutationResult =
  Apollo.MutationResult<GQL_RemoveFromBucketListMutation>
export type RemoveFromBucketListMutationOptions = Apollo.BaseMutationOptions<
  GQL_RemoveFromBucketListMutation,
  GQL_RemoveFromBucketListMutationVariables
>
export const GetCurrentUserDocument = gql`
  query getCurrentUser {
    currentUser {
      id
      deleteRequestedAt
      incompleteBookings {
        id
        startDate
        endDate
        promoImage {
          thumb
        }
        listing {
          id
          title
        }
      }
    }
  }
`

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GQL_GetCurrentUserQuery,
    GQL_GetCurrentUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetCurrentUserQuery,
    GQL_GetCurrentUserQueryVariables
  >(GetCurrentUserDocument, options)
}
export function useGetCurrentUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetCurrentUserQuery,
    GQL_GetCurrentUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetCurrentUserQuery,
    GQL_GetCurrentUserQueryVariables
  >(GetCurrentUserDocument, options)
}
// @ts-ignore
export function useGetCurrentUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetCurrentUserQuery,
    GQL_GetCurrentUserQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetCurrentUserQuery,
  GQL_GetCurrentUserQueryVariables
>
export function useGetCurrentUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetCurrentUserQuery,
        GQL_GetCurrentUserQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetCurrentUserQuery | undefined,
  GQL_GetCurrentUserQueryVariables
>
export function useGetCurrentUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetCurrentUserQuery,
        GQL_GetCurrentUserQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetCurrentUserQuery,
    GQL_GetCurrentUserQueryVariables
  >(GetCurrentUserDocument, options)
}
export type GetCurrentUserQueryHookResult = ReturnType<
  typeof useGetCurrentUserQuery
>
export type GetCurrentUserLazyQueryHookResult = ReturnType<
  typeof useGetCurrentUserLazyQuery
>
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<
  typeof useGetCurrentUserSuspenseQuery
>
export type GetCurrentUserQueryResult = Apollo.QueryResult<
  GQL_GetCurrentUserQuery,
  GQL_GetCurrentUserQueryVariables
>
export const GetBookingInvitationDocument = gql`
  query getBookingInvitation($token: ID!) {
    bookingInvitation(token: $token) {
      id
      bookingCustomerId
      promoImage {
        thumb
      }
      listing {
        id
        title
        location {
          name
          lat
          lng
        }
      }
    }
  }
`

/**
 * __useGetBookingInvitationQuery__
 *
 * To run a query within a React component, call `useGetBookingInvitationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingInvitationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingInvitationQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetBookingInvitationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetBookingInvitationQuery,
    GQL_GetBookingInvitationQueryVariables
  > &
    (
      | { variables: GQL_GetBookingInvitationQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetBookingInvitationQuery,
    GQL_GetBookingInvitationQueryVariables
  >(GetBookingInvitationDocument, options)
}
export function useGetBookingInvitationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetBookingInvitationQuery,
    GQL_GetBookingInvitationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetBookingInvitationQuery,
    GQL_GetBookingInvitationQueryVariables
  >(GetBookingInvitationDocument, options)
}
// @ts-ignore
export function useGetBookingInvitationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetBookingInvitationQuery,
    GQL_GetBookingInvitationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetBookingInvitationQuery,
  GQL_GetBookingInvitationQueryVariables
>
export function useGetBookingInvitationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetBookingInvitationQuery,
        GQL_GetBookingInvitationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetBookingInvitationQuery | undefined,
  GQL_GetBookingInvitationQueryVariables
>
export function useGetBookingInvitationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetBookingInvitationQuery,
        GQL_GetBookingInvitationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetBookingInvitationQuery,
    GQL_GetBookingInvitationQueryVariables
  >(GetBookingInvitationDocument, options)
}
export type GetBookingInvitationQueryHookResult = ReturnType<
  typeof useGetBookingInvitationQuery
>
export type GetBookingInvitationLazyQueryHookResult = ReturnType<
  typeof useGetBookingInvitationLazyQuery
>
export type GetBookingInvitationSuspenseQueryHookResult = ReturnType<
  typeof useGetBookingInvitationSuspenseQuery
>
export type GetBookingInvitationQueryResult = Apollo.QueryResult<
  GQL_GetBookingInvitationQuery,
  GQL_GetBookingInvitationQueryVariables
>
export const JoinTravelCrewDocument = gql`
  mutation joinTravelCrew($bookingId: ID!, $hashid: String!) {
    joinTravelCrew(bookingId: $bookingId, hashid: $hashid) {
      booking {
        id
        travelCrew {
          id
          firstName
          lastName
        }
      }
    }
  }
`
export type GQL_JoinTravelCrewMutationFn = Apollo.MutationFunction<
  GQL_JoinTravelCrewMutation,
  GQL_JoinTravelCrewMutationVariables
>

/**
 * __useJoinTravelCrewMutation__
 *
 * To run a mutation, you first call `useJoinTravelCrewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinTravelCrewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinTravelCrewMutation, { data, loading, error }] = useJoinTravelCrewMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      hashid: // value for 'hashid'
 *   },
 * });
 */
export function useJoinTravelCrewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_JoinTravelCrewMutation,
    GQL_JoinTravelCrewMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_JoinTravelCrewMutation,
    GQL_JoinTravelCrewMutationVariables
  >(JoinTravelCrewDocument, options)
}
export type JoinTravelCrewMutationHookResult = ReturnType<
  typeof useJoinTravelCrewMutation
>
export type JoinTravelCrewMutationResult =
  Apollo.MutationResult<GQL_JoinTravelCrewMutation>
export type JoinTravelCrewMutationOptions = Apollo.BaseMutationOptions<
  GQL_JoinTravelCrewMutation,
  GQL_JoinTravelCrewMutationVariables
>
export const ApplyVoucherBalanceDocument = gql`
  mutation applyVoucherBalance($bookingId: ID!) {
    applyVoucherBalance(bookingId: $bookingId) {
      booking {
        id
      }
    }
  }
`
export type GQL_ApplyVoucherBalanceMutationFn = Apollo.MutationFunction<
  GQL_ApplyVoucherBalanceMutation,
  GQL_ApplyVoucherBalanceMutationVariables
>

/**
 * __useApplyVoucherBalanceMutation__
 *
 * To run a mutation, you first call `useApplyVoucherBalanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyVoucherBalanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyVoucherBalanceMutation, { data, loading, error }] = useApplyVoucherBalanceMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useApplyVoucherBalanceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_ApplyVoucherBalanceMutation,
    GQL_ApplyVoucherBalanceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_ApplyVoucherBalanceMutation,
    GQL_ApplyVoucherBalanceMutationVariables
  >(ApplyVoucherBalanceDocument, options)
}
export type ApplyVoucherBalanceMutationHookResult = ReturnType<
  typeof useApplyVoucherBalanceMutation
>
export type ApplyVoucherBalanceMutationResult =
  Apollo.MutationResult<GQL_ApplyVoucherBalanceMutation>
export type ApplyVoucherBalanceMutationOptions = Apollo.BaseMutationOptions<
  GQL_ApplyVoucherBalanceMutation,
  GQL_ApplyVoucherBalanceMutationVariables
>
export const DestroyBookingVoucherDocument = gql`
  mutation destroyBookingVoucher($bookingId: ID!, $voucherId: ID!) {
    destroyBookingVoucher(bookingId: $bookingId, voucherId: $voucherId) {
      booking {
        id
      }
    }
  }
`
export type GQL_DestroyBookingVoucherMutationFn = Apollo.MutationFunction<
  GQL_DestroyBookingVoucherMutation,
  GQL_DestroyBookingVoucherMutationVariables
>

/**
 * __useDestroyBookingVoucherMutation__
 *
 * To run a mutation, you first call `useDestroyBookingVoucherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyBookingVoucherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyBookingVoucherMutation, { data, loading, error }] = useDestroyBookingVoucherMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      voucherId: // value for 'voucherId'
 *   },
 * });
 */
export function useDestroyBookingVoucherMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_DestroyBookingVoucherMutation,
    GQL_DestroyBookingVoucherMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_DestroyBookingVoucherMutation,
    GQL_DestroyBookingVoucherMutationVariables
  >(DestroyBookingVoucherDocument, options)
}
export type DestroyBookingVoucherMutationHookResult = ReturnType<
  typeof useDestroyBookingVoucherMutation
>
export type DestroyBookingVoucherMutationResult =
  Apollo.MutationResult<GQL_DestroyBookingVoucherMutation>
export type DestroyBookingVoucherMutationOptions = Apollo.BaseMutationOptions<
  GQL_DestroyBookingVoucherMutation,
  GQL_DestroyBookingVoucherMutationVariables
>
export const GetBookingSuccessDocument = gql`
  query getBookingSuccess($id: ID!) {
    booking(id: $id) {
      id
      status
      paymentStatus
      storytellerBooking
      startDate
      endDate
      role
      joinUrl
      listing {
        id
        title
        url
        city
        state
        checkIn
        checkOut
      }
      story {
        id
        title
        url
      }
      promoImage {
        medium
      }
    }
  }
`

/**
 * __useGetBookingSuccessQuery__
 *
 * To run a query within a React component, call `useGetBookingSuccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingSuccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingSuccessQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBookingSuccessQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetBookingSuccessQuery,
    GQL_GetBookingSuccessQueryVariables
  > &
    (
      | { variables: GQL_GetBookingSuccessQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetBookingSuccessQuery,
    GQL_GetBookingSuccessQueryVariables
  >(GetBookingSuccessDocument, options)
}
export function useGetBookingSuccessLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetBookingSuccessQuery,
    GQL_GetBookingSuccessQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetBookingSuccessQuery,
    GQL_GetBookingSuccessQueryVariables
  >(GetBookingSuccessDocument, options)
}
// @ts-ignore
export function useGetBookingSuccessSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetBookingSuccessQuery,
    GQL_GetBookingSuccessQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetBookingSuccessQuery,
  GQL_GetBookingSuccessQueryVariables
>
export function useGetBookingSuccessSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetBookingSuccessQuery,
        GQL_GetBookingSuccessQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetBookingSuccessQuery | undefined,
  GQL_GetBookingSuccessQueryVariables
>
export function useGetBookingSuccessSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetBookingSuccessQuery,
        GQL_GetBookingSuccessQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetBookingSuccessQuery,
    GQL_GetBookingSuccessQueryVariables
  >(GetBookingSuccessDocument, options)
}
export type GetBookingSuccessQueryHookResult = ReturnType<
  typeof useGetBookingSuccessQuery
>
export type GetBookingSuccessLazyQueryHookResult = ReturnType<
  typeof useGetBookingSuccessLazyQuery
>
export type GetBookingSuccessSuspenseQueryHookResult = ReturnType<
  typeof useGetBookingSuccessSuspenseQuery
>
export type GetBookingSuccessQueryResult = Apollo.QueryResult<
  GQL_GetBookingSuccessQuery,
  GQL_GetBookingSuccessQueryVariables
>
export const GetPhotosForListingDocument = gql`
  query getPhotosForListing($id: ID) {
    photos(ownerId: $id, ownerType: "Listing") {
      image {
        medium
        large
      }
    }
  }
`

/**
 * __useGetPhotosForListingQuery__
 *
 * To run a query within a React component, call `useGetPhotosForListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhotosForListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhotosForListingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPhotosForListingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GQL_GetPhotosForListingQuery,
    GQL_GetPhotosForListingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetPhotosForListingQuery,
    GQL_GetPhotosForListingQueryVariables
  >(GetPhotosForListingDocument, options)
}
export function useGetPhotosForListingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetPhotosForListingQuery,
    GQL_GetPhotosForListingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetPhotosForListingQuery,
    GQL_GetPhotosForListingQueryVariables
  >(GetPhotosForListingDocument, options)
}
// @ts-ignore
export function useGetPhotosForListingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetPhotosForListingQuery,
    GQL_GetPhotosForListingQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetPhotosForListingQuery,
  GQL_GetPhotosForListingQueryVariables
>
export function useGetPhotosForListingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetPhotosForListingQuery,
        GQL_GetPhotosForListingQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetPhotosForListingQuery | undefined,
  GQL_GetPhotosForListingQueryVariables
>
export function useGetPhotosForListingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetPhotosForListingQuery,
        GQL_GetPhotosForListingQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetPhotosForListingQuery,
    GQL_GetPhotosForListingQueryVariables
  >(GetPhotosForListingDocument, options)
}
export type GetPhotosForListingQueryHookResult = ReturnType<
  typeof useGetPhotosForListingQuery
>
export type GetPhotosForListingLazyQueryHookResult = ReturnType<
  typeof useGetPhotosForListingLazyQuery
>
export type GetPhotosForListingSuspenseQueryHookResult = ReturnType<
  typeof useGetPhotosForListingSuspenseQuery
>
export type GetPhotosForListingQueryResult = Apollo.QueryResult<
  GQL_GetPhotosForListingQuery,
  GQL_GetPhotosForListingQueryVariables
>
export const GetStoryCardMediaDocument = gql`
  query getStoryCardMedia($storyId: ID!) {
    story(id: $storyId) {
      id
      photosCount
      portraitCoverImage {
        w400
        w800
        w1200
      }
      promoImage {
        medium
        large
      }
      featuredListingImage {
        medium
        large
      }
      photos(first: 3) {
        id
        image {
          medium
          large
        }
      }
      videos {
        ...Video
      }
    }
  }
  ${VideoFragmentDoc}
`

/**
 * __useGetStoryCardMediaQuery__
 *
 * To run a query within a React component, call `useGetStoryCardMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoryCardMediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoryCardMediaQuery({
 *   variables: {
 *      storyId: // value for 'storyId'
 *   },
 * });
 */
export function useGetStoryCardMediaQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetStoryCardMediaQuery,
    GQL_GetStoryCardMediaQueryVariables
  > &
    (
      | { variables: GQL_GetStoryCardMediaQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetStoryCardMediaQuery,
    GQL_GetStoryCardMediaQueryVariables
  >(GetStoryCardMediaDocument, options)
}
export function useGetStoryCardMediaLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetStoryCardMediaQuery,
    GQL_GetStoryCardMediaQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetStoryCardMediaQuery,
    GQL_GetStoryCardMediaQueryVariables
  >(GetStoryCardMediaDocument, options)
}
// @ts-ignore
export function useGetStoryCardMediaSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetStoryCardMediaQuery,
    GQL_GetStoryCardMediaQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetStoryCardMediaQuery,
  GQL_GetStoryCardMediaQueryVariables
>
export function useGetStoryCardMediaSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetStoryCardMediaQuery,
        GQL_GetStoryCardMediaQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetStoryCardMediaQuery | undefined,
  GQL_GetStoryCardMediaQueryVariables
>
export function useGetStoryCardMediaSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetStoryCardMediaQuery,
        GQL_GetStoryCardMediaQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetStoryCardMediaQuery,
    GQL_GetStoryCardMediaQueryVariables
  >(GetStoryCardMediaDocument, options)
}
export type GetStoryCardMediaQueryHookResult = ReturnType<
  typeof useGetStoryCardMediaQuery
>
export type GetStoryCardMediaLazyQueryHookResult = ReturnType<
  typeof useGetStoryCardMediaLazyQuery
>
export type GetStoryCardMediaSuspenseQueryHookResult = ReturnType<
  typeof useGetStoryCardMediaSuspenseQuery
>
export type GetStoryCardMediaQueryResult = Apollo.QueryResult<
  GQL_GetStoryCardMediaQuery,
  GQL_GetStoryCardMediaQueryVariables
>
export const GetStoryPhotosDocument = gql`
  query getStoryPhotos($storyId: ID!) {
    story(id: $storyId) {
      id
      photos {
        id
        image {
          medium
          large
        }
      }
    }
  }
`

/**
 * __useGetStoryPhotosQuery__
 *
 * To run a query within a React component, call `useGetStoryPhotosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoryPhotosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoryPhotosQuery({
 *   variables: {
 *      storyId: // value for 'storyId'
 *   },
 * });
 */
export function useGetStoryPhotosQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetStoryPhotosQuery,
    GQL_GetStoryPhotosQueryVariables
  > &
    (
      | { variables: GQL_GetStoryPhotosQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetStoryPhotosQuery,
    GQL_GetStoryPhotosQueryVariables
  >(GetStoryPhotosDocument, options)
}
export function useGetStoryPhotosLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetStoryPhotosQuery,
    GQL_GetStoryPhotosQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetStoryPhotosQuery,
    GQL_GetStoryPhotosQueryVariables
  >(GetStoryPhotosDocument, options)
}
// @ts-ignore
export function useGetStoryPhotosSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetStoryPhotosQuery,
    GQL_GetStoryPhotosQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetStoryPhotosQuery,
  GQL_GetStoryPhotosQueryVariables
>
export function useGetStoryPhotosSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetStoryPhotosQuery,
        GQL_GetStoryPhotosQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetStoryPhotosQuery | undefined,
  GQL_GetStoryPhotosQueryVariables
>
export function useGetStoryPhotosSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetStoryPhotosQuery,
        GQL_GetStoryPhotosQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetStoryPhotosQuery,
    GQL_GetStoryPhotosQueryVariables
  >(GetStoryPhotosDocument, options)
}
export type GetStoryPhotosQueryHookResult = ReturnType<
  typeof useGetStoryPhotosQuery
>
export type GetStoryPhotosLazyQueryHookResult = ReturnType<
  typeof useGetStoryPhotosLazyQuery
>
export type GetStoryPhotosSuspenseQueryHookResult = ReturnType<
  typeof useGetStoryPhotosSuspenseQuery
>
export type GetStoryPhotosQueryResult = Apollo.QueryResult<
  GQL_GetStoryPhotosQuery,
  GQL_GetStoryPhotosQueryVariables
>
export const GetListingAvailabilityAlertsDocument = gql`
  query getListingAvailabilityAlerts($listingId: ID!) {
    listing(id: $listingId) {
      id
      popular
      promotionalDiscounts {
        id
        name
        percentage
        startDate
        endDate
      }
      weekendAvailabilities {
        available
        startDate
        endDate
      }
    }
  }
`

/**
 * __useGetListingAvailabilityAlertsQuery__
 *
 * To run a query within a React component, call `useGetListingAvailabilityAlertsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListingAvailabilityAlertsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListingAvailabilityAlertsQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useGetListingAvailabilityAlertsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetListingAvailabilityAlertsQuery,
    GQL_GetListingAvailabilityAlertsQueryVariables
  > &
    (
      | {
          variables: GQL_GetListingAvailabilityAlertsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetListingAvailabilityAlertsQuery,
    GQL_GetListingAvailabilityAlertsQueryVariables
  >(GetListingAvailabilityAlertsDocument, options)
}
export function useGetListingAvailabilityAlertsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetListingAvailabilityAlertsQuery,
    GQL_GetListingAvailabilityAlertsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetListingAvailabilityAlertsQuery,
    GQL_GetListingAvailabilityAlertsQueryVariables
  >(GetListingAvailabilityAlertsDocument, options)
}
// @ts-ignore
export function useGetListingAvailabilityAlertsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetListingAvailabilityAlertsQuery,
    GQL_GetListingAvailabilityAlertsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetListingAvailabilityAlertsQuery,
  GQL_GetListingAvailabilityAlertsQueryVariables
>
export function useGetListingAvailabilityAlertsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetListingAvailabilityAlertsQuery,
        GQL_GetListingAvailabilityAlertsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetListingAvailabilityAlertsQuery | undefined,
  GQL_GetListingAvailabilityAlertsQueryVariables
>
export function useGetListingAvailabilityAlertsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetListingAvailabilityAlertsQuery,
        GQL_GetListingAvailabilityAlertsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetListingAvailabilityAlertsQuery,
    GQL_GetListingAvailabilityAlertsQueryVariables
  >(GetListingAvailabilityAlertsDocument, options)
}
export type GetListingAvailabilityAlertsQueryHookResult = ReturnType<
  typeof useGetListingAvailabilityAlertsQuery
>
export type GetListingAvailabilityAlertsLazyQueryHookResult = ReturnType<
  typeof useGetListingAvailabilityAlertsLazyQuery
>
export type GetListingAvailabilityAlertsSuspenseQueryHookResult = ReturnType<
  typeof useGetListingAvailabilityAlertsSuspenseQuery
>
export type GetListingAvailabilityAlertsQueryResult = Apollo.QueryResult<
  GQL_GetListingAvailabilityAlertsQuery,
  GQL_GetListingAvailabilityAlertsQueryVariables
>
export const GetCalendarDaysForBookingDocument = gql`
  query getCalendarDaysForBooking(
    $bookingId: ID!
    $startDate: ISO8601Date!
    $endDate: ISO8601Date!
  ) {
    booking(id: $bookingId) {
      id
      calendar(startDate: $startDate, endDate: $endDate) {
        ...CalendarParts
      }
    }
  }
  ${CalendarPartsFragmentDoc}
`

/**
 * __useGetCalendarDaysForBookingQuery__
 *
 * To run a query within a React component, call `useGetCalendarDaysForBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarDaysForBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarDaysForBookingQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetCalendarDaysForBookingQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetCalendarDaysForBookingQuery,
    GQL_GetCalendarDaysForBookingQueryVariables
  > &
    (
      | {
          variables: GQL_GetCalendarDaysForBookingQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetCalendarDaysForBookingQuery,
    GQL_GetCalendarDaysForBookingQueryVariables
  >(GetCalendarDaysForBookingDocument, options)
}
export function useGetCalendarDaysForBookingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetCalendarDaysForBookingQuery,
    GQL_GetCalendarDaysForBookingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetCalendarDaysForBookingQuery,
    GQL_GetCalendarDaysForBookingQueryVariables
  >(GetCalendarDaysForBookingDocument, options)
}
// @ts-ignore
export function useGetCalendarDaysForBookingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetCalendarDaysForBookingQuery,
    GQL_GetCalendarDaysForBookingQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetCalendarDaysForBookingQuery,
  GQL_GetCalendarDaysForBookingQueryVariables
>
export function useGetCalendarDaysForBookingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetCalendarDaysForBookingQuery,
        GQL_GetCalendarDaysForBookingQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetCalendarDaysForBookingQuery | undefined,
  GQL_GetCalendarDaysForBookingQueryVariables
>
export function useGetCalendarDaysForBookingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetCalendarDaysForBookingQuery,
        GQL_GetCalendarDaysForBookingQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetCalendarDaysForBookingQuery,
    GQL_GetCalendarDaysForBookingQueryVariables
  >(GetCalendarDaysForBookingDocument, options)
}
export type GetCalendarDaysForBookingQueryHookResult = ReturnType<
  typeof useGetCalendarDaysForBookingQuery
>
export type GetCalendarDaysForBookingLazyQueryHookResult = ReturnType<
  typeof useGetCalendarDaysForBookingLazyQuery
>
export type GetCalendarDaysForBookingSuspenseQueryHookResult = ReturnType<
  typeof useGetCalendarDaysForBookingSuspenseQuery
>
export type GetCalendarDaysForBookingQueryResult = Apollo.QueryResult<
  GQL_GetCalendarDaysForBookingQuery,
  GQL_GetCalendarDaysForBookingQueryVariables
>
export const GetCalendarDaysForListingDocument = gql`
  query getCalendarDaysForListing(
    $listingId: ID!
    $startDate: ISO8601Date!
    $endDate: ISO8601Date!
  ) {
    listing(id: $listingId) {
      id
      calendar(startDate: $startDate, endDate: $endDate) {
        ...CalendarParts
      }
    }
  }
  ${CalendarPartsFragmentDoc}
`

/**
 * __useGetCalendarDaysForListingQuery__
 *
 * To run a query within a React component, call `useGetCalendarDaysForListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarDaysForListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarDaysForListingQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetCalendarDaysForListingQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetCalendarDaysForListingQuery,
    GQL_GetCalendarDaysForListingQueryVariables
  > &
    (
      | {
          variables: GQL_GetCalendarDaysForListingQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetCalendarDaysForListingQuery,
    GQL_GetCalendarDaysForListingQueryVariables
  >(GetCalendarDaysForListingDocument, options)
}
export function useGetCalendarDaysForListingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetCalendarDaysForListingQuery,
    GQL_GetCalendarDaysForListingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetCalendarDaysForListingQuery,
    GQL_GetCalendarDaysForListingQueryVariables
  >(GetCalendarDaysForListingDocument, options)
}
// @ts-ignore
export function useGetCalendarDaysForListingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetCalendarDaysForListingQuery,
    GQL_GetCalendarDaysForListingQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetCalendarDaysForListingQuery,
  GQL_GetCalendarDaysForListingQueryVariables
>
export function useGetCalendarDaysForListingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetCalendarDaysForListingQuery,
        GQL_GetCalendarDaysForListingQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetCalendarDaysForListingQuery | undefined,
  GQL_GetCalendarDaysForListingQueryVariables
>
export function useGetCalendarDaysForListingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetCalendarDaysForListingQuery,
        GQL_GetCalendarDaysForListingQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetCalendarDaysForListingQuery,
    GQL_GetCalendarDaysForListingQueryVariables
  >(GetCalendarDaysForListingDocument, options)
}
export type GetCalendarDaysForListingQueryHookResult = ReturnType<
  typeof useGetCalendarDaysForListingQuery
>
export type GetCalendarDaysForListingLazyQueryHookResult = ReturnType<
  typeof useGetCalendarDaysForListingLazyQuery
>
export type GetCalendarDaysForListingSuspenseQueryHookResult = ReturnType<
  typeof useGetCalendarDaysForListingSuspenseQuery
>
export type GetCalendarDaysForListingQueryResult = Apollo.QueryResult<
  GQL_GetCalendarDaysForListingQuery,
  GQL_GetCalendarDaysForListingQueryVariables
>
export const GetUserCountryAndStripeKeyDocument = gql`
  query getUserCountryAndStripeKey {
    currentUser {
      id
      defaultCountry {
        id
        code
        name
        defaultCurrency
        stripePlatform {
          name
          publicKey
        }
      }
    }
  }
`

/**
 * __useGetUserCountryAndStripeKeyQuery__
 *
 * To run a query within a React component, call `useGetUserCountryAndStripeKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCountryAndStripeKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCountryAndStripeKeyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserCountryAndStripeKeyQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GQL_GetUserCountryAndStripeKeyQuery,
    GQL_GetUserCountryAndStripeKeyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetUserCountryAndStripeKeyQuery,
    GQL_GetUserCountryAndStripeKeyQueryVariables
  >(GetUserCountryAndStripeKeyDocument, options)
}
export function useGetUserCountryAndStripeKeyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetUserCountryAndStripeKeyQuery,
    GQL_GetUserCountryAndStripeKeyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetUserCountryAndStripeKeyQuery,
    GQL_GetUserCountryAndStripeKeyQueryVariables
  >(GetUserCountryAndStripeKeyDocument, options)
}
// @ts-ignore
export function useGetUserCountryAndStripeKeySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetUserCountryAndStripeKeyQuery,
    GQL_GetUserCountryAndStripeKeyQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetUserCountryAndStripeKeyQuery,
  GQL_GetUserCountryAndStripeKeyQueryVariables
>
export function useGetUserCountryAndStripeKeySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetUserCountryAndStripeKeyQuery,
        GQL_GetUserCountryAndStripeKeyQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetUserCountryAndStripeKeyQuery | undefined,
  GQL_GetUserCountryAndStripeKeyQueryVariables
>
export function useGetUserCountryAndStripeKeySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetUserCountryAndStripeKeyQuery,
        GQL_GetUserCountryAndStripeKeyQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetUserCountryAndStripeKeyQuery,
    GQL_GetUserCountryAndStripeKeyQueryVariables
  >(GetUserCountryAndStripeKeyDocument, options)
}
export type GetUserCountryAndStripeKeyQueryHookResult = ReturnType<
  typeof useGetUserCountryAndStripeKeyQuery
>
export type GetUserCountryAndStripeKeyLazyQueryHookResult = ReturnType<
  typeof useGetUserCountryAndStripeKeyLazyQuery
>
export type GetUserCountryAndStripeKeySuspenseQueryHookResult = ReturnType<
  typeof useGetUserCountryAndStripeKeySuspenseQuery
>
export type GetUserCountryAndStripeKeyQueryResult = Apollo.QueryResult<
  GQL_GetUserCountryAndStripeKeyQuery,
  GQL_GetUserCountryAndStripeKeyQueryVariables
>
export const GetCountriesDocument = gql`
  query getCountries {
    defaults {
      countries {
        id
        code
        name
        discoverable
      }
    }
  }
`

/**
 * __useGetCountriesQuery__
 *
 * To run a query within a React component, call `useGetCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountriesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GQL_GetCountriesQuery,
    GQL_GetCountriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GQL_GetCountriesQuery, GQL_GetCountriesQueryVariables>(
    GetCountriesDocument,
    options,
  )
}
export function useGetCountriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetCountriesQuery,
    GQL_GetCountriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetCountriesQuery,
    GQL_GetCountriesQueryVariables
  >(GetCountriesDocument, options)
}
// @ts-ignore
export function useGetCountriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetCountriesQuery,
    GQL_GetCountriesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetCountriesQuery,
  GQL_GetCountriesQueryVariables
>
export function useGetCountriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetCountriesQuery,
        GQL_GetCountriesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetCountriesQuery | undefined,
  GQL_GetCountriesQueryVariables
>
export function useGetCountriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetCountriesQuery,
        GQL_GetCountriesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetCountriesQuery,
    GQL_GetCountriesQueryVariables
  >(GetCountriesDocument, options)
}
export type GetCountriesQueryHookResult = ReturnType<
  typeof useGetCountriesQuery
>
export type GetCountriesLazyQueryHookResult = ReturnType<
  typeof useGetCountriesLazyQuery
>
export type GetCountriesSuspenseQueryHookResult = ReturnType<
  typeof useGetCountriesSuspenseQuery
>
export type GetCountriesQueryResult = Apollo.QueryResult<
  GQL_GetCountriesQuery,
  GQL_GetCountriesQueryVariables
>
export const GetCountryDocument = gql`
  query getCountry($code: Countries!) {
    country(code: $code) {
      id
      code
      name
      officialName
      defaultCurrency
    }
  }
`

/**
 * __useGetCountryQuery__
 *
 * To run a query within a React component, call `useGetCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountryQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetCountryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetCountryQuery,
    GQL_GetCountryQueryVariables
  > &
    (
      | { variables: GQL_GetCountryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GQL_GetCountryQuery, GQL_GetCountryQueryVariables>(
    GetCountryDocument,
    options,
  )
}
export function useGetCountryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetCountryQuery,
    GQL_GetCountryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GQL_GetCountryQuery, GQL_GetCountryQueryVariables>(
    GetCountryDocument,
    options,
  )
}
// @ts-ignore
export function useGetCountrySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetCountryQuery,
    GQL_GetCountryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetCountryQuery,
  GQL_GetCountryQueryVariables
>
export function useGetCountrySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetCountryQuery,
        GQL_GetCountryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetCountryQuery | undefined,
  GQL_GetCountryQueryVariables
>
export function useGetCountrySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetCountryQuery,
        GQL_GetCountryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetCountryQuery,
    GQL_GetCountryQueryVariables
  >(GetCountryDocument, options)
}
export type GetCountryQueryHookResult = ReturnType<typeof useGetCountryQuery>
export type GetCountryLazyQueryHookResult = ReturnType<
  typeof useGetCountryLazyQuery
>
export type GetCountrySuspenseQueryHookResult = ReturnType<
  typeof useGetCountrySuspenseQuery
>
export type GetCountryQueryResult = Apollo.QueryResult<
  GQL_GetCountryQuery,
  GQL_GetCountryQueryVariables
>
export const AdventuresReviewDocument = gql`
  query adventuresReview($bookingId: ID!) {
    booking(id: $bookingId) {
      id
      adventures {
        ...AdventureFragment
      }
      story {
        id
        title
        featuredListing {
          title
        }
        storyteller: user {
          firstName
        }
      }
      adventureReviews {
        id
        adventure {
          ...AdventureFragment
        }
        rating
        content
        fulfillingMomentIds
      }
    }
    fulfillingMoments {
      id
      slug
      name
    }
  }
  ${AdventureFragmentFragmentDoc}
`

/**
 * __useAdventuresReviewQuery__
 *
 * To run a query within a React component, call `useAdventuresReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdventuresReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdventuresReviewQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useAdventuresReviewQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_AdventuresReviewQuery,
    GQL_AdventuresReviewQueryVariables
  > &
    (
      | { variables: GQL_AdventuresReviewQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_AdventuresReviewQuery,
    GQL_AdventuresReviewQueryVariables
  >(AdventuresReviewDocument, options)
}
export function useAdventuresReviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_AdventuresReviewQuery,
    GQL_AdventuresReviewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_AdventuresReviewQuery,
    GQL_AdventuresReviewQueryVariables
  >(AdventuresReviewDocument, options)
}
// @ts-ignore
export function useAdventuresReviewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_AdventuresReviewQuery,
    GQL_AdventuresReviewQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_AdventuresReviewQuery,
  GQL_AdventuresReviewQueryVariables
>
export function useAdventuresReviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_AdventuresReviewQuery,
        GQL_AdventuresReviewQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_AdventuresReviewQuery | undefined,
  GQL_AdventuresReviewQueryVariables
>
export function useAdventuresReviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_AdventuresReviewQuery,
        GQL_AdventuresReviewQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_AdventuresReviewQuery,
    GQL_AdventuresReviewQueryVariables
  >(AdventuresReviewDocument, options)
}
export type AdventuresReviewQueryHookResult = ReturnType<
  typeof useAdventuresReviewQuery
>
export type AdventuresReviewLazyQueryHookResult = ReturnType<
  typeof useAdventuresReviewLazyQuery
>
export type AdventuresReviewSuspenseQueryHookResult = ReturnType<
  typeof useAdventuresReviewSuspenseQuery
>
export type AdventuresReviewQueryResult = Apollo.QueryResult<
  GQL_AdventuresReviewQuery,
  GQL_AdventuresReviewQueryVariables
>
export const CreateAdventureReviewDocument = gql`
  mutation createAdventureReview(
    $bookingId: ID!
    $adventureReviewInput: AdventureReviewInput!
  ) {
    createAdventureReview(
      bookingId: $bookingId
      adventureReviewInput: $adventureReviewInput
    ) {
      adventureReview {
        id
        rating
        content
        fulfillingMomentIds
      }
    }
  }
`
export type GQL_CreateAdventureReviewMutationFn = Apollo.MutationFunction<
  GQL_CreateAdventureReviewMutation,
  GQL_CreateAdventureReviewMutationVariables
>

/**
 * __useCreateAdventureReviewMutation__
 *
 * To run a mutation, you first call `useCreateAdventureReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdventureReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdventureReviewMutation, { data, loading, error }] = useCreateAdventureReviewMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      adventureReviewInput: // value for 'adventureReviewInput'
 *   },
 * });
 */
export function useCreateAdventureReviewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_CreateAdventureReviewMutation,
    GQL_CreateAdventureReviewMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_CreateAdventureReviewMutation,
    GQL_CreateAdventureReviewMutationVariables
  >(CreateAdventureReviewDocument, options)
}
export type CreateAdventureReviewMutationHookResult = ReturnType<
  typeof useCreateAdventureReviewMutation
>
export type CreateAdventureReviewMutationResult =
  Apollo.MutationResult<GQL_CreateAdventureReviewMutation>
export type CreateAdventureReviewMutationOptions = Apollo.BaseMutationOptions<
  GQL_CreateAdventureReviewMutation,
  GQL_CreateAdventureReviewMutationVariables
>
export const UpdateAdventureReviewDocument = gql`
  mutation updateAdventureReview(
    $adventureReviewId: ID!
    $adventureReviewInput: AdventureReviewInput!
  ) {
    updateAdventureReview(
      adventureReviewId: $adventureReviewId
      adventureReviewInput: $adventureReviewInput
    ) {
      adventureReview {
        id
        rating
        content
        fulfillingMomentIds
      }
    }
  }
`
export type GQL_UpdateAdventureReviewMutationFn = Apollo.MutationFunction<
  GQL_UpdateAdventureReviewMutation,
  GQL_UpdateAdventureReviewMutationVariables
>

/**
 * __useUpdateAdventureReviewMutation__
 *
 * To run a mutation, you first call `useUpdateAdventureReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdventureReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdventureReviewMutation, { data, loading, error }] = useUpdateAdventureReviewMutation({
 *   variables: {
 *      adventureReviewId: // value for 'adventureReviewId'
 *      adventureReviewInput: // value for 'adventureReviewInput'
 *   },
 * });
 */
export function useUpdateAdventureReviewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_UpdateAdventureReviewMutation,
    GQL_UpdateAdventureReviewMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_UpdateAdventureReviewMutation,
    GQL_UpdateAdventureReviewMutationVariables
  >(UpdateAdventureReviewDocument, options)
}
export type UpdateAdventureReviewMutationHookResult = ReturnType<
  typeof useUpdateAdventureReviewMutation
>
export type UpdateAdventureReviewMutationResult =
  Apollo.MutationResult<GQL_UpdateAdventureReviewMutation>
export type UpdateAdventureReviewMutationOptions = Apollo.BaseMutationOptions<
  GQL_UpdateAdventureReviewMutation,
  GQL_UpdateAdventureReviewMutationVariables
>
export const GetFulfillmentDataDocument = gql`
  query getFulfillmentData($bookingId: ID!) {
    booking(id: $bookingId) {
      id
      adventures {
        id
      }
    }
    fulfillingMoments {
      id
      slug
      name
    }
  }
`

/**
 * __useGetFulfillmentDataQuery__
 *
 * To run a query within a React component, call `useGetFulfillmentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFulfillmentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFulfillmentDataQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetFulfillmentDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetFulfillmentDataQuery,
    GQL_GetFulfillmentDataQueryVariables
  > &
    (
      | { variables: GQL_GetFulfillmentDataQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetFulfillmentDataQuery,
    GQL_GetFulfillmentDataQueryVariables
  >(GetFulfillmentDataDocument, options)
}
export function useGetFulfillmentDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetFulfillmentDataQuery,
    GQL_GetFulfillmentDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetFulfillmentDataQuery,
    GQL_GetFulfillmentDataQueryVariables
  >(GetFulfillmentDataDocument, options)
}
// @ts-ignore
export function useGetFulfillmentDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetFulfillmentDataQuery,
    GQL_GetFulfillmentDataQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetFulfillmentDataQuery,
  GQL_GetFulfillmentDataQueryVariables
>
export function useGetFulfillmentDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetFulfillmentDataQuery,
        GQL_GetFulfillmentDataQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetFulfillmentDataQuery | undefined,
  GQL_GetFulfillmentDataQueryVariables
>
export function useGetFulfillmentDataSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetFulfillmentDataQuery,
        GQL_GetFulfillmentDataQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetFulfillmentDataQuery,
    GQL_GetFulfillmentDataQueryVariables
  >(GetFulfillmentDataDocument, options)
}
export type GetFulfillmentDataQueryHookResult = ReturnType<
  typeof useGetFulfillmentDataQuery
>
export type GetFulfillmentDataLazyQueryHookResult = ReturnType<
  typeof useGetFulfillmentDataLazyQuery
>
export type GetFulfillmentDataSuspenseQueryHookResult = ReturnType<
  typeof useGetFulfillmentDataSuspenseQuery
>
export type GetFulfillmentDataQueryResult = Apollo.QueryResult<
  GQL_GetFulfillmentDataQuery,
  GQL_GetFulfillmentDataQueryVariables
>
export const BusinessLookupDocument = gql`
  query businessLookup($registrationNumber: String!, $country: Countries!) {
    businessLookup(registrationNumber: $registrationNumber, country: $country) {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressPostcode
      addressState
      entityName
      entityType
      gstRegistered
      registrationNumber
      taxId
      tradingName
    }
  }
`

/**
 * __useBusinessLookupQuery__
 *
 * To run a query within a React component, call `useBusinessLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessLookupQuery({
 *   variables: {
 *      registrationNumber: // value for 'registrationNumber'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useBusinessLookupQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_BusinessLookupQuery,
    GQL_BusinessLookupQueryVariables
  > &
    (
      | { variables: GQL_BusinessLookupQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_BusinessLookupQuery,
    GQL_BusinessLookupQueryVariables
  >(BusinessLookupDocument, options)
}
export function useBusinessLookupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_BusinessLookupQuery,
    GQL_BusinessLookupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_BusinessLookupQuery,
    GQL_BusinessLookupQueryVariables
  >(BusinessLookupDocument, options)
}
// @ts-ignore
export function useBusinessLookupSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_BusinessLookupQuery,
    GQL_BusinessLookupQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_BusinessLookupQuery,
  GQL_BusinessLookupQueryVariables
>
export function useBusinessLookupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_BusinessLookupQuery,
        GQL_BusinessLookupQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_BusinessLookupQuery | undefined,
  GQL_BusinessLookupQueryVariables
>
export function useBusinessLookupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_BusinessLookupQuery,
        GQL_BusinessLookupQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_BusinessLookupQuery,
    GQL_BusinessLookupQueryVariables
  >(BusinessLookupDocument, options)
}
export type BusinessLookupQueryHookResult = ReturnType<
  typeof useBusinessLookupQuery
>
export type BusinessLookupLazyQueryHookResult = ReturnType<
  typeof useBusinessLookupLazyQuery
>
export type BusinessLookupSuspenseQueryHookResult = ReturnType<
  typeof useBusinessLookupSuspenseQuery
>
export type BusinessLookupQueryResult = Apollo.QueryResult<
  GQL_BusinessLookupQuery,
  GQL_BusinessLookupQueryVariables
>
export const CreateBankAccountDocument = gql`
  mutation createBankAccount($stripeToken: String!, $listingId: ID) {
    createBankAccount(stripeToken: $stripeToken, listingId: $listingId) {
      bankAccount {
        ...BankAccountFragment
      }
    }
  }
  ${BankAccountFragmentFragmentDoc}
`
export type GQL_CreateBankAccountMutationFn = Apollo.MutationFunction<
  GQL_CreateBankAccountMutation,
  GQL_CreateBankAccountMutationVariables
>

/**
 * __useCreateBankAccountMutation__
 *
 * To run a mutation, you first call `useCreateBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBankAccountMutation, { data, loading, error }] = useCreateBankAccountMutation({
 *   variables: {
 *      stripeToken: // value for 'stripeToken'
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useCreateBankAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_CreateBankAccountMutation,
    GQL_CreateBankAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_CreateBankAccountMutation,
    GQL_CreateBankAccountMutationVariables
  >(CreateBankAccountDocument, options)
}
export type CreateBankAccountMutationHookResult = ReturnType<
  typeof useCreateBankAccountMutation
>
export type CreateBankAccountMutationResult =
  Apollo.MutationResult<GQL_CreateBankAccountMutation>
export type CreateBankAccountMutationOptions = Apollo.BaseMutationOptions<
  GQL_CreateBankAccountMutation,
  GQL_CreateBankAccountMutationVariables
>
export const CreateCreditCardDocument = gql`
  mutation createCreditCard($stripeToken: String!) {
    createCreditCard(stripeToken: $stripeToken) {
      creditCard {
        ...CreditCardFields
      }
    }
  }
  ${CreditCardFieldsFragmentDoc}
`
export type GQL_CreateCreditCardMutationFn = Apollo.MutationFunction<
  GQL_CreateCreditCardMutation,
  GQL_CreateCreditCardMutationVariables
>

/**
 * __useCreateCreditCardMutation__
 *
 * To run a mutation, you first call `useCreateCreditCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCreditCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCreditCardMutation, { data, loading, error }] = useCreateCreditCardMutation({
 *   variables: {
 *      stripeToken: // value for 'stripeToken'
 *   },
 * });
 */
export function useCreateCreditCardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_CreateCreditCardMutation,
    GQL_CreateCreditCardMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_CreateCreditCardMutation,
    GQL_CreateCreditCardMutationVariables
  >(CreateCreditCardDocument, options)
}
export type CreateCreditCardMutationHookResult = ReturnType<
  typeof useCreateCreditCardMutation
>
export type CreateCreditCardMutationResult =
  Apollo.MutationResult<GQL_CreateCreditCardMutation>
export type CreateCreditCardMutationOptions = Apollo.BaseMutationOptions<
  GQL_CreateCreditCardMutation,
  GQL_CreateCreditCardMutationVariables
>
export const DeleteAccountDocument = gql`
  mutation DeleteAccount {
    deleteAccount {
      user {
        id
      }
    }
  }
`
export type GQL_DeleteAccountMutationFn = Apollo.MutationFunction<
  GQL_DeleteAccountMutation,
  GQL_DeleteAccountMutationVariables
>

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_DeleteAccountMutation,
    GQL_DeleteAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_DeleteAccountMutation,
    GQL_DeleteAccountMutationVariables
  >(DeleteAccountDocument, options)
}
export type DeleteAccountMutationHookResult = ReturnType<
  typeof useDeleteAccountMutation
>
export type DeleteAccountMutationResult =
  Apollo.MutationResult<GQL_DeleteAccountMutation>
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<
  GQL_DeleteAccountMutation,
  GQL_DeleteAccountMutationVariables
>
export const DeleteCreditCardDocument = gql`
  mutation deleteCreditCard($creditCardId: ID!) {
    destroyCreditCard(creditCardId: $creditCardId) {
      creditCards {
        id
      }
    }
  }
`
export type GQL_DeleteCreditCardMutationFn = Apollo.MutationFunction<
  GQL_DeleteCreditCardMutation,
  GQL_DeleteCreditCardMutationVariables
>

/**
 * __useDeleteCreditCardMutation__
 *
 * To run a mutation, you first call `useDeleteCreditCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCreditCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCreditCardMutation, { data, loading, error }] = useDeleteCreditCardMutation({
 *   variables: {
 *      creditCardId: // value for 'creditCardId'
 *   },
 * });
 */
export function useDeleteCreditCardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_DeleteCreditCardMutation,
    GQL_DeleteCreditCardMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_DeleteCreditCardMutation,
    GQL_DeleteCreditCardMutationVariables
  >(DeleteCreditCardDocument, options)
}
export type DeleteCreditCardMutationHookResult = ReturnType<
  typeof useDeleteCreditCardMutation
>
export type DeleteCreditCardMutationResult =
  Apollo.MutationResult<GQL_DeleteCreditCardMutation>
export type DeleteCreditCardMutationOptions = Apollo.BaseMutationOptions<
  GQL_DeleteCreditCardMutation,
  GQL_DeleteCreditCardMutationVariables
>
export const DestroyBankAccountDocument = gql`
  mutation destroyBankAccount($bankAccountId: ID!) {
    destroyBankAccount(bankAccountId: $bankAccountId) {
      bankAccounts {
        id
      }
    }
  }
`
export type GQL_DestroyBankAccountMutationFn = Apollo.MutationFunction<
  GQL_DestroyBankAccountMutation,
  GQL_DestroyBankAccountMutationVariables
>

/**
 * __useDestroyBankAccountMutation__
 *
 * To run a mutation, you first call `useDestroyBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyBankAccountMutation, { data, loading, error }] = useDestroyBankAccountMutation({
 *   variables: {
 *      bankAccountId: // value for 'bankAccountId'
 *   },
 * });
 */
export function useDestroyBankAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_DestroyBankAccountMutation,
    GQL_DestroyBankAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_DestroyBankAccountMutation,
    GQL_DestroyBankAccountMutationVariables
  >(DestroyBankAccountDocument, options)
}
export type DestroyBankAccountMutationHookResult = ReturnType<
  typeof useDestroyBankAccountMutation
>
export type DestroyBankAccountMutationResult =
  Apollo.MutationResult<GQL_DestroyBankAccountMutation>
export type DestroyBankAccountMutationOptions = Apollo.BaseMutationOptions<
  GQL_DestroyBankAccountMutation,
  GQL_DestroyBankAccountMutationVariables
>
export const GetMyBankAccountsDocument = gql`
  query getMyBankAccounts {
    currentUser {
      id
      bankAccounts {
        ...BankAccountFragment
      }
    }
  }
  ${BankAccountFragmentFragmentDoc}
`

/**
 * __useGetMyBankAccountsQuery__
 *
 * To run a query within a React component, call `useGetMyBankAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyBankAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyBankAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyBankAccountsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GQL_GetMyBankAccountsQuery,
    GQL_GetMyBankAccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetMyBankAccountsQuery,
    GQL_GetMyBankAccountsQueryVariables
  >(GetMyBankAccountsDocument, options)
}
export function useGetMyBankAccountsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetMyBankAccountsQuery,
    GQL_GetMyBankAccountsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetMyBankAccountsQuery,
    GQL_GetMyBankAccountsQueryVariables
  >(GetMyBankAccountsDocument, options)
}
// @ts-ignore
export function useGetMyBankAccountsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetMyBankAccountsQuery,
    GQL_GetMyBankAccountsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetMyBankAccountsQuery,
  GQL_GetMyBankAccountsQueryVariables
>
export function useGetMyBankAccountsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetMyBankAccountsQuery,
        GQL_GetMyBankAccountsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetMyBankAccountsQuery | undefined,
  GQL_GetMyBankAccountsQueryVariables
>
export function useGetMyBankAccountsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetMyBankAccountsQuery,
        GQL_GetMyBankAccountsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetMyBankAccountsQuery,
    GQL_GetMyBankAccountsQueryVariables
  >(GetMyBankAccountsDocument, options)
}
export type GetMyBankAccountsQueryHookResult = ReturnType<
  typeof useGetMyBankAccountsQuery
>
export type GetMyBankAccountsLazyQueryHookResult = ReturnType<
  typeof useGetMyBankAccountsLazyQuery
>
export type GetMyBankAccountsSuspenseQueryHookResult = ReturnType<
  typeof useGetMyBankAccountsSuspenseQuery
>
export type GetMyBankAccountsQueryResult = Apollo.QueryResult<
  GQL_GetMyBankAccountsQuery,
  GQL_GetMyBankAccountsQueryVariables
>
export const SetDefaultBankAccountDocument = gql`
  mutation setDefaultBankAccount($bankAccountId: ID!) {
    setDefaultBankAccount(bankAccountId: $bankAccountId) {
      bankAccount {
        id
        default
      }
    }
  }
`
export type GQL_SetDefaultBankAccountMutationFn = Apollo.MutationFunction<
  GQL_SetDefaultBankAccountMutation,
  GQL_SetDefaultBankAccountMutationVariables
>

/**
 * __useSetDefaultBankAccountMutation__
 *
 * To run a mutation, you first call `useSetDefaultBankAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultBankAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultBankAccountMutation, { data, loading, error }] = useSetDefaultBankAccountMutation({
 *   variables: {
 *      bankAccountId: // value for 'bankAccountId'
 *   },
 * });
 */
export function useSetDefaultBankAccountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_SetDefaultBankAccountMutation,
    GQL_SetDefaultBankAccountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_SetDefaultBankAccountMutation,
    GQL_SetDefaultBankAccountMutationVariables
  >(SetDefaultBankAccountDocument, options)
}
export type SetDefaultBankAccountMutationHookResult = ReturnType<
  typeof useSetDefaultBankAccountMutation
>
export type SetDefaultBankAccountMutationResult =
  Apollo.MutationResult<GQL_SetDefaultBankAccountMutation>
export type SetDefaultBankAccountMutationOptions = Apollo.BaseMutationOptions<
  GQL_SetDefaultBankAccountMutation,
  GQL_SetDefaultBankAccountMutationVariables
>
export const SetPreferredCreditCardDocument = gql`
  mutation setPreferredCreditCard($creditCardId: ID!) {
    setPreferredCreditCard(creditCardId: $creditCardId) {
      creditCard {
        id
        default
      }
    }
  }
`
export type GQL_SetPreferredCreditCardMutationFn = Apollo.MutationFunction<
  GQL_SetPreferredCreditCardMutation,
  GQL_SetPreferredCreditCardMutationVariables
>

/**
 * __useSetPreferredCreditCardMutation__
 *
 * To run a mutation, you first call `useSetPreferredCreditCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPreferredCreditCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPreferredCreditCardMutation, { data, loading, error }] = useSetPreferredCreditCardMutation({
 *   variables: {
 *      creditCardId: // value for 'creditCardId'
 *   },
 * });
 */
export function useSetPreferredCreditCardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_SetPreferredCreditCardMutation,
    GQL_SetPreferredCreditCardMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_SetPreferredCreditCardMutation,
    GQL_SetPreferredCreditCardMutationVariables
  >(SetPreferredCreditCardDocument, options)
}
export type SetPreferredCreditCardMutationHookResult = ReturnType<
  typeof useSetPreferredCreditCardMutation
>
export type SetPreferredCreditCardMutationResult =
  Apollo.MutationResult<GQL_SetPreferredCreditCardMutation>
export type SetPreferredCreditCardMutationOptions = Apollo.BaseMutationOptions<
  GQL_SetPreferredCreditCardMutation,
  GQL_SetPreferredCreditCardMutationVariables
>
export const UpdatePasswordDocument = gql`
  mutation updatePassword(
    $currentPassword: String!
    $newPassword: String!
    $confirmPassword: String!
  ) {
    updatePassword(
      currentPassword: $currentPassword
      newPassword: $newPassword
      confirmPassword: $confirmPassword
    ) {
      user {
        id
      }
    }
  }
`
export type GQL_UpdatePasswordMutationFn = Apollo.MutationFunction<
  GQL_UpdatePasswordMutation,
  GQL_UpdatePasswordMutationVariables
>

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      currentPassword: // value for 'currentPassword'
 *      newPassword: // value for 'newPassword'
 *      confirmPassword: // value for 'confirmPassword'
 *   },
 * });
 */
export function useUpdatePasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_UpdatePasswordMutation,
    GQL_UpdatePasswordMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_UpdatePasswordMutation,
    GQL_UpdatePasswordMutationVariables
  >(UpdatePasswordDocument, options)
}
export type UpdatePasswordMutationHookResult = ReturnType<
  typeof useUpdatePasswordMutation
>
export type UpdatePasswordMutationResult =
  Apollo.MutationResult<GQL_UpdatePasswordMutation>
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<
  GQL_UpdatePasswordMutation,
  GQL_UpdatePasswordMutationVariables
>
export const UserCreditCardsDocument = gql`
  query userCreditCards {
    currentUser {
      id
      creditCards {
        ...CreditCardFields
      }
    }
  }
  ${CreditCardFieldsFragmentDoc}
`

/**
 * __useUserCreditCardsQuery__
 *
 * To run a query within a React component, call `useUserCreditCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCreditCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCreditCardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserCreditCardsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GQL_UserCreditCardsQuery,
    GQL_UserCreditCardsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_UserCreditCardsQuery,
    GQL_UserCreditCardsQueryVariables
  >(UserCreditCardsDocument, options)
}
export function useUserCreditCardsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_UserCreditCardsQuery,
    GQL_UserCreditCardsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_UserCreditCardsQuery,
    GQL_UserCreditCardsQueryVariables
  >(UserCreditCardsDocument, options)
}
// @ts-ignore
export function useUserCreditCardsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_UserCreditCardsQuery,
    GQL_UserCreditCardsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_UserCreditCardsQuery,
  GQL_UserCreditCardsQueryVariables
>
export function useUserCreditCardsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_UserCreditCardsQuery,
        GQL_UserCreditCardsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_UserCreditCardsQuery | undefined,
  GQL_UserCreditCardsQueryVariables
>
export function useUserCreditCardsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_UserCreditCardsQuery,
        GQL_UserCreditCardsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_UserCreditCardsQuery,
    GQL_UserCreditCardsQueryVariables
  >(UserCreditCardsDocument, options)
}
export type UserCreditCardsQueryHookResult = ReturnType<
  typeof useUserCreditCardsQuery
>
export type UserCreditCardsLazyQueryHookResult = ReturnType<
  typeof useUserCreditCardsLazyQuery
>
export type UserCreditCardsSuspenseQueryHookResult = ReturnType<
  typeof useUserCreditCardsSuspenseQuery
>
export type UserCreditCardsQueryResult = Apollo.QueryResult<
  GQL_UserCreditCardsQuery,
  GQL_UserCreditCardsQueryVariables
>
export const AcceptAssignmentDocument = gql`
  mutation acceptAssignment(
    $id: ID!
    $assignmentInput: AcceptAssignmentInput!
  ) {
    acceptAssignment(assignmentId: $id, assignmentInput: $assignmentInput) {
      assignment {
        ...Assignment
        ...AssignmentBookingField
        ...AssignmentListingsField
      }
    }
  }
  ${AssignmentFragmentDoc}
  ${AssignmentBookingFieldFragmentDoc}
  ${AssignmentListingsFieldFragmentDoc}
`
export type GQL_AcceptAssignmentMutationFn = Apollo.MutationFunction<
  GQL_AcceptAssignmentMutation,
  GQL_AcceptAssignmentMutationVariables
>

/**
 * __useAcceptAssignmentMutation__
 *
 * To run a mutation, you first call `useAcceptAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptAssignmentMutation, { data, loading, error }] = useAcceptAssignmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      assignmentInput: // value for 'assignmentInput'
 *   },
 * });
 */
export function useAcceptAssignmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_AcceptAssignmentMutation,
    GQL_AcceptAssignmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_AcceptAssignmentMutation,
    GQL_AcceptAssignmentMutationVariables
  >(AcceptAssignmentDocument, options)
}
export type AcceptAssignmentMutationHookResult = ReturnType<
  typeof useAcceptAssignmentMutation
>
export type AcceptAssignmentMutationResult =
  Apollo.MutationResult<GQL_AcceptAssignmentMutation>
export type AcceptAssignmentMutationOptions = Apollo.BaseMutationOptions<
  GQL_AcceptAssignmentMutation,
  GQL_AcceptAssignmentMutationVariables
>
export const DeclineAssignmentDocument = gql`
  mutation declineAssignment($id: ID!, $reason: String, $explanation: String) {
    declineAssignment(
      assignmentId: $id
      reason: $reason
      explanation: $explanation
    ) {
      assignment {
        ...Assignment
      }
    }
  }
  ${AssignmentFragmentDoc}
`
export type GQL_DeclineAssignmentMutationFn = Apollo.MutationFunction<
  GQL_DeclineAssignmentMutation,
  GQL_DeclineAssignmentMutationVariables
>

/**
 * __useDeclineAssignmentMutation__
 *
 * To run a mutation, you first call `useDeclineAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineAssignmentMutation, { data, loading, error }] = useDeclineAssignmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reason: // value for 'reason'
 *      explanation: // value for 'explanation'
 *   },
 * });
 */
export function useDeclineAssignmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_DeclineAssignmentMutation,
    GQL_DeclineAssignmentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_DeclineAssignmentMutation,
    GQL_DeclineAssignmentMutationVariables
  >(DeclineAssignmentDocument, options)
}
export type DeclineAssignmentMutationHookResult = ReturnType<
  typeof useDeclineAssignmentMutation
>
export type DeclineAssignmentMutationResult =
  Apollo.MutationResult<GQL_DeclineAssignmentMutation>
export type DeclineAssignmentMutationOptions = Apollo.BaseMutationOptions<
  GQL_DeclineAssignmentMutation,
  GQL_DeclineAssignmentMutationVariables
>
export const GetMyAssignmentsDocument = gql`
  query getMyAssignments {
    currentUser {
      id
      assignments {
        ...Assignment
        ...AssignmentBookingField
        ...AssignmentListingsField
      }
    }
  }
  ${AssignmentFragmentDoc}
  ${AssignmentBookingFieldFragmentDoc}
  ${AssignmentListingsFieldFragmentDoc}
`

/**
 * __useGetMyAssignmentsQuery__
 *
 * To run a query within a React component, call `useGetMyAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyAssignmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyAssignmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GQL_GetMyAssignmentsQuery,
    GQL_GetMyAssignmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetMyAssignmentsQuery,
    GQL_GetMyAssignmentsQueryVariables
  >(GetMyAssignmentsDocument, options)
}
export function useGetMyAssignmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetMyAssignmentsQuery,
    GQL_GetMyAssignmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetMyAssignmentsQuery,
    GQL_GetMyAssignmentsQueryVariables
  >(GetMyAssignmentsDocument, options)
}
// @ts-ignore
export function useGetMyAssignmentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetMyAssignmentsQuery,
    GQL_GetMyAssignmentsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetMyAssignmentsQuery,
  GQL_GetMyAssignmentsQueryVariables
>
export function useGetMyAssignmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetMyAssignmentsQuery,
        GQL_GetMyAssignmentsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetMyAssignmentsQuery | undefined,
  GQL_GetMyAssignmentsQueryVariables
>
export function useGetMyAssignmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetMyAssignmentsQuery,
        GQL_GetMyAssignmentsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetMyAssignmentsQuery,
    GQL_GetMyAssignmentsQueryVariables
  >(GetMyAssignmentsDocument, options)
}
export type GetMyAssignmentsQueryHookResult = ReturnType<
  typeof useGetMyAssignmentsQuery
>
export type GetMyAssignmentsLazyQueryHookResult = ReturnType<
  typeof useGetMyAssignmentsLazyQuery
>
export type GetMyAssignmentsSuspenseQueryHookResult = ReturnType<
  typeof useGetMyAssignmentsSuspenseQuery
>
export type GetMyAssignmentsQueryResult = Apollo.QueryResult<
  GQL_GetMyAssignmentsQuery,
  GQL_GetMyAssignmentsQueryVariables
>
export const GuestListDocument = gql`
  query guestList($bookingId: ID!) {
    booking(id: $bookingId) {
      id
      totalGuests
      guests {
        firstName
        lastName
        phoneNumber
        postcode
      }
    }
  }
`

/**
 * __useGuestListQuery__
 *
 * To run a query within a React component, call `useGuestListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestListQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGuestListQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GuestListQuery,
    GQL_GuestListQueryVariables
  > &
    (
      | { variables: GQL_GuestListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GQL_GuestListQuery, GQL_GuestListQueryVariables>(
    GuestListDocument,
    options,
  )
}
export function useGuestListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GuestListQuery,
    GQL_GuestListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GQL_GuestListQuery, GQL_GuestListQueryVariables>(
    GuestListDocument,
    options,
  )
}
// @ts-ignore
export function useGuestListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GuestListQuery,
    GQL_GuestListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GuestListQuery,
  GQL_GuestListQueryVariables
>
export function useGuestListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GuestListQuery,
        GQL_GuestListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GuestListQuery | undefined,
  GQL_GuestListQueryVariables
>
export function useGuestListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GuestListQuery,
        GQL_GuestListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GuestListQuery,
    GQL_GuestListQueryVariables
  >(GuestListDocument, options)
}
export type GuestListQueryHookResult = ReturnType<typeof useGuestListQuery>
export type GuestListLazyQueryHookResult = ReturnType<
  typeof useGuestListLazyQuery
>
export type GuestListSuspenseQueryHookResult = ReturnType<
  typeof useGuestListSuspenseQuery
>
export type GuestListQueryResult = Apollo.QueryResult<
  GQL_GuestListQuery,
  GQL_GuestListQueryVariables
>
export const HpcFailedDocument = gql`
  query hpcFailed($bookingId: ID!) {
    booking(id: $bookingId) {
      id
      listing {
        id
        title
      }
      guests {
        hpcStatus
      }
      conversation {
        id
      }
    }
  }
`

/**
 * __useHpcFailedQuery__
 *
 * To run a query within a React component, call `useHpcFailedQuery` and pass it any options that fit your needs.
 * When your component renders, `useHpcFailedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHpcFailedQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useHpcFailedQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_HpcFailedQuery,
    GQL_HpcFailedQueryVariables
  > &
    (
      | { variables: GQL_HpcFailedQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GQL_HpcFailedQuery, GQL_HpcFailedQueryVariables>(
    HpcFailedDocument,
    options,
  )
}
export function useHpcFailedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_HpcFailedQuery,
    GQL_HpcFailedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GQL_HpcFailedQuery, GQL_HpcFailedQueryVariables>(
    HpcFailedDocument,
    options,
  )
}
// @ts-ignore
export function useHpcFailedSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_HpcFailedQuery,
    GQL_HpcFailedQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_HpcFailedQuery,
  GQL_HpcFailedQueryVariables
>
export function useHpcFailedSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_HpcFailedQuery,
        GQL_HpcFailedQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_HpcFailedQuery | undefined,
  GQL_HpcFailedQueryVariables
>
export function useHpcFailedSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_HpcFailedQuery,
        GQL_HpcFailedQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_HpcFailedQuery,
    GQL_HpcFailedQueryVariables
  >(HpcFailedDocument, options)
}
export type HpcFailedQueryHookResult = ReturnType<typeof useHpcFailedQuery>
export type HpcFailedLazyQueryHookResult = ReturnType<
  typeof useHpcFailedLazyQuery
>
export type HpcFailedSuspenseQueryHookResult = ReturnType<
  typeof useHpcFailedSuspenseQuery
>
export type HpcFailedQueryResult = Apollo.QueryResult<
  GQL_HpcFailedQuery,
  GQL_HpcFailedQueryVariables
>
export const UpdateGuestListDocument = gql`
  mutation updateGuestList($bookingId: ID!, $guestsInputs: [GuestInput!]!) {
    updateGuestList(bookingId: $bookingId, guestInputs: $guestsInputs) {
      booking {
        id
        totalGuests
        guests {
          firstName
          lastName
          phoneNumber
          postcode
        }
        hpcStatus
      }
    }
  }
`
export type GQL_UpdateGuestListMutationFn = Apollo.MutationFunction<
  GQL_UpdateGuestListMutation,
  GQL_UpdateGuestListMutationVariables
>

/**
 * __useUpdateGuestListMutation__
 *
 * To run a mutation, you first call `useUpdateGuestListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGuestListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGuestListMutation, { data, loading, error }] = useUpdateGuestListMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      guestsInputs: // value for 'guestsInputs'
 *   },
 * });
 */
export function useUpdateGuestListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_UpdateGuestListMutation,
    GQL_UpdateGuestListMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_UpdateGuestListMutation,
    GQL_UpdateGuestListMutationVariables
  >(UpdateGuestListDocument, options)
}
export type UpdateGuestListMutationHookResult = ReturnType<
  typeof useUpdateGuestListMutation
>
export type UpdateGuestListMutationResult =
  Apollo.MutationResult<GQL_UpdateGuestListMutation>
export type UpdateGuestListMutationOptions = Apollo.BaseMutationOptions<
  GQL_UpdateGuestListMutation,
  GQL_UpdateGuestListMutationVariables
>
export const CopyBookingAdventuresDocument = gql`
  mutation copyBookingAdventures(
    $bookingId: ID!
    $bucketListId: ID!
    $source: String
  ) {
    copyBookingAdventures(
      bookingId: $bookingId
      bucketListId: $bucketListId
      source: $source
    ) {
      adventures {
        id
      }
    }
  }
`
export type GQL_CopyBookingAdventuresMutationFn = Apollo.MutationFunction<
  GQL_CopyBookingAdventuresMutation,
  GQL_CopyBookingAdventuresMutationVariables
>

/**
 * __useCopyBookingAdventuresMutation__
 *
 * To run a mutation, you first call `useCopyBookingAdventuresMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyBookingAdventuresMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyBookingAdventuresMutation, { data, loading, error }] = useCopyBookingAdventuresMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      bucketListId: // value for 'bucketListId'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useCopyBookingAdventuresMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_CopyBookingAdventuresMutation,
    GQL_CopyBookingAdventuresMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_CopyBookingAdventuresMutation,
    GQL_CopyBookingAdventuresMutationVariables
  >(CopyBookingAdventuresDocument, options)
}
export type CopyBookingAdventuresMutationHookResult = ReturnType<
  typeof useCopyBookingAdventuresMutation
>
export type CopyBookingAdventuresMutationResult =
  Apollo.MutationResult<GQL_CopyBookingAdventuresMutation>
export type CopyBookingAdventuresMutationOptions = Apollo.BaseMutationOptions<
  GQL_CopyBookingAdventuresMutation,
  GQL_CopyBookingAdventuresMutationVariables
>
export const UpdateBookingPromptedToAddAdventuresDocument = gql`
  mutation updateBookingPromptedToAddAdventures($bookingId: ID!) {
    updateBooking(
      bookingId: $bookingId
      bookingInput: { promptedToAddAdventures: true }
    ) {
      booking {
        id
        promptedToAddAdventures
      }
    }
  }
`
export type GQL_UpdateBookingPromptedToAddAdventuresMutationFn =
  Apollo.MutationFunction<
    GQL_UpdateBookingPromptedToAddAdventuresMutation,
    GQL_UpdateBookingPromptedToAddAdventuresMutationVariables
  >

/**
 * __useUpdateBookingPromptedToAddAdventuresMutation__
 *
 * To run a mutation, you first call `useUpdateBookingPromptedToAddAdventuresMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingPromptedToAddAdventuresMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingPromptedToAddAdventuresMutation, { data, loading, error }] = useUpdateBookingPromptedToAddAdventuresMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useUpdateBookingPromptedToAddAdventuresMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_UpdateBookingPromptedToAddAdventuresMutation,
    GQL_UpdateBookingPromptedToAddAdventuresMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_UpdateBookingPromptedToAddAdventuresMutation,
    GQL_UpdateBookingPromptedToAddAdventuresMutationVariables
  >(UpdateBookingPromptedToAddAdventuresDocument, options)
}
export type UpdateBookingPromptedToAddAdventuresMutationHookResult = ReturnType<
  typeof useUpdateBookingPromptedToAddAdventuresMutation
>
export type UpdateBookingPromptedToAddAdventuresMutationResult =
  Apollo.MutationResult<GQL_UpdateBookingPromptedToAddAdventuresMutation>
export type UpdateBookingPromptedToAddAdventuresMutationOptions =
  Apollo.BaseMutationOptions<
    GQL_UpdateBookingPromptedToAddAdventuresMutation,
    GQL_UpdateBookingPromptedToAddAdventuresMutationVariables
  >
export const AddAdventureToBookingDocument = gql`
  mutation addAdventureToBooking(
    $bookingId: ID!
    $adventureId: ID!
    $source: String
  ) {
    createBookingAdventure(
      bookingId: $bookingId
      adventureId: $adventureId
      source: $source
    ) {
      adventure {
        id
      }
    }
  }
`
export type GQL_AddAdventureToBookingMutationFn = Apollo.MutationFunction<
  GQL_AddAdventureToBookingMutation,
  GQL_AddAdventureToBookingMutationVariables
>

/**
 * __useAddAdventureToBookingMutation__
 *
 * To run a mutation, you first call `useAddAdventureToBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAdventureToBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAdventureToBookingMutation, { data, loading, error }] = useAddAdventureToBookingMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      adventureId: // value for 'adventureId'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useAddAdventureToBookingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_AddAdventureToBookingMutation,
    GQL_AddAdventureToBookingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_AddAdventureToBookingMutation,
    GQL_AddAdventureToBookingMutationVariables
  >(AddAdventureToBookingDocument, options)
}
export type AddAdventureToBookingMutationHookResult = ReturnType<
  typeof useAddAdventureToBookingMutation
>
export type AddAdventureToBookingMutationResult =
  Apollo.MutationResult<GQL_AddAdventureToBookingMutation>
export type AddAdventureToBookingMutationOptions = Apollo.BaseMutationOptions<
  GQL_AddAdventureToBookingMutation,
  GQL_AddAdventureToBookingMutationVariables
>
export const GetAdventureDocument = gql`
  query getAdventure($adventureId: ID!) {
    adventure(id: $adventureId) {
      id
      description
      locationType
      title
      reviewScore
      location {
        name
        lat
        lng
      }
      adventureType {
        id
        name
        slug
        category
      }
      ...AdventureCardFragment
    }
  }
  ${AdventureCardFragmentFragmentDoc}
`

/**
 * __useGetAdventureQuery__
 *
 * To run a query within a React component, call `useGetAdventureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdventureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdventureQuery({
 *   variables: {
 *      adventureId: // value for 'adventureId'
 *   },
 * });
 */
export function useGetAdventureQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetAdventureQuery,
    GQL_GetAdventureQueryVariables
  > &
    (
      | { variables: GQL_GetAdventureQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GQL_GetAdventureQuery, GQL_GetAdventureQueryVariables>(
    GetAdventureDocument,
    options,
  )
}
export function useGetAdventureLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetAdventureQuery,
    GQL_GetAdventureQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetAdventureQuery,
    GQL_GetAdventureQueryVariables
  >(GetAdventureDocument, options)
}
// @ts-ignore
export function useGetAdventureSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetAdventureQuery,
    GQL_GetAdventureQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetAdventureQuery,
  GQL_GetAdventureQueryVariables
>
export function useGetAdventureSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetAdventureQuery,
        GQL_GetAdventureQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetAdventureQuery | undefined,
  GQL_GetAdventureQueryVariables
>
export function useGetAdventureSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetAdventureQuery,
        GQL_GetAdventureQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetAdventureQuery,
    GQL_GetAdventureQueryVariables
  >(GetAdventureDocument, options)
}
export type GetAdventureQueryHookResult = ReturnType<
  typeof useGetAdventureQuery
>
export type GetAdventureLazyQueryHookResult = ReturnType<
  typeof useGetAdventureLazyQuery
>
export type GetAdventureSuspenseQueryHookResult = ReturnType<
  typeof useGetAdventureSuspenseQuery
>
export type GetAdventureQueryResult = Apollo.QueryResult<
  GQL_GetAdventureQuery,
  GQL_GetAdventureQueryVariables
>
export const GetBookingAdventuresDocument = gql`
  query getBookingAdventures($bookingId: ID!) {
    booking(id: $bookingId) {
      id
      adventures {
        id
      }
    }
  }
`

/**
 * __useGetBookingAdventuresQuery__
 *
 * To run a query within a React component, call `useGetBookingAdventuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingAdventuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingAdventuresQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetBookingAdventuresQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetBookingAdventuresQuery,
    GQL_GetBookingAdventuresQueryVariables
  > &
    (
      | { variables: GQL_GetBookingAdventuresQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetBookingAdventuresQuery,
    GQL_GetBookingAdventuresQueryVariables
  >(GetBookingAdventuresDocument, options)
}
export function useGetBookingAdventuresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetBookingAdventuresQuery,
    GQL_GetBookingAdventuresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetBookingAdventuresQuery,
    GQL_GetBookingAdventuresQueryVariables
  >(GetBookingAdventuresDocument, options)
}
// @ts-ignore
export function useGetBookingAdventuresSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetBookingAdventuresQuery,
    GQL_GetBookingAdventuresQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetBookingAdventuresQuery,
  GQL_GetBookingAdventuresQueryVariables
>
export function useGetBookingAdventuresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetBookingAdventuresQuery,
        GQL_GetBookingAdventuresQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetBookingAdventuresQuery | undefined,
  GQL_GetBookingAdventuresQueryVariables
>
export function useGetBookingAdventuresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetBookingAdventuresQuery,
        GQL_GetBookingAdventuresQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetBookingAdventuresQuery,
    GQL_GetBookingAdventuresQueryVariables
  >(GetBookingAdventuresDocument, options)
}
export type GetBookingAdventuresQueryHookResult = ReturnType<
  typeof useGetBookingAdventuresQuery
>
export type GetBookingAdventuresLazyQueryHookResult = ReturnType<
  typeof useGetBookingAdventuresLazyQuery
>
export type GetBookingAdventuresSuspenseQueryHookResult = ReturnType<
  typeof useGetBookingAdventuresSuspenseQuery
>
export type GetBookingAdventuresQueryResult = Apollo.QueryResult<
  GQL_GetBookingAdventuresQuery,
  GQL_GetBookingAdventuresQueryVariables
>
export const GetBookingAdventuresIndexDocument = gql`
  query getBookingAdventuresIndex {
    currentUser {
      id
      bookingAdventuresIndex
    }
  }
`

/**
 * __useGetBookingAdventuresIndexQuery__
 *
 * To run a query within a React component, call `useGetBookingAdventuresIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingAdventuresIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingAdventuresIndexQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBookingAdventuresIndexQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GQL_GetBookingAdventuresIndexQuery,
    GQL_GetBookingAdventuresIndexQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetBookingAdventuresIndexQuery,
    GQL_GetBookingAdventuresIndexQueryVariables
  >(GetBookingAdventuresIndexDocument, options)
}
export function useGetBookingAdventuresIndexLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetBookingAdventuresIndexQuery,
    GQL_GetBookingAdventuresIndexQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetBookingAdventuresIndexQuery,
    GQL_GetBookingAdventuresIndexQueryVariables
  >(GetBookingAdventuresIndexDocument, options)
}
// @ts-ignore
export function useGetBookingAdventuresIndexSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetBookingAdventuresIndexQuery,
    GQL_GetBookingAdventuresIndexQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetBookingAdventuresIndexQuery,
  GQL_GetBookingAdventuresIndexQueryVariables
>
export function useGetBookingAdventuresIndexSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetBookingAdventuresIndexQuery,
        GQL_GetBookingAdventuresIndexQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetBookingAdventuresIndexQuery | undefined,
  GQL_GetBookingAdventuresIndexQueryVariables
>
export function useGetBookingAdventuresIndexSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetBookingAdventuresIndexQuery,
        GQL_GetBookingAdventuresIndexQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetBookingAdventuresIndexQuery,
    GQL_GetBookingAdventuresIndexQueryVariables
  >(GetBookingAdventuresIndexDocument, options)
}
export type GetBookingAdventuresIndexQueryHookResult = ReturnType<
  typeof useGetBookingAdventuresIndexQuery
>
export type GetBookingAdventuresIndexLazyQueryHookResult = ReturnType<
  typeof useGetBookingAdventuresIndexLazyQuery
>
export type GetBookingAdventuresIndexSuspenseQueryHookResult = ReturnType<
  typeof useGetBookingAdventuresIndexSuspenseQuery
>
export type GetBookingAdventuresIndexQueryResult = Apollo.QueryResult<
  GQL_GetBookingAdventuresIndexQuery,
  GQL_GetBookingAdventuresIndexQueryVariables
>
export const GetBookingItineraryDocument = gql`
  query getBookingItinerary($bookingId: ID!) {
    booking(id: $bookingId) {
      id
      joinUrl
      role
      promptedToAddAdventures
      startDate
      travelCrew {
        id
        firstName
        avatar {
          original
          thumbLg
          thumbMd
        }
      }
      listing {
        id
        url
        coordinates
        subcategory {
          id
          slug
        }
        listingType {
          id
          slug
        }
        title
        city
        region {
          id
          name
        }
        location {
          name
          lat
          lng
        }
        state
        coordinates
        promoImage {
          medium
          large
        }
      }
      story {
        id
        promoImage {
          medium
          large
        }
        user {
          firstName
          avatar {
            original
            thumbLg
          }
        }
      }
      adventures {
        ... on StoryAdventure {
          ...AdventureCardFragment
        }
        ... on ListingAdventure {
          id
          adventureType {
            id
            slug
          }
          location {
            lat
            lng
          }
        }
      }
    }
  }
  ${AdventureCardFragmentFragmentDoc}
`

/**
 * __useGetBookingItineraryQuery__
 *
 * To run a query within a React component, call `useGetBookingItineraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingItineraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingItineraryQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetBookingItineraryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetBookingItineraryQuery,
    GQL_GetBookingItineraryQueryVariables
  > &
    (
      | { variables: GQL_GetBookingItineraryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetBookingItineraryQuery,
    GQL_GetBookingItineraryQueryVariables
  >(GetBookingItineraryDocument, options)
}
export function useGetBookingItineraryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetBookingItineraryQuery,
    GQL_GetBookingItineraryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetBookingItineraryQuery,
    GQL_GetBookingItineraryQueryVariables
  >(GetBookingItineraryDocument, options)
}
// @ts-ignore
export function useGetBookingItinerarySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetBookingItineraryQuery,
    GQL_GetBookingItineraryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetBookingItineraryQuery,
  GQL_GetBookingItineraryQueryVariables
>
export function useGetBookingItinerarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetBookingItineraryQuery,
        GQL_GetBookingItineraryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetBookingItineraryQuery | undefined,
  GQL_GetBookingItineraryQueryVariables
>
export function useGetBookingItinerarySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetBookingItineraryQuery,
        GQL_GetBookingItineraryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetBookingItineraryQuery,
    GQL_GetBookingItineraryQueryVariables
  >(GetBookingItineraryDocument, options)
}
export type GetBookingItineraryQueryHookResult = ReturnType<
  typeof useGetBookingItineraryQuery
>
export type GetBookingItineraryLazyQueryHookResult = ReturnType<
  typeof useGetBookingItineraryLazyQuery
>
export type GetBookingItinerarySuspenseQueryHookResult = ReturnType<
  typeof useGetBookingItinerarySuspenseQuery
>
export type GetBookingItineraryQueryResult = Apollo.QueryResult<
  GQL_GetBookingItineraryQuery,
  GQL_GetBookingItineraryQueryVariables
>
export const GetBookingListingDocument = gql`
  query getBookingListing($bookingId: ID!) {
    booking(id: $bookingId) {
      id
      listing {
        id
        url
        coordinates
        subcategory {
          id
          slug
        }
        listingType {
          id
          slug
        }
        title
        city
        region {
          id
          name
        }
        state
        coordinates
        promoImage {
          medium
          large
        }
      }
    }
  }
`

/**
 * __useGetBookingListingQuery__
 *
 * To run a query within a React component, call `useGetBookingListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingListingQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetBookingListingQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetBookingListingQuery,
    GQL_GetBookingListingQueryVariables
  > &
    (
      | { variables: GQL_GetBookingListingQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetBookingListingQuery,
    GQL_GetBookingListingQueryVariables
  >(GetBookingListingDocument, options)
}
export function useGetBookingListingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetBookingListingQuery,
    GQL_GetBookingListingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetBookingListingQuery,
    GQL_GetBookingListingQueryVariables
  >(GetBookingListingDocument, options)
}
// @ts-ignore
export function useGetBookingListingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetBookingListingQuery,
    GQL_GetBookingListingQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetBookingListingQuery,
  GQL_GetBookingListingQueryVariables
>
export function useGetBookingListingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetBookingListingQuery,
        GQL_GetBookingListingQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetBookingListingQuery | undefined,
  GQL_GetBookingListingQueryVariables
>
export function useGetBookingListingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetBookingListingQuery,
        GQL_GetBookingListingQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetBookingListingQuery,
    GQL_GetBookingListingQueryVariables
  >(GetBookingListingDocument, options)
}
export type GetBookingListingQueryHookResult = ReturnType<
  typeof useGetBookingListingQuery
>
export type GetBookingListingLazyQueryHookResult = ReturnType<
  typeof useGetBookingListingLazyQuery
>
export type GetBookingListingSuspenseQueryHookResult = ReturnType<
  typeof useGetBookingListingSuspenseQuery
>
export type GetBookingListingQueryResult = Apollo.QueryResult<
  GQL_GetBookingListingQuery,
  GQL_GetBookingListingQueryVariables
>
export const GetBookingNearbyAdventuresDocument = gql`
  query getBookingNearbyAdventures(
    $bookingId: ID!
    $pageSize: Int = 4
    $cursor: String
  ) {
    booking(id: $bookingId) {
      id
      listing {
        id
        country {
          id
          code
        }
        state
        nearbyAdventures(first: $pageSize, after: $cursor, sourceType: Story) {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              id
              ...AdventureCardFragment
            }
          }
        }
      }
    }
  }
  ${AdventureCardFragmentFragmentDoc}
`

/**
 * __useGetBookingNearbyAdventuresQuery__
 *
 * To run a query within a React component, call `useGetBookingNearbyAdventuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingNearbyAdventuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingNearbyAdventuresQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      pageSize: // value for 'pageSize'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetBookingNearbyAdventuresQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetBookingNearbyAdventuresQuery,
    GQL_GetBookingNearbyAdventuresQueryVariables
  > &
    (
      | {
          variables: GQL_GetBookingNearbyAdventuresQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetBookingNearbyAdventuresQuery,
    GQL_GetBookingNearbyAdventuresQueryVariables
  >(GetBookingNearbyAdventuresDocument, options)
}
export function useGetBookingNearbyAdventuresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetBookingNearbyAdventuresQuery,
    GQL_GetBookingNearbyAdventuresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetBookingNearbyAdventuresQuery,
    GQL_GetBookingNearbyAdventuresQueryVariables
  >(GetBookingNearbyAdventuresDocument, options)
}
// @ts-ignore
export function useGetBookingNearbyAdventuresSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetBookingNearbyAdventuresQuery,
    GQL_GetBookingNearbyAdventuresQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetBookingNearbyAdventuresQuery,
  GQL_GetBookingNearbyAdventuresQueryVariables
>
export function useGetBookingNearbyAdventuresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetBookingNearbyAdventuresQuery,
        GQL_GetBookingNearbyAdventuresQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetBookingNearbyAdventuresQuery | undefined,
  GQL_GetBookingNearbyAdventuresQueryVariables
>
export function useGetBookingNearbyAdventuresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetBookingNearbyAdventuresQuery,
        GQL_GetBookingNearbyAdventuresQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetBookingNearbyAdventuresQuery,
    GQL_GetBookingNearbyAdventuresQueryVariables
  >(GetBookingNearbyAdventuresDocument, options)
}
export type GetBookingNearbyAdventuresQueryHookResult = ReturnType<
  typeof useGetBookingNearbyAdventuresQuery
>
export type GetBookingNearbyAdventuresLazyQueryHookResult = ReturnType<
  typeof useGetBookingNearbyAdventuresLazyQuery
>
export type GetBookingNearbyAdventuresSuspenseQueryHookResult = ReturnType<
  typeof useGetBookingNearbyAdventuresSuspenseQuery
>
export type GetBookingNearbyAdventuresQueryResult = Apollo.QueryResult<
  GQL_GetBookingNearbyAdventuresQuery,
  GQL_GetBookingNearbyAdventuresQueryVariables
>
export const GetBookingSuggestedAdventuresDocument = gql`
  query getBookingSuggestedAdventures(
    $bookingId: ID!
    $pageSize: Int = 4
    $cursor: String
  ) {
    booking(id: $bookingId) {
      id
      suggestedAdventures(first: $pageSize, after: $cursor) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            ...AdventureCardFragment
          }
        }
      }
    }
  }
  ${AdventureCardFragmentFragmentDoc}
`

/**
 * __useGetBookingSuggestedAdventuresQuery__
 *
 * To run a query within a React component, call `useGetBookingSuggestedAdventuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingSuggestedAdventuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingSuggestedAdventuresQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      pageSize: // value for 'pageSize'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetBookingSuggestedAdventuresQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetBookingSuggestedAdventuresQuery,
    GQL_GetBookingSuggestedAdventuresQueryVariables
  > &
    (
      | {
          variables: GQL_GetBookingSuggestedAdventuresQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetBookingSuggestedAdventuresQuery,
    GQL_GetBookingSuggestedAdventuresQueryVariables
  >(GetBookingSuggestedAdventuresDocument, options)
}
export function useGetBookingSuggestedAdventuresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetBookingSuggestedAdventuresQuery,
    GQL_GetBookingSuggestedAdventuresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetBookingSuggestedAdventuresQuery,
    GQL_GetBookingSuggestedAdventuresQueryVariables
  >(GetBookingSuggestedAdventuresDocument, options)
}
// @ts-ignore
export function useGetBookingSuggestedAdventuresSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetBookingSuggestedAdventuresQuery,
    GQL_GetBookingSuggestedAdventuresQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetBookingSuggestedAdventuresQuery,
  GQL_GetBookingSuggestedAdventuresQueryVariables
>
export function useGetBookingSuggestedAdventuresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetBookingSuggestedAdventuresQuery,
        GQL_GetBookingSuggestedAdventuresQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetBookingSuggestedAdventuresQuery | undefined,
  GQL_GetBookingSuggestedAdventuresQueryVariables
>
export function useGetBookingSuggestedAdventuresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetBookingSuggestedAdventuresQuery,
        GQL_GetBookingSuggestedAdventuresQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetBookingSuggestedAdventuresQuery,
    GQL_GetBookingSuggestedAdventuresQueryVariables
  >(GetBookingSuggestedAdventuresDocument, options)
}
export type GetBookingSuggestedAdventuresQueryHookResult = ReturnType<
  typeof useGetBookingSuggestedAdventuresQuery
>
export type GetBookingSuggestedAdventuresLazyQueryHookResult = ReturnType<
  typeof useGetBookingSuggestedAdventuresLazyQuery
>
export type GetBookingSuggestedAdventuresSuspenseQueryHookResult = ReturnType<
  typeof useGetBookingSuggestedAdventuresSuspenseQuery
>
export type GetBookingSuggestedAdventuresQueryResult = Apollo.QueryResult<
  GQL_GetBookingSuggestedAdventuresQuery,
  GQL_GetBookingSuggestedAdventuresQueryVariables
>
export const GetMapNearbyAdventuresDocument = gql`
  query getMapNearbyAdventures($bookingId: ID!) {
    booking(id: $bookingId) {
      id
      listing {
        id
        coordinates
        subcategory {
          id
          slug
        }
        listingType {
          id
          slug
        }
        ...ListingCardFragment
        allNearbyAdventures(sourceType: Story) {
          id
          adventureType {
            id
            slug
          }
          location {
            lat
            lng
          }
        }
      }
    }
  }
  ${ListingCardFragmentFragmentDoc}
`

/**
 * __useGetMapNearbyAdventuresQuery__
 *
 * To run a query within a React component, call `useGetMapNearbyAdventuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMapNearbyAdventuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMapNearbyAdventuresQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useGetMapNearbyAdventuresQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetMapNearbyAdventuresQuery,
    GQL_GetMapNearbyAdventuresQueryVariables
  > &
    (
      | { variables: GQL_GetMapNearbyAdventuresQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetMapNearbyAdventuresQuery,
    GQL_GetMapNearbyAdventuresQueryVariables
  >(GetMapNearbyAdventuresDocument, options)
}
export function useGetMapNearbyAdventuresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetMapNearbyAdventuresQuery,
    GQL_GetMapNearbyAdventuresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetMapNearbyAdventuresQuery,
    GQL_GetMapNearbyAdventuresQueryVariables
  >(GetMapNearbyAdventuresDocument, options)
}
// @ts-ignore
export function useGetMapNearbyAdventuresSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetMapNearbyAdventuresQuery,
    GQL_GetMapNearbyAdventuresQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetMapNearbyAdventuresQuery,
  GQL_GetMapNearbyAdventuresQueryVariables
>
export function useGetMapNearbyAdventuresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetMapNearbyAdventuresQuery,
        GQL_GetMapNearbyAdventuresQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetMapNearbyAdventuresQuery | undefined,
  GQL_GetMapNearbyAdventuresQueryVariables
>
export function useGetMapNearbyAdventuresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetMapNearbyAdventuresQuery,
        GQL_GetMapNearbyAdventuresQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetMapNearbyAdventuresQuery,
    GQL_GetMapNearbyAdventuresQueryVariables
  >(GetMapNearbyAdventuresDocument, options)
}
export type GetMapNearbyAdventuresQueryHookResult = ReturnType<
  typeof useGetMapNearbyAdventuresQuery
>
export type GetMapNearbyAdventuresLazyQueryHookResult = ReturnType<
  typeof useGetMapNearbyAdventuresLazyQuery
>
export type GetMapNearbyAdventuresSuspenseQueryHookResult = ReturnType<
  typeof useGetMapNearbyAdventuresSuspenseQuery
>
export type GetMapNearbyAdventuresQueryResult = Apollo.QueryResult<
  GQL_GetMapNearbyAdventuresQuery,
  GQL_GetMapNearbyAdventuresQueryVariables
>
export const RemoveAdventureFromBookingDocument = gql`
  mutation removeAdventureFromBooking($bookingId: ID!, $adventureId: ID!) {
    destroyBookingAdventure(bookingId: $bookingId, adventureId: $adventureId) {
      adventures {
        id
      }
    }
  }
`
export type GQL_RemoveAdventureFromBookingMutationFn = Apollo.MutationFunction<
  GQL_RemoveAdventureFromBookingMutation,
  GQL_RemoveAdventureFromBookingMutationVariables
>

/**
 * __useRemoveAdventureFromBookingMutation__
 *
 * To run a mutation, you first call `useRemoveAdventureFromBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAdventureFromBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAdventureFromBookingMutation, { data, loading, error }] = useRemoveAdventureFromBookingMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      adventureId: // value for 'adventureId'
 *   },
 * });
 */
export function useRemoveAdventureFromBookingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_RemoveAdventureFromBookingMutation,
    GQL_RemoveAdventureFromBookingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_RemoveAdventureFromBookingMutation,
    GQL_RemoveAdventureFromBookingMutationVariables
  >(RemoveAdventureFromBookingDocument, options)
}
export type RemoveAdventureFromBookingMutationHookResult = ReturnType<
  typeof useRemoveAdventureFromBookingMutation
>
export type RemoveAdventureFromBookingMutationResult =
  Apollo.MutationResult<GQL_RemoveAdventureFromBookingMutation>
export type RemoveAdventureFromBookingMutationOptions =
  Apollo.BaseMutationOptions<
    GQL_RemoveAdventureFromBookingMutation,
    GQL_RemoveAdventureFromBookingMutationVariables
  >
export const GetMyBucketListDocument = gql`
  query getMyBucketList($id: ID) {
    currentUser {
      id
      bucketList(id: $id) {
        ...BucketListFragment
        publicUrl
      }
    }
  }
  ${BucketListFragmentFragmentDoc}
`

/**
 * __useGetMyBucketListQuery__
 *
 * To run a query within a React component, call `useGetMyBucketListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyBucketListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyBucketListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMyBucketListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GQL_GetMyBucketListQuery,
    GQL_GetMyBucketListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetMyBucketListQuery,
    GQL_GetMyBucketListQueryVariables
  >(GetMyBucketListDocument, options)
}
export function useGetMyBucketListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetMyBucketListQuery,
    GQL_GetMyBucketListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetMyBucketListQuery,
    GQL_GetMyBucketListQueryVariables
  >(GetMyBucketListDocument, options)
}
// @ts-ignore
export function useGetMyBucketListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetMyBucketListQuery,
    GQL_GetMyBucketListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetMyBucketListQuery,
  GQL_GetMyBucketListQueryVariables
>
export function useGetMyBucketListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetMyBucketListQuery,
        GQL_GetMyBucketListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetMyBucketListQuery | undefined,
  GQL_GetMyBucketListQueryVariables
>
export function useGetMyBucketListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetMyBucketListQuery,
        GQL_GetMyBucketListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetMyBucketListQuery,
    GQL_GetMyBucketListQueryVariables
  >(GetMyBucketListDocument, options)
}
export type GetMyBucketListQueryHookResult = ReturnType<
  typeof useGetMyBucketListQuery
>
export type GetMyBucketListLazyQueryHookResult = ReturnType<
  typeof useGetMyBucketListLazyQuery
>
export type GetMyBucketListSuspenseQueryHookResult = ReturnType<
  typeof useGetMyBucketListSuspenseQuery
>
export type GetMyBucketListQueryResult = Apollo.QueryResult<
  GQL_GetMyBucketListQuery,
  GQL_GetMyBucketListQueryVariables
>
export const GetMyBucketListItemsDocument = gql`
  query getMyBucketListItems(
    $id: ID
    $params: SearchFilters
    $first: Int
    $cursor: String
  ) {
    currentUser {
      id
      bucketList(id: $id) {
        id
        items(params: $params, first: $first, after: $cursor) {
          pageInfo {
            endCursor
            hasNextPage
          }
          ...BucketListItemConnection
        }
      }
    }
  }
  ${BucketListItemConnectionFragmentDoc}
`

/**
 * __useGetMyBucketListItemsQuery__
 *
 * To run a query within a React component, call `useGetMyBucketListItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyBucketListItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyBucketListItemsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetMyBucketListItemsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GQL_GetMyBucketListItemsQuery,
    GQL_GetMyBucketListItemsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetMyBucketListItemsQuery,
    GQL_GetMyBucketListItemsQueryVariables
  >(GetMyBucketListItemsDocument, options)
}
export function useGetMyBucketListItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetMyBucketListItemsQuery,
    GQL_GetMyBucketListItemsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetMyBucketListItemsQuery,
    GQL_GetMyBucketListItemsQueryVariables
  >(GetMyBucketListItemsDocument, options)
}
// @ts-ignore
export function useGetMyBucketListItemsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetMyBucketListItemsQuery,
    GQL_GetMyBucketListItemsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetMyBucketListItemsQuery,
  GQL_GetMyBucketListItemsQueryVariables
>
export function useGetMyBucketListItemsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetMyBucketListItemsQuery,
        GQL_GetMyBucketListItemsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetMyBucketListItemsQuery | undefined,
  GQL_GetMyBucketListItemsQueryVariables
>
export function useGetMyBucketListItemsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetMyBucketListItemsQuery,
        GQL_GetMyBucketListItemsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetMyBucketListItemsQuery,
    GQL_GetMyBucketListItemsQueryVariables
  >(GetMyBucketListItemsDocument, options)
}
export type GetMyBucketListItemsQueryHookResult = ReturnType<
  typeof useGetMyBucketListItemsQuery
>
export type GetMyBucketListItemsLazyQueryHookResult = ReturnType<
  typeof useGetMyBucketListItemsLazyQuery
>
export type GetMyBucketListItemsSuspenseQueryHookResult = ReturnType<
  typeof useGetMyBucketListItemsSuspenseQuery
>
export type GetMyBucketListItemsQueryResult = Apollo.QueryResult<
  GQL_GetMyBucketListItemsQuery,
  GQL_GetMyBucketListItemsQueryVariables
>
export const GetMyBucketListMapResultsDocument = gql`
  query getMyBucketListMapResults($id: ID, $params: SearchFilters) {
    currentUser {
      id
      bucketList(id: $id) {
        id
        mapResults(params: $params) {
          ...MapResultFragment
          markerCount
        }
      }
    }
  }
  ${MapResultFragmentFragmentDoc}
`

/**
 * __useGetMyBucketListMapResultsQuery__
 *
 * To run a query within a React component, call `useGetMyBucketListMapResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyBucketListMapResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyBucketListMapResultsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetMyBucketListMapResultsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GQL_GetMyBucketListMapResultsQuery,
    GQL_GetMyBucketListMapResultsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetMyBucketListMapResultsQuery,
    GQL_GetMyBucketListMapResultsQueryVariables
  >(GetMyBucketListMapResultsDocument, options)
}
export function useGetMyBucketListMapResultsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetMyBucketListMapResultsQuery,
    GQL_GetMyBucketListMapResultsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetMyBucketListMapResultsQuery,
    GQL_GetMyBucketListMapResultsQueryVariables
  >(GetMyBucketListMapResultsDocument, options)
}
// @ts-ignore
export function useGetMyBucketListMapResultsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetMyBucketListMapResultsQuery,
    GQL_GetMyBucketListMapResultsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetMyBucketListMapResultsQuery,
  GQL_GetMyBucketListMapResultsQueryVariables
>
export function useGetMyBucketListMapResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetMyBucketListMapResultsQuery,
        GQL_GetMyBucketListMapResultsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetMyBucketListMapResultsQuery | undefined,
  GQL_GetMyBucketListMapResultsQueryVariables
>
export function useGetMyBucketListMapResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetMyBucketListMapResultsQuery,
        GQL_GetMyBucketListMapResultsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetMyBucketListMapResultsQuery,
    GQL_GetMyBucketListMapResultsQueryVariables
  >(GetMyBucketListMapResultsDocument, options)
}
export type GetMyBucketListMapResultsQueryHookResult = ReturnType<
  typeof useGetMyBucketListMapResultsQuery
>
export type GetMyBucketListMapResultsLazyQueryHookResult = ReturnType<
  typeof useGetMyBucketListMapResultsLazyQuery
>
export type GetMyBucketListMapResultsSuspenseQueryHookResult = ReturnType<
  typeof useGetMyBucketListMapResultsSuspenseQuery
>
export type GetMyBucketListMapResultsQueryResult = Apollo.QueryResult<
  GQL_GetMyBucketListMapResultsQuery,
  GQL_GetMyBucketListMapResultsQueryVariables
>
export const CreateBucketListDocument = gql`
  mutation createBucketList($name: String!, $themeId: ID!) {
    createBucketList(name: $name, themeId: $themeId) {
      bucketList {
        ...BucketListFragment
      }
    }
  }
  ${BucketListFragmentFragmentDoc}
`
export type GQL_CreateBucketListMutationFn = Apollo.MutationFunction<
  GQL_CreateBucketListMutation,
  GQL_CreateBucketListMutationVariables
>

/**
 * __useCreateBucketListMutation__
 *
 * To run a mutation, you first call `useCreateBucketListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBucketListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBucketListMutation, { data, loading, error }] = useCreateBucketListMutation({
 *   variables: {
 *      name: // value for 'name'
 *      themeId: // value for 'themeId'
 *   },
 * });
 */
export function useCreateBucketListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_CreateBucketListMutation,
    GQL_CreateBucketListMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_CreateBucketListMutation,
    GQL_CreateBucketListMutationVariables
  >(CreateBucketListDocument, options)
}
export type CreateBucketListMutationHookResult = ReturnType<
  typeof useCreateBucketListMutation
>
export type CreateBucketListMutationResult =
  Apollo.MutationResult<GQL_CreateBucketListMutation>
export type CreateBucketListMutationOptions = Apollo.BaseMutationOptions<
  GQL_CreateBucketListMutation,
  GQL_CreateBucketListMutationVariables
>
export const DestroyBucketListDocument = gql`
  mutation destroyBucketList($id: ID!) {
    destroyBucketList(bucketListId: $id) {
      bucketList {
        name
      }
    }
  }
`
export type GQL_DestroyBucketListMutationFn = Apollo.MutationFunction<
  GQL_DestroyBucketListMutation,
  GQL_DestroyBucketListMutationVariables
>

/**
 * __useDestroyBucketListMutation__
 *
 * To run a mutation, you first call `useDestroyBucketListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyBucketListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyBucketListMutation, { data, loading, error }] = useDestroyBucketListMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDestroyBucketListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_DestroyBucketListMutation,
    GQL_DestroyBucketListMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_DestroyBucketListMutation,
    GQL_DestroyBucketListMutationVariables
  >(DestroyBucketListDocument, options)
}
export type DestroyBucketListMutationHookResult = ReturnType<
  typeof useDestroyBucketListMutation
>
export type DestroyBucketListMutationResult =
  Apollo.MutationResult<GQL_DestroyBucketListMutation>
export type DestroyBucketListMutationOptions = Apollo.BaseMutationOptions<
  GQL_DestroyBucketListMutation,
  GQL_DestroyBucketListMutationVariables
>
export const GetBucketListItemsIndexDocument = gql`
  query getBucketListItemsIndex {
    currentUser {
      id
      bucketListItemsIndex
    }
  }
`

/**
 * __useGetBucketListItemsIndexQuery__
 *
 * To run a query within a React component, call `useGetBucketListItemsIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBucketListItemsIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBucketListItemsIndexQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBucketListItemsIndexQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GQL_GetBucketListItemsIndexQuery,
    GQL_GetBucketListItemsIndexQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetBucketListItemsIndexQuery,
    GQL_GetBucketListItemsIndexQueryVariables
  >(GetBucketListItemsIndexDocument, options)
}
export function useGetBucketListItemsIndexLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetBucketListItemsIndexQuery,
    GQL_GetBucketListItemsIndexQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetBucketListItemsIndexQuery,
    GQL_GetBucketListItemsIndexQueryVariables
  >(GetBucketListItemsIndexDocument, options)
}
// @ts-ignore
export function useGetBucketListItemsIndexSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetBucketListItemsIndexQuery,
    GQL_GetBucketListItemsIndexQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetBucketListItemsIndexQuery,
  GQL_GetBucketListItemsIndexQueryVariables
>
export function useGetBucketListItemsIndexSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetBucketListItemsIndexQuery,
        GQL_GetBucketListItemsIndexQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetBucketListItemsIndexQuery | undefined,
  GQL_GetBucketListItemsIndexQueryVariables
>
export function useGetBucketListItemsIndexSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetBucketListItemsIndexQuery,
        GQL_GetBucketListItemsIndexQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetBucketListItemsIndexQuery,
    GQL_GetBucketListItemsIndexQueryVariables
  >(GetBucketListItemsIndexDocument, options)
}
export type GetBucketListItemsIndexQueryHookResult = ReturnType<
  typeof useGetBucketListItemsIndexQuery
>
export type GetBucketListItemsIndexLazyQueryHookResult = ReturnType<
  typeof useGetBucketListItemsIndexLazyQuery
>
export type GetBucketListItemsIndexSuspenseQueryHookResult = ReturnType<
  typeof useGetBucketListItemsIndexSuspenseQuery
>
export type GetBucketListItemsIndexQueryResult = Apollo.QueryResult<
  GQL_GetBucketListItemsIndexQuery,
  GQL_GetBucketListItemsIndexQueryVariables
>
export const BucketListThemesDocument = gql`
  query bucketListThemes {
    defaults {
      bucketListThemes {
        ...BucketListTheme
      }
    }
  }
  ${BucketListThemeFragmentDoc}
`

/**
 * __useBucketListThemesQuery__
 *
 * To run a query within a React component, call `useBucketListThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBucketListThemesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBucketListThemesQuery({
 *   variables: {
 *   },
 * });
 */
export function useBucketListThemesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GQL_BucketListThemesQuery,
    GQL_BucketListThemesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_BucketListThemesQuery,
    GQL_BucketListThemesQueryVariables
  >(BucketListThemesDocument, options)
}
export function useBucketListThemesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_BucketListThemesQuery,
    GQL_BucketListThemesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_BucketListThemesQuery,
    GQL_BucketListThemesQueryVariables
  >(BucketListThemesDocument, options)
}
// @ts-ignore
export function useBucketListThemesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_BucketListThemesQuery,
    GQL_BucketListThemesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_BucketListThemesQuery,
  GQL_BucketListThemesQueryVariables
>
export function useBucketListThemesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_BucketListThemesQuery,
        GQL_BucketListThemesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_BucketListThemesQuery | undefined,
  GQL_BucketListThemesQueryVariables
>
export function useBucketListThemesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_BucketListThemesQuery,
        GQL_BucketListThemesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_BucketListThemesQuery,
    GQL_BucketListThemesQueryVariables
  >(BucketListThemesDocument, options)
}
export type BucketListThemesQueryHookResult = ReturnType<
  typeof useBucketListThemesQuery
>
export type BucketListThemesLazyQueryHookResult = ReturnType<
  typeof useBucketListThemesLazyQuery
>
export type BucketListThemesSuspenseQueryHookResult = ReturnType<
  typeof useBucketListThemesSuspenseQuery
>
export type BucketListThemesQueryResult = Apollo.QueryResult<
  GQL_BucketListThemesQuery,
  GQL_BucketListThemesQueryVariables
>
export const GetMyBucketListsDocument = gql`
  query getMyBucketLists {
    currentUser {
      id
      bucketLists {
        ...BucketListFragment
      }
    }
  }
  ${BucketListFragmentFragmentDoc}
`

/**
 * __useGetMyBucketListsQuery__
 *
 * To run a query within a React component, call `useGetMyBucketListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyBucketListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyBucketListsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyBucketListsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GQL_GetMyBucketListsQuery,
    GQL_GetMyBucketListsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetMyBucketListsQuery,
    GQL_GetMyBucketListsQueryVariables
  >(GetMyBucketListsDocument, options)
}
export function useGetMyBucketListsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetMyBucketListsQuery,
    GQL_GetMyBucketListsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetMyBucketListsQuery,
    GQL_GetMyBucketListsQueryVariables
  >(GetMyBucketListsDocument, options)
}
// @ts-ignore
export function useGetMyBucketListsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetMyBucketListsQuery,
    GQL_GetMyBucketListsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetMyBucketListsQuery,
  GQL_GetMyBucketListsQueryVariables
>
export function useGetMyBucketListsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetMyBucketListsQuery,
        GQL_GetMyBucketListsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetMyBucketListsQuery | undefined,
  GQL_GetMyBucketListsQueryVariables
>
export function useGetMyBucketListsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetMyBucketListsQuery,
        GQL_GetMyBucketListsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetMyBucketListsQuery,
    GQL_GetMyBucketListsQueryVariables
  >(GetMyBucketListsDocument, options)
}
export type GetMyBucketListsQueryHookResult = ReturnType<
  typeof useGetMyBucketListsQuery
>
export type GetMyBucketListsLazyQueryHookResult = ReturnType<
  typeof useGetMyBucketListsLazyQuery
>
export type GetMyBucketListsSuspenseQueryHookResult = ReturnType<
  typeof useGetMyBucketListsSuspenseQuery
>
export type GetMyBucketListsQueryResult = Apollo.QueryResult<
  GQL_GetMyBucketListsQuery,
  GQL_GetMyBucketListsQueryVariables
>
export const UpdateBucketListDocument = gql`
  mutation updateBucketList($id: ID!, $name: String!, $themeId: ID!) {
    updateBucketList(bucketListId: $id, name: $name, themeId: $themeId) {
      bucketList {
        ...BucketListFragment
      }
    }
  }
  ${BucketListFragmentFragmentDoc}
`
export type GQL_UpdateBucketListMutationFn = Apollo.MutationFunction<
  GQL_UpdateBucketListMutation,
  GQL_UpdateBucketListMutationVariables
>

/**
 * __useUpdateBucketListMutation__
 *
 * To run a mutation, you first call `useUpdateBucketListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBucketListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBucketListMutation, { data, loading, error }] = useUpdateBucketListMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      themeId: // value for 'themeId'
 *   },
 * });
 */
export function useUpdateBucketListMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_UpdateBucketListMutation,
    GQL_UpdateBucketListMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_UpdateBucketListMutation,
    GQL_UpdateBucketListMutationVariables
  >(UpdateBucketListDocument, options)
}
export type UpdateBucketListMutationHookResult = ReturnType<
  typeof useUpdateBucketListMutation
>
export type UpdateBucketListMutationResult =
  Apollo.MutationResult<GQL_UpdateBucketListMutation>
export type UpdateBucketListMutationOptions = Apollo.BaseMutationOptions<
  GQL_UpdateBucketListMutation,
  GQL_UpdateBucketListMutationVariables
>
export const GetMyCreatorCalendarDocument = gql`
  query getMyCreatorCalendar(
    $calendarStart: ISO8601Date!
    $calendarEnd: ISO8601Date!
  ) {
    currentUser {
      id
      calendar(startDate: $calendarStart, endDate: $calendarEnd) {
        days {
          available
          date
        }
        events {
          id
          type
          label
          start
          end
        }
      }
    }
  }
`

/**
 * __useGetMyCreatorCalendarQuery__
 *
 * To run a query within a React component, call `useGetMyCreatorCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCreatorCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCreatorCalendarQuery({
 *   variables: {
 *      calendarStart: // value for 'calendarStart'
 *      calendarEnd: // value for 'calendarEnd'
 *   },
 * });
 */
export function useGetMyCreatorCalendarQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetMyCreatorCalendarQuery,
    GQL_GetMyCreatorCalendarQueryVariables
  > &
    (
      | { variables: GQL_GetMyCreatorCalendarQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetMyCreatorCalendarQuery,
    GQL_GetMyCreatorCalendarQueryVariables
  >(GetMyCreatorCalendarDocument, options)
}
export function useGetMyCreatorCalendarLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetMyCreatorCalendarQuery,
    GQL_GetMyCreatorCalendarQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetMyCreatorCalendarQuery,
    GQL_GetMyCreatorCalendarQueryVariables
  >(GetMyCreatorCalendarDocument, options)
}
// @ts-ignore
export function useGetMyCreatorCalendarSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetMyCreatorCalendarQuery,
    GQL_GetMyCreatorCalendarQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetMyCreatorCalendarQuery,
  GQL_GetMyCreatorCalendarQueryVariables
>
export function useGetMyCreatorCalendarSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetMyCreatorCalendarQuery,
        GQL_GetMyCreatorCalendarQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetMyCreatorCalendarQuery | undefined,
  GQL_GetMyCreatorCalendarQueryVariables
>
export function useGetMyCreatorCalendarSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetMyCreatorCalendarQuery,
        GQL_GetMyCreatorCalendarQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetMyCreatorCalendarQuery,
    GQL_GetMyCreatorCalendarQueryVariables
  >(GetMyCreatorCalendarDocument, options)
}
export type GetMyCreatorCalendarQueryHookResult = ReturnType<
  typeof useGetMyCreatorCalendarQuery
>
export type GetMyCreatorCalendarLazyQueryHookResult = ReturnType<
  typeof useGetMyCreatorCalendarLazyQuery
>
export type GetMyCreatorCalendarSuspenseQueryHookResult = ReturnType<
  typeof useGetMyCreatorCalendarSuspenseQuery
>
export type GetMyCreatorCalendarQueryResult = Apollo.QueryResult<
  GQL_GetMyCreatorCalendarQuery,
  GQL_GetMyCreatorCalendarQueryVariables
>
export const UpdateMyCreatorCalendarDocument = gql`
  mutation updateMyCreatorCalendar(
    $startDate: ISO8601Date!
    $endDate: ISO8601Date!
    $available: Boolean!
  ) {
    updateStorytellerCalendar(
      startDate: $startDate
      endDate: $endDate
      available: $available
    ) {
      calendar {
        days {
          available
          date
        }
        events {
          id
          type
          label
          start
          end
        }
      }
    }
  }
`
export type GQL_UpdateMyCreatorCalendarMutationFn = Apollo.MutationFunction<
  GQL_UpdateMyCreatorCalendarMutation,
  GQL_UpdateMyCreatorCalendarMutationVariables
>

/**
 * __useUpdateMyCreatorCalendarMutation__
 *
 * To run a mutation, you first call `useUpdateMyCreatorCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMyCreatorCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMyCreatorCalendarMutation, { data, loading, error }] = useUpdateMyCreatorCalendarMutation({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      available: // value for 'available'
 *   },
 * });
 */
export function useUpdateMyCreatorCalendarMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_UpdateMyCreatorCalendarMutation,
    GQL_UpdateMyCreatorCalendarMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_UpdateMyCreatorCalendarMutation,
    GQL_UpdateMyCreatorCalendarMutationVariables
  >(UpdateMyCreatorCalendarDocument, options)
}
export type UpdateMyCreatorCalendarMutationHookResult = ReturnType<
  typeof useUpdateMyCreatorCalendarMutation
>
export type UpdateMyCreatorCalendarMutationResult =
  Apollo.MutationResult<GQL_UpdateMyCreatorCalendarMutation>
export type UpdateMyCreatorCalendarMutationOptions = Apollo.BaseMutationOptions<
  GQL_UpdateMyCreatorCalendarMutation,
  GQL_UpdateMyCreatorCalendarMutationVariables
>
export const AcceptInvitationDocument = gql`
  mutation acceptInvitation(
    $password: String!
    $passwordConfirmation: String!
    $invitationToken: String
  ) {
    acceptInvitation(
      password: $password
      passwordConfirmation: $passwordConfirmation
      invitationToken: $invitationToken
    ) {
      user {
        id
      }
    }
  }
`
export type GQL_AcceptInvitationMutationFn = Apollo.MutationFunction<
  GQL_AcceptInvitationMutation,
  GQL_AcceptInvitationMutationVariables
>

/**
 * __useAcceptInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInvitationMutation, { data, loading, error }] = useAcceptInvitationMutation({
 *   variables: {
 *      password: // value for 'password'
 *      passwordConfirmation: // value for 'passwordConfirmation'
 *      invitationToken: // value for 'invitationToken'
 *   },
 * });
 */
export function useAcceptInvitationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_AcceptInvitationMutation,
    GQL_AcceptInvitationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_AcceptInvitationMutation,
    GQL_AcceptInvitationMutationVariables
  >(AcceptInvitationDocument, options)
}
export type AcceptInvitationMutationHookResult = ReturnType<
  typeof useAcceptInvitationMutation
>
export type AcceptInvitationMutationResult =
  Apollo.MutationResult<GQL_AcceptInvitationMutation>
export type AcceptInvitationMutationOptions = Apollo.BaseMutationOptions<
  GQL_AcceptInvitationMutation,
  GQL_AcceptInvitationMutationVariables
>
export const ListingCalendarDocument = gql`
  query listingCalendar(
    $listingId: ID!
    $calendarStart: ISO8601Date!
    $calendarEnd: ISO8601Date!
  ) {
    listing(id: $listingId) {
      id
      price
      weekendPrice
      pricingSuffix
      concurrentBookings
      channelManager
      channelManagerSyncEnabled
      listingType {
        slug
      }
      calendar(startDate: $calendarStart, endDate: $calendarEnd) {
        events {
          id
          type
          label
          start
          end
          summary
          ... on BookingCalendarEvent {
            booking {
              status
            }
          }
        }
        days {
          date
          available
          requested
          customPrice
          weekendPrice
          minimumNights
          customMinimumBookingDuration
          note
        }
      }
    }
  }
`

/**
 * __useListingCalendarQuery__
 *
 * To run a query within a React component, call `useListingCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingCalendarQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      calendarStart: // value for 'calendarStart'
 *      calendarEnd: // value for 'calendarEnd'
 *   },
 * });
 */
export function useListingCalendarQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_ListingCalendarQuery,
    GQL_ListingCalendarQueryVariables
  > &
    (
      | { variables: GQL_ListingCalendarQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_ListingCalendarQuery,
    GQL_ListingCalendarQueryVariables
  >(ListingCalendarDocument, options)
}
export function useListingCalendarLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_ListingCalendarQuery,
    GQL_ListingCalendarQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_ListingCalendarQuery,
    GQL_ListingCalendarQueryVariables
  >(ListingCalendarDocument, options)
}
// @ts-ignore
export function useListingCalendarSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_ListingCalendarQuery,
    GQL_ListingCalendarQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_ListingCalendarQuery,
  GQL_ListingCalendarQueryVariables
>
export function useListingCalendarSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_ListingCalendarQuery,
        GQL_ListingCalendarQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_ListingCalendarQuery | undefined,
  GQL_ListingCalendarQueryVariables
>
export function useListingCalendarSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_ListingCalendarQuery,
        GQL_ListingCalendarQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_ListingCalendarQuery,
    GQL_ListingCalendarQueryVariables
  >(ListingCalendarDocument, options)
}
export type ListingCalendarQueryHookResult = ReturnType<
  typeof useListingCalendarQuery
>
export type ListingCalendarLazyQueryHookResult = ReturnType<
  typeof useListingCalendarLazyQuery
>
export type ListingCalendarSuspenseQueryHookResult = ReturnType<
  typeof useListingCalendarSuspenseQuery
>
export type ListingCalendarQueryResult = Apollo.QueryResult<
  GQL_ListingCalendarQuery,
  GQL_ListingCalendarQueryVariables
>
export const UpdateListingCalendarDocument = gql`
  mutation updateListingCalendar(
    $listingId: ID!
    $startDate: ISO8601Date!
    $endDate: ISO8601Date!
    $calendarInput: CalendarInput!
  ) {
    updateCalendar(
      listingId: $listingId
      startDate: $startDate
      endDate: $endDate
      calendarInput: $calendarInput
    ) {
      calendar {
        days {
          date
          available
          minimumNights
          customPrice
          customMinimumBookingDuration
          note
        }
      }
    }
  }
`
export type GQL_UpdateListingCalendarMutationFn = Apollo.MutationFunction<
  GQL_UpdateListingCalendarMutation,
  GQL_UpdateListingCalendarMutationVariables
>

/**
 * __useUpdateListingCalendarMutation__
 *
 * To run a mutation, you first call `useUpdateListingCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateListingCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateListingCalendarMutation, { data, loading, error }] = useUpdateListingCalendarMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      calendarInput: // value for 'calendarInput'
 *   },
 * });
 */
export function useUpdateListingCalendarMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_UpdateListingCalendarMutation,
    GQL_UpdateListingCalendarMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_UpdateListingCalendarMutation,
    GQL_UpdateListingCalendarMutationVariables
  >(UpdateListingCalendarDocument, options)
}
export type UpdateListingCalendarMutationHookResult = ReturnType<
  typeof useUpdateListingCalendarMutation
>
export type UpdateListingCalendarMutationResult =
  Apollo.MutationResult<GQL_UpdateListingCalendarMutation>
export type UpdateListingCalendarMutationOptions = Apollo.BaseMutationOptions<
  GQL_UpdateListingCalendarMutation,
  GQL_UpdateListingCalendarMutationVariables
>
export const CreateAdventureLinkDocument = gql`
  mutation createAdventureLink($adventureId: ID!, $listingId: ID!) {
    createAdventureLink(adventureId: $adventureId, listingId: $listingId) {
      adventure {
        ...EditListingAdventureFragment
      }
    }
  }
  ${EditListingAdventureFragmentFragmentDoc}
`
export type GQL_CreateAdventureLinkMutationFn = Apollo.MutationFunction<
  GQL_CreateAdventureLinkMutation,
  GQL_CreateAdventureLinkMutationVariables
>

/**
 * __useCreateAdventureLinkMutation__
 *
 * To run a mutation, you first call `useCreateAdventureLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdventureLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdventureLinkMutation, { data, loading, error }] = useCreateAdventureLinkMutation({
 *   variables: {
 *      adventureId: // value for 'adventureId'
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useCreateAdventureLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_CreateAdventureLinkMutation,
    GQL_CreateAdventureLinkMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_CreateAdventureLinkMutation,
    GQL_CreateAdventureLinkMutationVariables
  >(CreateAdventureLinkDocument, options)
}
export type CreateAdventureLinkMutationHookResult = ReturnType<
  typeof useCreateAdventureLinkMutation
>
export type CreateAdventureLinkMutationResult =
  Apollo.MutationResult<GQL_CreateAdventureLinkMutation>
export type CreateAdventureLinkMutationOptions = Apollo.BaseMutationOptions<
  GQL_CreateAdventureLinkMutation,
  GQL_CreateAdventureLinkMutationVariables
>
export const GetListingNearbyAdventuresDocument = gql`
  query getListingNearbyAdventures(
    $listingId: ID!
    $adventureTypes: [String!]
    $pageSize: Int = 4
    $afterCursor: String
    $beforeCursor: String
  ) {
    listing(id: $listingId) {
      id
      nearbyAdventureTypes {
        id
        name
        slug
        category
      }
      nearbyAdventures(
        adventureTypes: $adventureTypes
        first: $pageSize
        after: $afterCursor
        before: $beforeCursor
      ) {
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
        edges {
          cursor
          node {
            ...EditListingAdventureFragment
          }
        }
      }
    }
  }
  ${EditListingAdventureFragmentFragmentDoc}
`

/**
 * __useGetListingNearbyAdventuresQuery__
 *
 * To run a query within a React component, call `useGetListingNearbyAdventuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListingNearbyAdventuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListingNearbyAdventuresQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      adventureTypes: // value for 'adventureTypes'
 *      pageSize: // value for 'pageSize'
 *      afterCursor: // value for 'afterCursor'
 *      beforeCursor: // value for 'beforeCursor'
 *   },
 * });
 */
export function useGetListingNearbyAdventuresQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetListingNearbyAdventuresQuery,
    GQL_GetListingNearbyAdventuresQueryVariables
  > &
    (
      | {
          variables: GQL_GetListingNearbyAdventuresQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetListingNearbyAdventuresQuery,
    GQL_GetListingNearbyAdventuresQueryVariables
  >(GetListingNearbyAdventuresDocument, options)
}
export function useGetListingNearbyAdventuresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetListingNearbyAdventuresQuery,
    GQL_GetListingNearbyAdventuresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetListingNearbyAdventuresQuery,
    GQL_GetListingNearbyAdventuresQueryVariables
  >(GetListingNearbyAdventuresDocument, options)
}
// @ts-ignore
export function useGetListingNearbyAdventuresSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetListingNearbyAdventuresQuery,
    GQL_GetListingNearbyAdventuresQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetListingNearbyAdventuresQuery,
  GQL_GetListingNearbyAdventuresQueryVariables
>
export function useGetListingNearbyAdventuresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetListingNearbyAdventuresQuery,
        GQL_GetListingNearbyAdventuresQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetListingNearbyAdventuresQuery | undefined,
  GQL_GetListingNearbyAdventuresQueryVariables
>
export function useGetListingNearbyAdventuresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetListingNearbyAdventuresQuery,
        GQL_GetListingNearbyAdventuresQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetListingNearbyAdventuresQuery,
    GQL_GetListingNearbyAdventuresQueryVariables
  >(GetListingNearbyAdventuresDocument, options)
}
export type GetListingNearbyAdventuresQueryHookResult = ReturnType<
  typeof useGetListingNearbyAdventuresQuery
>
export type GetListingNearbyAdventuresLazyQueryHookResult = ReturnType<
  typeof useGetListingNearbyAdventuresLazyQuery
>
export type GetListingNearbyAdventuresSuspenseQueryHookResult = ReturnType<
  typeof useGetListingNearbyAdventuresSuspenseQuery
>
export type GetListingNearbyAdventuresQueryResult = Apollo.QueryResult<
  GQL_GetListingNearbyAdventuresQuery,
  GQL_GetListingNearbyAdventuresQueryVariables
>
export const CreateListingAdventureDocument = gql`
  mutation createListingAdventure(
    $listingId: ID!
    $adventureInput: CreateAdventureInput!
  ) {
    createListingAdventure(
      listingId: $listingId
      adventureInput: $adventureInput
    ) {
      adventure {
        ...EditListingAdventureFragment
      }
    }
  }
  ${EditListingAdventureFragmentFragmentDoc}
`
export type GQL_CreateListingAdventureMutationFn = Apollo.MutationFunction<
  GQL_CreateListingAdventureMutation,
  GQL_CreateListingAdventureMutationVariables
>

/**
 * __useCreateListingAdventureMutation__
 *
 * To run a mutation, you first call `useCreateListingAdventureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateListingAdventureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createListingAdventureMutation, { data, loading, error }] = useCreateListingAdventureMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      adventureInput: // value for 'adventureInput'
 *   },
 * });
 */
export function useCreateListingAdventureMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_CreateListingAdventureMutation,
    GQL_CreateListingAdventureMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_CreateListingAdventureMutation,
    GQL_CreateListingAdventureMutationVariables
  >(CreateListingAdventureDocument, options)
}
export type CreateListingAdventureMutationHookResult = ReturnType<
  typeof useCreateListingAdventureMutation
>
export type CreateListingAdventureMutationResult =
  Apollo.MutationResult<GQL_CreateListingAdventureMutation>
export type CreateListingAdventureMutationOptions = Apollo.BaseMutationOptions<
  GQL_CreateListingAdventureMutation,
  GQL_CreateListingAdventureMutationVariables
>
export const DestroyAdventureLinkDocument = gql`
  mutation destroyAdventureLink($adventureId: ID!, $listingId: ID!) {
    destroyAdventureLink(adventureId: $adventureId, listingId: $listingId) {
      adventure {
        id
      }
    }
  }
`
export type GQL_DestroyAdventureLinkMutationFn = Apollo.MutationFunction<
  GQL_DestroyAdventureLinkMutation,
  GQL_DestroyAdventureLinkMutationVariables
>

/**
 * __useDestroyAdventureLinkMutation__
 *
 * To run a mutation, you first call `useDestroyAdventureLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyAdventureLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyAdventureLinkMutation, { data, loading, error }] = useDestroyAdventureLinkMutation({
 *   variables: {
 *      adventureId: // value for 'adventureId'
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useDestroyAdventureLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_DestroyAdventureLinkMutation,
    GQL_DestroyAdventureLinkMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_DestroyAdventureLinkMutation,
    GQL_DestroyAdventureLinkMutationVariables
  >(DestroyAdventureLinkDocument, options)
}
export type DestroyAdventureLinkMutationHookResult = ReturnType<
  typeof useDestroyAdventureLinkMutation
>
export type DestroyAdventureLinkMutationResult =
  Apollo.MutationResult<GQL_DestroyAdventureLinkMutation>
export type DestroyAdventureLinkMutationOptions = Apollo.BaseMutationOptions<
  GQL_DestroyAdventureLinkMutation,
  GQL_DestroyAdventureLinkMutationVariables
>
export const DestroyAdventureDocument = gql`
  mutation destroyAdventure($id: ID!) {
    destroyAdventure(adventureId: $id) {
      adventure {
        id
      }
    }
  }
`
export type GQL_DestroyAdventureMutationFn = Apollo.MutationFunction<
  GQL_DestroyAdventureMutation,
  GQL_DestroyAdventureMutationVariables
>

/**
 * __useDestroyAdventureMutation__
 *
 * To run a mutation, you first call `useDestroyAdventureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyAdventureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyAdventureMutation, { data, loading, error }] = useDestroyAdventureMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDestroyAdventureMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_DestroyAdventureMutation,
    GQL_DestroyAdventureMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_DestroyAdventureMutation,
    GQL_DestroyAdventureMutationVariables
  >(DestroyAdventureDocument, options)
}
export type DestroyAdventureMutationHookResult = ReturnType<
  typeof useDestroyAdventureMutation
>
export type DestroyAdventureMutationResult =
  Apollo.MutationResult<GQL_DestroyAdventureMutation>
export type DestroyAdventureMutationOptions = Apollo.BaseMutationOptions<
  GQL_DestroyAdventureMutation,
  GQL_DestroyAdventureMutationVariables
>
export const GetListingAdventuresDocument = gql`
  query getListingAdventures($listingId: ID!) {
    listing(id: $listingId) {
      id
      linkedAdventureIds
      adventures {
        ...EditListingAdventureFragment
      }
    }
  }
  ${EditListingAdventureFragmentFragmentDoc}
`

/**
 * __useGetListingAdventuresQuery__
 *
 * To run a query within a React component, call `useGetListingAdventuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListingAdventuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListingAdventuresQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useGetListingAdventuresQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetListingAdventuresQuery,
    GQL_GetListingAdventuresQueryVariables
  > &
    (
      | { variables: GQL_GetListingAdventuresQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetListingAdventuresQuery,
    GQL_GetListingAdventuresQueryVariables
  >(GetListingAdventuresDocument, options)
}
export function useGetListingAdventuresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetListingAdventuresQuery,
    GQL_GetListingAdventuresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetListingAdventuresQuery,
    GQL_GetListingAdventuresQueryVariables
  >(GetListingAdventuresDocument, options)
}
// @ts-ignore
export function useGetListingAdventuresSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetListingAdventuresQuery,
    GQL_GetListingAdventuresQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetListingAdventuresQuery,
  GQL_GetListingAdventuresQueryVariables
>
export function useGetListingAdventuresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetListingAdventuresQuery,
        GQL_GetListingAdventuresQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetListingAdventuresQuery | undefined,
  GQL_GetListingAdventuresQueryVariables
>
export function useGetListingAdventuresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetListingAdventuresQuery,
        GQL_GetListingAdventuresQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetListingAdventuresQuery,
    GQL_GetListingAdventuresQueryVariables
  >(GetListingAdventuresDocument, options)
}
export type GetListingAdventuresQueryHookResult = ReturnType<
  typeof useGetListingAdventuresQuery
>
export type GetListingAdventuresLazyQueryHookResult = ReturnType<
  typeof useGetListingAdventuresLazyQuery
>
export type GetListingAdventuresSuspenseQueryHookResult = ReturnType<
  typeof useGetListingAdventuresSuspenseQuery
>
export type GetListingAdventuresQueryResult = Apollo.QueryResult<
  GQL_GetListingAdventuresQuery,
  GQL_GetListingAdventuresQueryVariables
>
export const UpdateAdventureDocument = gql`
  mutation updateAdventure(
    $adventureId: ID!
    $adventureInput: UpdateAdventureInput!
  ) {
    updateAdventure(
      adventureId: $adventureId
      adventureInput: $adventureInput
    ) {
      adventure {
        ...EditListingAdventureFragment
      }
    }
  }
  ${EditListingAdventureFragmentFragmentDoc}
`
export type GQL_UpdateAdventureMutationFn = Apollo.MutationFunction<
  GQL_UpdateAdventureMutation,
  GQL_UpdateAdventureMutationVariables
>

/**
 * __useUpdateAdventureMutation__
 *
 * To run a mutation, you first call `useUpdateAdventureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdventureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdventureMutation, { data, loading, error }] = useUpdateAdventureMutation({
 *   variables: {
 *      adventureId: // value for 'adventureId'
 *      adventureInput: // value for 'adventureInput'
 *   },
 * });
 */
export function useUpdateAdventureMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_UpdateAdventureMutation,
    GQL_UpdateAdventureMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_UpdateAdventureMutation,
    GQL_UpdateAdventureMutationVariables
  >(UpdateAdventureDocument, options)
}
export type UpdateAdventureMutationHookResult = ReturnType<
  typeof useUpdateAdventureMutation
>
export type UpdateAdventureMutationResult =
  Apollo.MutationResult<GQL_UpdateAdventureMutation>
export type UpdateAdventureMutationOptions = Apollo.BaseMutationOptions<
  GQL_UpdateAdventureMutation,
  GQL_UpdateAdventureMutationVariables
>
export const GetStoryOfferCalendarDocument = gql`
  query getStoryOfferCalendar(
    $listingId: ID!
    $calendarStart: ISO8601Date!
    $calendarEnd: ISO8601Date!
  ) {
    listing(id: $listingId) {
      id
      storyOfferCalendar(endDate: $calendarEnd, startDate: $calendarStart) {
        days {
          available
          offer
          customOffer
          date
          discountedPrice
          customDiscountedPrice
        }
        startDate
        endDate
      }
    }
  }
`

/**
 * __useGetStoryOfferCalendarQuery__
 *
 * To run a query within a React component, call `useGetStoryOfferCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoryOfferCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoryOfferCalendarQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      calendarStart: // value for 'calendarStart'
 *      calendarEnd: // value for 'calendarEnd'
 *   },
 * });
 */
export function useGetStoryOfferCalendarQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetStoryOfferCalendarQuery,
    GQL_GetStoryOfferCalendarQueryVariables
  > &
    (
      | { variables: GQL_GetStoryOfferCalendarQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetStoryOfferCalendarQuery,
    GQL_GetStoryOfferCalendarQueryVariables
  >(GetStoryOfferCalendarDocument, options)
}
export function useGetStoryOfferCalendarLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetStoryOfferCalendarQuery,
    GQL_GetStoryOfferCalendarQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetStoryOfferCalendarQuery,
    GQL_GetStoryOfferCalendarQueryVariables
  >(GetStoryOfferCalendarDocument, options)
}
// @ts-ignore
export function useGetStoryOfferCalendarSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetStoryOfferCalendarQuery,
    GQL_GetStoryOfferCalendarQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetStoryOfferCalendarQuery,
  GQL_GetStoryOfferCalendarQueryVariables
>
export function useGetStoryOfferCalendarSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetStoryOfferCalendarQuery,
        GQL_GetStoryOfferCalendarQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetStoryOfferCalendarQuery | undefined,
  GQL_GetStoryOfferCalendarQueryVariables
>
export function useGetStoryOfferCalendarSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetStoryOfferCalendarQuery,
        GQL_GetStoryOfferCalendarQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetStoryOfferCalendarQuery,
    GQL_GetStoryOfferCalendarQueryVariables
  >(GetStoryOfferCalendarDocument, options)
}
export type GetStoryOfferCalendarQueryHookResult = ReturnType<
  typeof useGetStoryOfferCalendarQuery
>
export type GetStoryOfferCalendarLazyQueryHookResult = ReturnType<
  typeof useGetStoryOfferCalendarLazyQuery
>
export type GetStoryOfferCalendarSuspenseQueryHookResult = ReturnType<
  typeof useGetStoryOfferCalendarSuspenseQuery
>
export type GetStoryOfferCalendarQueryResult = Apollo.QueryResult<
  GQL_GetStoryOfferCalendarQuery,
  GQL_GetStoryOfferCalendarQueryVariables
>
export const UpdateStoryOfferCalendarDocument = gql`
  mutation updateStoryOfferCalendar(
    $listingId: ID!
    $endDate: ISO8601Date!
    $startDate: ISO8601Date!
    $calendarInput: StoryOfferCalendarInput!
  ) {
    updateStoryOfferCalendar(
      listingId: $listingId
      endDate: $endDate
      startDate: $startDate
      calendarInput: $calendarInput
    ) {
      calendar {
        days {
          available
          date
        }
        endDate
        startDate
      }
    }
  }
`
export type GQL_UpdateStoryOfferCalendarMutationFn = Apollo.MutationFunction<
  GQL_UpdateStoryOfferCalendarMutation,
  GQL_UpdateStoryOfferCalendarMutationVariables
>

/**
 * __useUpdateStoryOfferCalendarMutation__
 *
 * To run a mutation, you first call `useUpdateStoryOfferCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStoryOfferCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStoryOfferCalendarMutation, { data, loading, error }] = useUpdateStoryOfferCalendarMutation({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      calendarInput: // value for 'calendarInput'
 *   },
 * });
 */
export function useUpdateStoryOfferCalendarMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_UpdateStoryOfferCalendarMutation,
    GQL_UpdateStoryOfferCalendarMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_UpdateStoryOfferCalendarMutation,
    GQL_UpdateStoryOfferCalendarMutationVariables
  >(UpdateStoryOfferCalendarDocument, options)
}
export type UpdateStoryOfferCalendarMutationHookResult = ReturnType<
  typeof useUpdateStoryOfferCalendarMutation
>
export type UpdateStoryOfferCalendarMutationResult =
  Apollo.MutationResult<GQL_UpdateStoryOfferCalendarMutation>
export type UpdateStoryOfferCalendarMutationOptions =
  Apollo.BaseMutationOptions<
    GQL_UpdateStoryOfferCalendarMutation,
    GQL_UpdateStoryOfferCalendarMutationVariables
  >
export const CreateStoryVideoDocument = gql`
  mutation createStoryVideo($storyId: ID!) {
    createStoryVideo(storyId: $storyId) {
      directUpload {
        url
      }
    }
  }
`
export type GQL_CreateStoryVideoMutationFn = Apollo.MutationFunction<
  GQL_CreateStoryVideoMutation,
  GQL_CreateStoryVideoMutationVariables
>

/**
 * __useCreateStoryVideoMutation__
 *
 * To run a mutation, you first call `useCreateStoryVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStoryVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStoryVideoMutation, { data, loading, error }] = useCreateStoryVideoMutation({
 *   variables: {
 *      storyId: // value for 'storyId'
 *   },
 * });
 */
export function useCreateStoryVideoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_CreateStoryVideoMutation,
    GQL_CreateStoryVideoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_CreateStoryVideoMutation,
    GQL_CreateStoryVideoMutationVariables
  >(CreateStoryVideoDocument, options)
}
export type CreateStoryVideoMutationHookResult = ReturnType<
  typeof useCreateStoryVideoMutation
>
export type CreateStoryVideoMutationResult =
  Apollo.MutationResult<GQL_CreateStoryVideoMutation>
export type CreateStoryVideoMutationOptions = Apollo.BaseMutationOptions<
  GQL_CreateStoryVideoMutation,
  GQL_CreateStoryVideoMutationVariables
>
export const DestroyVideoDocument = gql`
  mutation destroyVideo($videoId: ID!) {
    destroyVideo(videoId: $videoId) {
      video {
        id
      }
    }
  }
`
export type GQL_DestroyVideoMutationFn = Apollo.MutationFunction<
  GQL_DestroyVideoMutation,
  GQL_DestroyVideoMutationVariables
>

/**
 * __useDestroyVideoMutation__
 *
 * To run a mutation, you first call `useDestroyVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyVideoMutation, { data, loading, error }] = useDestroyVideoMutation({
 *   variables: {
 *      videoId: // value for 'videoId'
 *   },
 * });
 */
export function useDestroyVideoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_DestroyVideoMutation,
    GQL_DestroyVideoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_DestroyVideoMutation,
    GQL_DestroyVideoMutationVariables
  >(DestroyVideoDocument, options)
}
export type DestroyVideoMutationHookResult = ReturnType<
  typeof useDestroyVideoMutation
>
export type DestroyVideoMutationResult =
  Apollo.MutationResult<GQL_DestroyVideoMutation>
export type DestroyVideoMutationOptions = Apollo.BaseMutationOptions<
  GQL_DestroyVideoMutation,
  GQL_DestroyVideoMutationVariables
>
export const GetStoryVideosDocument = gql`
  query getStoryVideos($storyId: ID!) {
    currentUser {
      id
      story(id: $storyId) {
        id
        videos {
          ...Video
        }
      }
    }
  }
  ${VideoFragmentDoc}
`

/**
 * __useGetStoryVideosQuery__
 *
 * To run a query within a React component, call `useGetStoryVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoryVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoryVideosQuery({
 *   variables: {
 *      storyId: // value for 'storyId'
 *   },
 * });
 */
export function useGetStoryVideosQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetStoryVideosQuery,
    GQL_GetStoryVideosQueryVariables
  > &
    (
      | { variables: GQL_GetStoryVideosQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetStoryVideosQuery,
    GQL_GetStoryVideosQueryVariables
  >(GetStoryVideosDocument, options)
}
export function useGetStoryVideosLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetStoryVideosQuery,
    GQL_GetStoryVideosQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetStoryVideosQuery,
    GQL_GetStoryVideosQueryVariables
  >(GetStoryVideosDocument, options)
}
// @ts-ignore
export function useGetStoryVideosSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetStoryVideosQuery,
    GQL_GetStoryVideosQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetStoryVideosQuery,
  GQL_GetStoryVideosQueryVariables
>
export function useGetStoryVideosSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetStoryVideosQuery,
        GQL_GetStoryVideosQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetStoryVideosQuery | undefined,
  GQL_GetStoryVideosQueryVariables
>
export function useGetStoryVideosSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetStoryVideosQuery,
        GQL_GetStoryVideosQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetStoryVideosQuery,
    GQL_GetStoryVideosQueryVariables
  >(GetStoryVideosDocument, options)
}
export type GetStoryVideosQueryHookResult = ReturnType<
  typeof useGetStoryVideosQuery
>
export type GetStoryVideosLazyQueryHookResult = ReturnType<
  typeof useGetStoryVideosLazyQuery
>
export type GetStoryVideosSuspenseQueryHookResult = ReturnType<
  typeof useGetStoryVideosSuspenseQuery
>
export type GetStoryVideosQueryResult = Apollo.QueryResult<
  GQL_GetStoryVideosQuery,
  GQL_GetStoryVideosQueryVariables
>
export const CreateRipaVideoDocument = gql`
  mutation createRipaVideo($storyId: ID!, $category: RipaVideoCategory!) {
    createRipaVideo(storyId: $storyId, category: $category) {
      directUpload {
        url
      }
    }
  }
`
export type GQL_CreateRipaVideoMutationFn = Apollo.MutationFunction<
  GQL_CreateRipaVideoMutation,
  GQL_CreateRipaVideoMutationVariables
>

/**
 * __useCreateRipaVideoMutation__
 *
 * To run a mutation, you first call `useCreateRipaVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRipaVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRipaVideoMutation, { data, loading, error }] = useCreateRipaVideoMutation({
 *   variables: {
 *      storyId: // value for 'storyId'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useCreateRipaVideoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_CreateRipaVideoMutation,
    GQL_CreateRipaVideoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_CreateRipaVideoMutation,
    GQL_CreateRipaVideoMutationVariables
  >(CreateRipaVideoDocument, options)
}
export type CreateRipaVideoMutationHookResult = ReturnType<
  typeof useCreateRipaVideoMutation
>
export type CreateRipaVideoMutationResult =
  Apollo.MutationResult<GQL_CreateRipaVideoMutation>
export type CreateRipaVideoMutationOptions = Apollo.BaseMutationOptions<
  GQL_CreateRipaVideoMutation,
  GQL_CreateRipaVideoMutationVariables
>
export const GetRipaVideosDocument = gql`
  query getRipaVideos($storyId: ID!) {
    currentUser {
      id
      story(id: $storyId) {
        id
        adventureRipaVideos {
          ...Video
        }
        accommodationRipaVideos {
          ...Video
        }
      }
    }
  }
  ${VideoFragmentDoc}
`

/**
 * __useGetRipaVideosQuery__
 *
 * To run a query within a React component, call `useGetRipaVideosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRipaVideosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRipaVideosQuery({
 *   variables: {
 *      storyId: // value for 'storyId'
 *   },
 * });
 */
export function useGetRipaVideosQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetRipaVideosQuery,
    GQL_GetRipaVideosQueryVariables
  > &
    (
      | { variables: GQL_GetRipaVideosQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetRipaVideosQuery,
    GQL_GetRipaVideosQueryVariables
  >(GetRipaVideosDocument, options)
}
export function useGetRipaVideosLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetRipaVideosQuery,
    GQL_GetRipaVideosQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetRipaVideosQuery,
    GQL_GetRipaVideosQueryVariables
  >(GetRipaVideosDocument, options)
}
// @ts-ignore
export function useGetRipaVideosSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetRipaVideosQuery,
    GQL_GetRipaVideosQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetRipaVideosQuery,
  GQL_GetRipaVideosQueryVariables
>
export function useGetRipaVideosSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetRipaVideosQuery,
        GQL_GetRipaVideosQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetRipaVideosQuery | undefined,
  GQL_GetRipaVideosQueryVariables
>
export function useGetRipaVideosSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetRipaVideosQuery,
        GQL_GetRipaVideosQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetRipaVideosQuery,
    GQL_GetRipaVideosQueryVariables
  >(GetRipaVideosDocument, options)
}
export type GetRipaVideosQueryHookResult = ReturnType<
  typeof useGetRipaVideosQuery
>
export type GetRipaVideosLazyQueryHookResult = ReturnType<
  typeof useGetRipaVideosLazyQuery
>
export type GetRipaVideosSuspenseQueryHookResult = ReturnType<
  typeof useGetRipaVideosSuspenseQuery
>
export type GetRipaVideosQueryResult = Apollo.QueryResult<
  GQL_GetRipaVideosQuery,
  GQL_GetRipaVideosQueryVariables
>
export const CreateSavedMessageDocument = gql`
  mutation createSavedMessage($text: String!, $title: String!) {
    createSavedMessage(text: $text, title: $title) {
      savedMessage {
        id
        title
        text
      }
    }
  }
`
export type GQL_CreateSavedMessageMutationFn = Apollo.MutationFunction<
  GQL_CreateSavedMessageMutation,
  GQL_CreateSavedMessageMutationVariables
>

/**
 * __useCreateSavedMessageMutation__
 *
 * To run a mutation, you first call `useCreateSavedMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSavedMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSavedMessageMutation, { data, loading, error }] = useCreateSavedMessageMutation({
 *   variables: {
 *      text: // value for 'text'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateSavedMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_CreateSavedMessageMutation,
    GQL_CreateSavedMessageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_CreateSavedMessageMutation,
    GQL_CreateSavedMessageMutationVariables
  >(CreateSavedMessageDocument, options)
}
export type CreateSavedMessageMutationHookResult = ReturnType<
  typeof useCreateSavedMessageMutation
>
export type CreateSavedMessageMutationResult =
  Apollo.MutationResult<GQL_CreateSavedMessageMutation>
export type CreateSavedMessageMutationOptions = Apollo.BaseMutationOptions<
  GQL_CreateSavedMessageMutation,
  GQL_CreateSavedMessageMutationVariables
>
export const DestroySavedMessageDocument = gql`
  mutation destroySavedMessage($id: ID!) {
    destroySavedMessage(savedMessageId: $id) {
      savedMessages {
        id
        text
        title
      }
    }
  }
`
export type GQL_DestroySavedMessageMutationFn = Apollo.MutationFunction<
  GQL_DestroySavedMessageMutation,
  GQL_DestroySavedMessageMutationVariables
>

/**
 * __useDestroySavedMessageMutation__
 *
 * To run a mutation, you first call `useDestroySavedMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroySavedMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroySavedMessageMutation, { data, loading, error }] = useDestroySavedMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDestroySavedMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_DestroySavedMessageMutation,
    GQL_DestroySavedMessageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_DestroySavedMessageMutation,
    GQL_DestroySavedMessageMutationVariables
  >(DestroySavedMessageDocument, options)
}
export type DestroySavedMessageMutationHookResult = ReturnType<
  typeof useDestroySavedMessageMutation
>
export type DestroySavedMessageMutationResult =
  Apollo.MutationResult<GQL_DestroySavedMessageMutation>
export type DestroySavedMessageMutationOptions = Apollo.BaseMutationOptions<
  GQL_DestroySavedMessageMutation,
  GQL_DestroySavedMessageMutationVariables
>
export const GetSavedMessagesDocument = gql`
  query getSavedMessages {
    currentUser {
      id
      savedMessages {
        id
        text
        title
      }
    }
  }
`

/**
 * __useGetSavedMessagesQuery__
 *
 * To run a query within a React component, call `useGetSavedMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedMessagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSavedMessagesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GQL_GetSavedMessagesQuery,
    GQL_GetSavedMessagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetSavedMessagesQuery,
    GQL_GetSavedMessagesQueryVariables
  >(GetSavedMessagesDocument, options)
}
export function useGetSavedMessagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetSavedMessagesQuery,
    GQL_GetSavedMessagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetSavedMessagesQuery,
    GQL_GetSavedMessagesQueryVariables
  >(GetSavedMessagesDocument, options)
}
// @ts-ignore
export function useGetSavedMessagesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetSavedMessagesQuery,
    GQL_GetSavedMessagesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetSavedMessagesQuery,
  GQL_GetSavedMessagesQueryVariables
>
export function useGetSavedMessagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetSavedMessagesQuery,
        GQL_GetSavedMessagesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetSavedMessagesQuery | undefined,
  GQL_GetSavedMessagesQueryVariables
>
export function useGetSavedMessagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetSavedMessagesQuery,
        GQL_GetSavedMessagesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetSavedMessagesQuery,
    GQL_GetSavedMessagesQueryVariables
  >(GetSavedMessagesDocument, options)
}
export type GetSavedMessagesQueryHookResult = ReturnType<
  typeof useGetSavedMessagesQuery
>
export type GetSavedMessagesLazyQueryHookResult = ReturnType<
  typeof useGetSavedMessagesLazyQuery
>
export type GetSavedMessagesSuspenseQueryHookResult = ReturnType<
  typeof useGetSavedMessagesSuspenseQuery
>
export type GetSavedMessagesQueryResult = Apollo.QueryResult<
  GQL_GetSavedMessagesQuery,
  GQL_GetSavedMessagesQueryVariables
>
export const UpdateSavedMessageDocument = gql`
  mutation updateSavedMessage($id: ID!, $text: String!, $title: String!) {
    updateSavedMessage(savedMessageId: $id, text: $text, title: $title) {
      savedMessage {
        id
        text
        title
      }
    }
  }
`
export type GQL_UpdateSavedMessageMutationFn = Apollo.MutationFunction<
  GQL_UpdateSavedMessageMutation,
  GQL_UpdateSavedMessageMutationVariables
>

/**
 * __useUpdateSavedMessageMutation__
 *
 * To run a mutation, you first call `useUpdateSavedMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSavedMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSavedMessageMutation, { data, loading, error }] = useUpdateSavedMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      text: // value for 'text'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useUpdateSavedMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_UpdateSavedMessageMutation,
    GQL_UpdateSavedMessageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_UpdateSavedMessageMutation,
    GQL_UpdateSavedMessageMutationVariables
  >(UpdateSavedMessageDocument, options)
}
export type UpdateSavedMessageMutationHookResult = ReturnType<
  typeof useUpdateSavedMessageMutation
>
export type UpdateSavedMessageMutationResult =
  Apollo.MutationResult<GQL_UpdateSavedMessageMutation>
export type UpdateSavedMessageMutationOptions = Apollo.BaseMutationOptions<
  GQL_UpdateSavedMessageMutation,
  GQL_UpdateSavedMessageMutationVariables
>
export const ArchiveConversationDocument = gql`
  mutation archiveConversation($conversationId: ID!) {
    archiveConversation(conversationId: $conversationId) {
      conversation {
        id
        archivable
        archivedAt
      }
    }
  }
`
export type GQL_ArchiveConversationMutationFn = Apollo.MutationFunction<
  GQL_ArchiveConversationMutation,
  GQL_ArchiveConversationMutationVariables
>

/**
 * __useArchiveConversationMutation__
 *
 * To run a mutation, you first call `useArchiveConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveConversationMutation, { data, loading, error }] = useArchiveConversationMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useArchiveConversationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_ArchiveConversationMutation,
    GQL_ArchiveConversationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_ArchiveConversationMutation,
    GQL_ArchiveConversationMutationVariables
  >(ArchiveConversationDocument, options)
}
export type ArchiveConversationMutationHookResult = ReturnType<
  typeof useArchiveConversationMutation
>
export type ArchiveConversationMutationResult =
  Apollo.MutationResult<GQL_ArchiveConversationMutation>
export type ArchiveConversationMutationOptions = Apollo.BaseMutationOptions<
  GQL_ArchiveConversationMutation,
  GQL_ArchiveConversationMutationVariables
>
export const InboxDocument = gql`
  query inbox(
    $bookingRequestsFirst: Int = 10
    $bookingRequestsCursor: String
    $unreadFirst: Int = 10
    $unreadCursor: String
    $readFirst: Int = 10
    $readCursor: String
  ) {
    currentUser {
      id
      host
      assignments {
        ...Assignment
        ...AssignmentBookingField
      }
    }
    inbox {
      bookingRequests(
        first: $bookingRequestsFirst
        after: $bookingRequestsCursor
      ) @connection(key: "bookingRequests") {
        ...ConversationConnectionFragment
      }
      unread(first: $unreadFirst, after: $unreadCursor)
        @connection(key: "unread") {
        ...ConversationConnectionFragment
      }
      read(first: $readFirst, after: $readCursor) @connection(key: "read") {
        ...ConversationConnectionFragment
      }
    }
  }
  ${AssignmentFragmentDoc}
  ${AssignmentBookingFieldFragmentDoc}
  ${ConversationConnectionFragmentFragmentDoc}
`

/**
 * __useInboxQuery__
 *
 * To run a query within a React component, call `useInboxQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxQuery({
 *   variables: {
 *      bookingRequestsFirst: // value for 'bookingRequestsFirst'
 *      bookingRequestsCursor: // value for 'bookingRequestsCursor'
 *      unreadFirst: // value for 'unreadFirst'
 *      unreadCursor: // value for 'unreadCursor'
 *      readFirst: // value for 'readFirst'
 *      readCursor: // value for 'readCursor'
 *   },
 * });
 */
export function useInboxQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GQL_InboxQuery,
    GQL_InboxQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GQL_InboxQuery, GQL_InboxQueryVariables>(
    InboxDocument,
    options,
  )
}
export function useInboxLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_InboxQuery,
    GQL_InboxQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GQL_InboxQuery, GQL_InboxQueryVariables>(
    InboxDocument,
    options,
  )
}
// @ts-ignore
export function useInboxSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_InboxQuery,
    GQL_InboxQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GQL_InboxQuery, GQL_InboxQueryVariables>
export function useInboxSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GQL_InboxQuery, GQL_InboxQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GQL_InboxQuery | undefined,
  GQL_InboxQueryVariables
>
export function useInboxSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GQL_InboxQuery, GQL_InboxQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GQL_InboxQuery, GQL_InboxQueryVariables>(
    InboxDocument,
    options,
  )
}
export type InboxQueryHookResult = ReturnType<typeof useInboxQuery>
export type InboxLazyQueryHookResult = ReturnType<typeof useInboxLazyQuery>
export type InboxSuspenseQueryHookResult = ReturnType<
  typeof useInboxSuspenseQuery
>
export type InboxQueryResult = Apollo.QueryResult<
  GQL_InboxQuery,
  GQL_InboxQueryVariables
>
export const RestoreConversationDocument = gql`
  mutation restoreConversation($conversationId: ID!) {
    restoreConversation(conversationId: $conversationId) {
      conversation {
        id
        archivable
        archivedAt
      }
    }
  }
`
export type GQL_RestoreConversationMutationFn = Apollo.MutationFunction<
  GQL_RestoreConversationMutation,
  GQL_RestoreConversationMutationVariables
>

/**
 * __useRestoreConversationMutation__
 *
 * To run a mutation, you first call `useRestoreConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreConversationMutation, { data, loading, error }] = useRestoreConversationMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useRestoreConversationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_RestoreConversationMutation,
    GQL_RestoreConversationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_RestoreConversationMutation,
    GQL_RestoreConversationMutationVariables
  >(RestoreConversationDocument, options)
}
export type RestoreConversationMutationHookResult = ReturnType<
  typeof useRestoreConversationMutation
>
export type RestoreConversationMutationResult =
  Apollo.MutationResult<GQL_RestoreConversationMutation>
export type RestoreConversationMutationOptions = Apollo.BaseMutationOptions<
  GQL_RestoreConversationMutation,
  GQL_RestoreConversationMutationVariables
>
export const SendMessageDocument = gql`
  mutation sendMessage(
    $conversationId: ID!
    $body: String!
    $attachments: [AttachmentInput!]
  ) {
    sendMessage(
      conversationId: $conversationId
      body: $body
      attachments: $attachments
    ) {
      message {
        body
      }
    }
  }
`
export type GQL_SendMessageMutationFn = Apollo.MutationFunction<
  GQL_SendMessageMutation,
  GQL_SendMessageMutationVariables
>

/**
 * __useSendMessageMutation__
 *
 * To run a mutation, you first call `useSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageMutation, { data, loading, error }] = useSendMessageMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      body: // value for 'body'
 *      attachments: // value for 'attachments'
 *   },
 * });
 */
export function useSendMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_SendMessageMutation,
    GQL_SendMessageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_SendMessageMutation,
    GQL_SendMessageMutationVariables
  >(SendMessageDocument, options)
}
export type SendMessageMutationHookResult = ReturnType<
  typeof useSendMessageMutation
>
export type SendMessageMutationResult =
  Apollo.MutationResult<GQL_SendMessageMutation>
export type SendMessageMutationOptions = Apollo.BaseMutationOptions<
  GQL_SendMessageMutation,
  GQL_SendMessageMutationVariables
>
export const GetSearchBarResultsDocument = gql`
  query getSearchBarResults($query: String!, $sessionToken: String) {
    searchByTitle(query: $query, sessionToken: $sessionToken) {
      result {
        ... on Listing {
          id
          __typename
          title
          url
          promoImage {
            thumb
          }
          location {
            name
            lat
            lng
          }
        }
        ... on Story {
          id
          __typename
          title
          url
          user {
            id
            firstName
            avatar {
              original
            }
          }
          promoImage {
            thumb
          }
          featuredListing {
            location {
              name
              lat
              lng
            }
          }
        }
        ... on Region {
          id
          __typename
          name
          slug
          state {
            id
            countryId
            code
          }
        }
        ... on Prediction {
          __typename
          googlePlaceId
          description
          mainText
        }
      }
    }
  }
`

/**
 * __useGetSearchBarResultsQuery__
 *
 * To run a query within a React component, call `useGetSearchBarResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchBarResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchBarResultsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      sessionToken: // value for 'sessionToken'
 *   },
 * });
 */
export function useGetSearchBarResultsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetSearchBarResultsQuery,
    GQL_GetSearchBarResultsQueryVariables
  > &
    (
      | { variables: GQL_GetSearchBarResultsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetSearchBarResultsQuery,
    GQL_GetSearchBarResultsQueryVariables
  >(GetSearchBarResultsDocument, options)
}
export function useGetSearchBarResultsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetSearchBarResultsQuery,
    GQL_GetSearchBarResultsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetSearchBarResultsQuery,
    GQL_GetSearchBarResultsQueryVariables
  >(GetSearchBarResultsDocument, options)
}
// @ts-ignore
export function useGetSearchBarResultsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetSearchBarResultsQuery,
    GQL_GetSearchBarResultsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetSearchBarResultsQuery,
  GQL_GetSearchBarResultsQueryVariables
>
export function useGetSearchBarResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetSearchBarResultsQuery,
        GQL_GetSearchBarResultsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetSearchBarResultsQuery | undefined,
  GQL_GetSearchBarResultsQueryVariables
>
export function useGetSearchBarResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetSearchBarResultsQuery,
        GQL_GetSearchBarResultsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetSearchBarResultsQuery,
    GQL_GetSearchBarResultsQueryVariables
  >(GetSearchBarResultsDocument, options)
}
export type GetSearchBarResultsQueryHookResult = ReturnType<
  typeof useGetSearchBarResultsQuery
>
export type GetSearchBarResultsLazyQueryHookResult = ReturnType<
  typeof useGetSearchBarResultsLazyQuery
>
export type GetSearchBarResultsSuspenseQueryHookResult = ReturnType<
  typeof useGetSearchBarResultsSuspenseQuery
>
export type GetSearchBarResultsQueryResult = Apollo.QueryResult<
  GQL_GetSearchBarResultsQuery,
  GQL_GetSearchBarResultsQueryVariables
>
export const GetStatesForCountryDocument = gql`
  query getStatesForCountry($country: Countries!) {
    search(params: { country: $country }) {
      defaults {
        states {
          id
          code
          name
          countryId
        }
      }
    }
  }
`

/**
 * __useGetStatesForCountryQuery__
 *
 * To run a query within a React component, call `useGetStatesForCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatesForCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatesForCountryQuery({
 *   variables: {
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetStatesForCountryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetStatesForCountryQuery,
    GQL_GetStatesForCountryQueryVariables
  > &
    (
      | { variables: GQL_GetStatesForCountryQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetStatesForCountryQuery,
    GQL_GetStatesForCountryQueryVariables
  >(GetStatesForCountryDocument, options)
}
export function useGetStatesForCountryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetStatesForCountryQuery,
    GQL_GetStatesForCountryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetStatesForCountryQuery,
    GQL_GetStatesForCountryQueryVariables
  >(GetStatesForCountryDocument, options)
}
// @ts-ignore
export function useGetStatesForCountrySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetStatesForCountryQuery,
    GQL_GetStatesForCountryQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetStatesForCountryQuery,
  GQL_GetStatesForCountryQueryVariables
>
export function useGetStatesForCountrySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetStatesForCountryQuery,
        GQL_GetStatesForCountryQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetStatesForCountryQuery | undefined,
  GQL_GetStatesForCountryQueryVariables
>
export function useGetStatesForCountrySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetStatesForCountryQuery,
        GQL_GetStatesForCountryQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetStatesForCountryQuery,
    GQL_GetStatesForCountryQueryVariables
  >(GetStatesForCountryDocument, options)
}
export type GetStatesForCountryQueryHookResult = ReturnType<
  typeof useGetStatesForCountryQuery
>
export type GetStatesForCountryLazyQueryHookResult = ReturnType<
  typeof useGetStatesForCountryLazyQuery
>
export type GetStatesForCountrySuspenseQueryHookResult = ReturnType<
  typeof useGetStatesForCountrySuspenseQuery
>
export type GetStatesForCountryQueryResult = Apollo.QueryResult<
  GQL_GetStatesForCountryQuery,
  GQL_GetStatesForCountryQueryVariables
>
export const PlaceLookupDocument = gql`
  query placeLookup($googlePlaceId: String!, $sessionToken: String) {
    placeLookup(googlePlaceId: $googlePlaceId, sessionToken: $sessionToken) {
      name
      googlePlaceId
      origin
      bounds {
        sw
        ne
      }
      country {
        code
      }
    }
  }
`

/**
 * __usePlaceLookupQuery__
 *
 * To run a query within a React component, call `usePlaceLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaceLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaceLookupQuery({
 *   variables: {
 *      googlePlaceId: // value for 'googlePlaceId'
 *      sessionToken: // value for 'sessionToken'
 *   },
 * });
 */
export function usePlaceLookupQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_PlaceLookupQuery,
    GQL_PlaceLookupQueryVariables
  > &
    (
      | { variables: GQL_PlaceLookupQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GQL_PlaceLookupQuery, GQL_PlaceLookupQueryVariables>(
    PlaceLookupDocument,
    options,
  )
}
export function usePlaceLookupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_PlaceLookupQuery,
    GQL_PlaceLookupQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_PlaceLookupQuery,
    GQL_PlaceLookupQueryVariables
  >(PlaceLookupDocument, options)
}
// @ts-ignore
export function usePlaceLookupSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_PlaceLookupQuery,
    GQL_PlaceLookupQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_PlaceLookupQuery,
  GQL_PlaceLookupQueryVariables
>
export function usePlaceLookupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_PlaceLookupQuery,
        GQL_PlaceLookupQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_PlaceLookupQuery | undefined,
  GQL_PlaceLookupQueryVariables
>
export function usePlaceLookupSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_PlaceLookupQuery,
        GQL_PlaceLookupQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_PlaceLookupQuery,
    GQL_PlaceLookupQueryVariables
  >(PlaceLookupDocument, options)
}
export type PlaceLookupQueryHookResult = ReturnType<typeof usePlaceLookupQuery>
export type PlaceLookupLazyQueryHookResult = ReturnType<
  typeof usePlaceLookupLazyQuery
>
export type PlaceLookupSuspenseQueryHookResult = ReturnType<
  typeof usePlaceLookupSuspenseQuery
>
export type PlaceLookupQueryResult = Apollo.QueryResult<
  GQL_PlaceLookupQuery,
  GQL_PlaceLookupQueryVariables
>
export const GetAdventureWithListingDocument = gql`
  query getAdventureWithListing($adventureId: ID!) {
    adventure(id: $adventureId) {
      id
      description
      locationType
      title
      url
      shareUrl
      adventureType {
        id
        name
        slug
        category
      }
      location {
        name
        lat
        lng
      }
      region {
        id
        state {
          id
          code
          country {
            id
            code
          }
        }
      }
      photos(first: 1) {
        image {
          medium
          large
        }
      }
      reviewScore
      ... on StoryAdventure {
        storyUrl
        storyteller {
          id
          firstName
          url
          avatar {
            original
            thumb
            thumbLg
          }
        }
        story {
          id
          title
          url
          active
          featuredListing {
            id
            state
            market {
              id
              code
              name
              slug
            }
            coordinates
            region {
              id
              name
              slug
            }
            subcategory {
              id
              slug
            }
          }
        }
      }
    }
  }
`

/**
 * __useGetAdventureWithListingQuery__
 *
 * To run a query within a React component, call `useGetAdventureWithListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdventureWithListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdventureWithListingQuery({
 *   variables: {
 *      adventureId: // value for 'adventureId'
 *   },
 * });
 */
export function useGetAdventureWithListingQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetAdventureWithListingQuery,
    GQL_GetAdventureWithListingQueryVariables
  > &
    (
      | { variables: GQL_GetAdventureWithListingQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetAdventureWithListingQuery,
    GQL_GetAdventureWithListingQueryVariables
  >(GetAdventureWithListingDocument, options)
}
export function useGetAdventureWithListingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetAdventureWithListingQuery,
    GQL_GetAdventureWithListingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetAdventureWithListingQuery,
    GQL_GetAdventureWithListingQueryVariables
  >(GetAdventureWithListingDocument, options)
}
// @ts-ignore
export function useGetAdventureWithListingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetAdventureWithListingQuery,
    GQL_GetAdventureWithListingQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetAdventureWithListingQuery,
  GQL_GetAdventureWithListingQueryVariables
>
export function useGetAdventureWithListingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetAdventureWithListingQuery,
        GQL_GetAdventureWithListingQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetAdventureWithListingQuery | undefined,
  GQL_GetAdventureWithListingQueryVariables
>
export function useGetAdventureWithListingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetAdventureWithListingQuery,
        GQL_GetAdventureWithListingQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetAdventureWithListingQuery,
    GQL_GetAdventureWithListingQueryVariables
  >(GetAdventureWithListingDocument, options)
}
export type GetAdventureWithListingQueryHookResult = ReturnType<
  typeof useGetAdventureWithListingQuery
>
export type GetAdventureWithListingLazyQueryHookResult = ReturnType<
  typeof useGetAdventureWithListingLazyQuery
>
export type GetAdventureWithListingSuspenseQueryHookResult = ReturnType<
  typeof useGetAdventureWithListingSuspenseQuery
>
export type GetAdventureWithListingQueryResult = Apollo.QueryResult<
  GQL_GetAdventureWithListingQuery,
  GQL_GetAdventureWithListingQueryVariables
>
export const GetAdventurePhotosDocument = gql`
  query getAdventurePhotos($id: ID!) {
    adventure(id: $id) {
      id
      photos(first: 10) {
        aspectRatio
        createdAt
        id
        image {
          original
          medium
          large
          hero
          thumb
        }
        position
        updatedAt
      }
    }
  }
`

/**
 * __useGetAdventurePhotosQuery__
 *
 * To run a query within a React component, call `useGetAdventurePhotosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdventurePhotosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdventurePhotosQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdventurePhotosQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetAdventurePhotosQuery,
    GQL_GetAdventurePhotosQueryVariables
  > &
    (
      | { variables: GQL_GetAdventurePhotosQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetAdventurePhotosQuery,
    GQL_GetAdventurePhotosQueryVariables
  >(GetAdventurePhotosDocument, options)
}
export function useGetAdventurePhotosLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetAdventurePhotosQuery,
    GQL_GetAdventurePhotosQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetAdventurePhotosQuery,
    GQL_GetAdventurePhotosQueryVariables
  >(GetAdventurePhotosDocument, options)
}
// @ts-ignore
export function useGetAdventurePhotosSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetAdventurePhotosQuery,
    GQL_GetAdventurePhotosQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetAdventurePhotosQuery,
  GQL_GetAdventurePhotosQueryVariables
>
export function useGetAdventurePhotosSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetAdventurePhotosQuery,
        GQL_GetAdventurePhotosQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetAdventurePhotosQuery | undefined,
  GQL_GetAdventurePhotosQueryVariables
>
export function useGetAdventurePhotosSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetAdventurePhotosQuery,
        GQL_GetAdventurePhotosQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetAdventurePhotosQuery,
    GQL_GetAdventurePhotosQueryVariables
  >(GetAdventurePhotosDocument, options)
}
export type GetAdventurePhotosQueryHookResult = ReturnType<
  typeof useGetAdventurePhotosQuery
>
export type GetAdventurePhotosLazyQueryHookResult = ReturnType<
  typeof useGetAdventurePhotosLazyQuery
>
export type GetAdventurePhotosSuspenseQueryHookResult = ReturnType<
  typeof useGetAdventurePhotosSuspenseQuery
>
export type GetAdventurePhotosQueryResult = Apollo.QueryResult<
  GQL_GetAdventurePhotosQuery,
  GQL_GetAdventurePhotosQueryVariables
>
export const GetAdventureReviewsDocument = gql`
  query getAdventureReviews($id: ID!, $cursor: String) {
    adventure(id: $id) {
      id
      reviews(first: 3, after: $cursor) {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            id
            createdAt
            content
            reviewer {
              firstName
              avatar {
                original
                thumbLg
              }
            }
            fulfillingMoments {
              slug
              name
            }
          }
        }
      }
    }
  }
`

/**
 * __useGetAdventureReviewsQuery__
 *
 * To run a query within a React component, call `useGetAdventureReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdventureReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdventureReviewsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetAdventureReviewsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetAdventureReviewsQuery,
    GQL_GetAdventureReviewsQueryVariables
  > &
    (
      | { variables: GQL_GetAdventureReviewsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetAdventureReviewsQuery,
    GQL_GetAdventureReviewsQueryVariables
  >(GetAdventureReviewsDocument, options)
}
export function useGetAdventureReviewsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetAdventureReviewsQuery,
    GQL_GetAdventureReviewsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetAdventureReviewsQuery,
    GQL_GetAdventureReviewsQueryVariables
  >(GetAdventureReviewsDocument, options)
}
// @ts-ignore
export function useGetAdventureReviewsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetAdventureReviewsQuery,
    GQL_GetAdventureReviewsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetAdventureReviewsQuery,
  GQL_GetAdventureReviewsQueryVariables
>
export function useGetAdventureReviewsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetAdventureReviewsQuery,
        GQL_GetAdventureReviewsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetAdventureReviewsQuery | undefined,
  GQL_GetAdventureReviewsQueryVariables
>
export function useGetAdventureReviewsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetAdventureReviewsQuery,
        GQL_GetAdventureReviewsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetAdventureReviewsQuery,
    GQL_GetAdventureReviewsQueryVariables
  >(GetAdventureReviewsDocument, options)
}
export type GetAdventureReviewsQueryHookResult = ReturnType<
  typeof useGetAdventureReviewsQuery
>
export type GetAdventureReviewsLazyQueryHookResult = ReturnType<
  typeof useGetAdventureReviewsLazyQuery
>
export type GetAdventureReviewsSuspenseQueryHookResult = ReturnType<
  typeof useGetAdventureReviewsSuspenseQuery
>
export type GetAdventureReviewsQueryResult = Apollo.QueryResult<
  GQL_GetAdventureReviewsQuery,
  GQL_GetAdventureReviewsQueryVariables
>
export const GetNearbyAdventuresDocument = gql`
  query getNearbyAdventures($id: ID!, $pageSize: Int = 3, $cursor: String) {
    adventure(id: $id) {
      id
      nearbyAdventures(first: $pageSize, after: $cursor) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            ...AdventureCardFragment
          }
        }
      }
    }
  }
  ${AdventureCardFragmentFragmentDoc}
`

/**
 * __useGetNearbyAdventuresQuery__
 *
 * To run a query within a React component, call `useGetNearbyAdventuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNearbyAdventuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNearbyAdventuresQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pageSize: // value for 'pageSize'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetNearbyAdventuresQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetNearbyAdventuresQuery,
    GQL_GetNearbyAdventuresQueryVariables
  > &
    (
      | { variables: GQL_GetNearbyAdventuresQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetNearbyAdventuresQuery,
    GQL_GetNearbyAdventuresQueryVariables
  >(GetNearbyAdventuresDocument, options)
}
export function useGetNearbyAdventuresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetNearbyAdventuresQuery,
    GQL_GetNearbyAdventuresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetNearbyAdventuresQuery,
    GQL_GetNearbyAdventuresQueryVariables
  >(GetNearbyAdventuresDocument, options)
}
// @ts-ignore
export function useGetNearbyAdventuresSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetNearbyAdventuresQuery,
    GQL_GetNearbyAdventuresQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetNearbyAdventuresQuery,
  GQL_GetNearbyAdventuresQueryVariables
>
export function useGetNearbyAdventuresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetNearbyAdventuresQuery,
        GQL_GetNearbyAdventuresQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetNearbyAdventuresQuery | undefined,
  GQL_GetNearbyAdventuresQueryVariables
>
export function useGetNearbyAdventuresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetNearbyAdventuresQuery,
        GQL_GetNearbyAdventuresQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetNearbyAdventuresQuery,
    GQL_GetNearbyAdventuresQueryVariables
  >(GetNearbyAdventuresDocument, options)
}
export type GetNearbyAdventuresQueryHookResult = ReturnType<
  typeof useGetNearbyAdventuresQuery
>
export type GetNearbyAdventuresLazyQueryHookResult = ReturnType<
  typeof useGetNearbyAdventuresLazyQuery
>
export type GetNearbyAdventuresSuspenseQueryHookResult = ReturnType<
  typeof useGetNearbyAdventuresSuspenseQuery
>
export type GetNearbyAdventuresQueryResult = Apollo.QueryResult<
  GQL_GetNearbyAdventuresQuery,
  GQL_GetNearbyAdventuresQueryVariables
>
export const GetBucketListDocument = gql`
  query getBucketList($token: String!) {
    bucketList(token: $token) {
      ...BucketListFragment
      user {
        id
        firstName
      }
    }
  }
  ${BucketListFragmentFragmentDoc}
`

/**
 * __useGetBucketListQuery__
 *
 * To run a query within a React component, call `useGetBucketListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBucketListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBucketListQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetBucketListQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetBucketListQuery,
    GQL_GetBucketListQueryVariables
  > &
    (
      | { variables: GQL_GetBucketListQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetBucketListQuery,
    GQL_GetBucketListQueryVariables
  >(GetBucketListDocument, options)
}
export function useGetBucketListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetBucketListQuery,
    GQL_GetBucketListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetBucketListQuery,
    GQL_GetBucketListQueryVariables
  >(GetBucketListDocument, options)
}
// @ts-ignore
export function useGetBucketListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetBucketListQuery,
    GQL_GetBucketListQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetBucketListQuery,
  GQL_GetBucketListQueryVariables
>
export function useGetBucketListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetBucketListQuery,
        GQL_GetBucketListQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetBucketListQuery | undefined,
  GQL_GetBucketListQueryVariables
>
export function useGetBucketListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetBucketListQuery,
        GQL_GetBucketListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetBucketListQuery,
    GQL_GetBucketListQueryVariables
  >(GetBucketListDocument, options)
}
export type GetBucketListQueryHookResult = ReturnType<
  typeof useGetBucketListQuery
>
export type GetBucketListLazyQueryHookResult = ReturnType<
  typeof useGetBucketListLazyQuery
>
export type GetBucketListSuspenseQueryHookResult = ReturnType<
  typeof useGetBucketListSuspenseQuery
>
export type GetBucketListQueryResult = Apollo.QueryResult<
  GQL_GetBucketListQuery,
  GQL_GetBucketListQueryVariables
>
export const GetBucketListItemsDocument = gql`
  query getBucketListItems(
    $token: String!
    $params: SearchFilters
    $first: Int
    $cursor: String
  ) {
    bucketList(token: $token) {
      id
      items(params: $params, first: $first, after: $cursor) {
        pageInfo {
          endCursor
          hasNextPage
        }
        ...BucketListItemConnection
      }
    }
  }
  ${BucketListItemConnectionFragmentDoc}
`

/**
 * __useGetBucketListItemsQuery__
 *
 * To run a query within a React component, call `useGetBucketListItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBucketListItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBucketListItemsQuery({
 *   variables: {
 *      token: // value for 'token'
 *      params: // value for 'params'
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetBucketListItemsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetBucketListItemsQuery,
    GQL_GetBucketListItemsQueryVariables
  > &
    (
      | { variables: GQL_GetBucketListItemsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetBucketListItemsQuery,
    GQL_GetBucketListItemsQueryVariables
  >(GetBucketListItemsDocument, options)
}
export function useGetBucketListItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetBucketListItemsQuery,
    GQL_GetBucketListItemsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetBucketListItemsQuery,
    GQL_GetBucketListItemsQueryVariables
  >(GetBucketListItemsDocument, options)
}
// @ts-ignore
export function useGetBucketListItemsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetBucketListItemsQuery,
    GQL_GetBucketListItemsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetBucketListItemsQuery,
  GQL_GetBucketListItemsQueryVariables
>
export function useGetBucketListItemsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetBucketListItemsQuery,
        GQL_GetBucketListItemsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetBucketListItemsQuery | undefined,
  GQL_GetBucketListItemsQueryVariables
>
export function useGetBucketListItemsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetBucketListItemsQuery,
        GQL_GetBucketListItemsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetBucketListItemsQuery,
    GQL_GetBucketListItemsQueryVariables
  >(GetBucketListItemsDocument, options)
}
export type GetBucketListItemsQueryHookResult = ReturnType<
  typeof useGetBucketListItemsQuery
>
export type GetBucketListItemsLazyQueryHookResult = ReturnType<
  typeof useGetBucketListItemsLazyQuery
>
export type GetBucketListItemsSuspenseQueryHookResult = ReturnType<
  typeof useGetBucketListItemsSuspenseQuery
>
export type GetBucketListItemsQueryResult = Apollo.QueryResult<
  GQL_GetBucketListItemsQuery,
  GQL_GetBucketListItemsQueryVariables
>
export const GetBucketListMapResultsDocument = gql`
  query getBucketListMapResults($token: String!, $params: SearchFilters) {
    bucketList(token: $token) {
      id
      mapResults(params: $params) {
        ...MapResultFragment
      }
    }
  }
  ${MapResultFragmentFragmentDoc}
`

/**
 * __useGetBucketListMapResultsQuery__
 *
 * To run a query within a React component, call `useGetBucketListMapResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBucketListMapResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBucketListMapResultsQuery({
 *   variables: {
 *      token: // value for 'token'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetBucketListMapResultsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetBucketListMapResultsQuery,
    GQL_GetBucketListMapResultsQueryVariables
  > &
    (
      | { variables: GQL_GetBucketListMapResultsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetBucketListMapResultsQuery,
    GQL_GetBucketListMapResultsQueryVariables
  >(GetBucketListMapResultsDocument, options)
}
export function useGetBucketListMapResultsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetBucketListMapResultsQuery,
    GQL_GetBucketListMapResultsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetBucketListMapResultsQuery,
    GQL_GetBucketListMapResultsQueryVariables
  >(GetBucketListMapResultsDocument, options)
}
// @ts-ignore
export function useGetBucketListMapResultsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetBucketListMapResultsQuery,
    GQL_GetBucketListMapResultsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetBucketListMapResultsQuery,
  GQL_GetBucketListMapResultsQueryVariables
>
export function useGetBucketListMapResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetBucketListMapResultsQuery,
        GQL_GetBucketListMapResultsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetBucketListMapResultsQuery | undefined,
  GQL_GetBucketListMapResultsQueryVariables
>
export function useGetBucketListMapResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetBucketListMapResultsQuery,
        GQL_GetBucketListMapResultsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetBucketListMapResultsQuery,
    GQL_GetBucketListMapResultsQueryVariables
  >(GetBucketListMapResultsDocument, options)
}
export type GetBucketListMapResultsQueryHookResult = ReturnType<
  typeof useGetBucketListMapResultsQuery
>
export type GetBucketListMapResultsLazyQueryHookResult = ReturnType<
  typeof useGetBucketListMapResultsLazyQuery
>
export type GetBucketListMapResultsSuspenseQueryHookResult = ReturnType<
  typeof useGetBucketListMapResultsSuspenseQuery
>
export type GetBucketListMapResultsQueryResult = Apollo.QueryResult<
  GQL_GetBucketListMapResultsQuery,
  GQL_GetBucketListMapResultsQueryVariables
>
export const GetCollectionWithItemsOnlyDocument = gql`
  query getCollectionWithItemsOnly(
    $id: ID!
    $pageSize: Int = 15
    $cursor: String
  ) {
    collection(id: $id) {
      id
      ... on Collection {
        id
        items(first: $pageSize, after: $cursor) {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              photo {
                medium
                large
              }
              item {
                __typename
                ... on Listing {
                  ...ListingCardFragment
                  stories {
                    ...StoryCardFragment
                  }
                }
                ... on Story {
                  ...StoryCardFragment
                  featuredListing {
                    ...StoryFeaturedListingFragment
                  }
                }
                ... on StoryAdventure {
                  ...AdventureCardFragment
                }
                ... on ListingAdventure {
                  ...ListingAdventure
                }
              }
            }
          }
        }
      }
    }
  }
  ${ListingCardFragmentFragmentDoc}
  ${StoryCardFragmentFragmentDoc}
  ${StoryFeaturedListingFragmentFragmentDoc}
  ${AdventureCardFragmentFragmentDoc}
  ${ListingAdventureFragmentDoc}
`

/**
 * __useGetCollectionWithItemsOnlyQuery__
 *
 * To run a query within a React component, call `useGetCollectionWithItemsOnlyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionWithItemsOnlyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionWithItemsOnlyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      pageSize: // value for 'pageSize'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetCollectionWithItemsOnlyQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetCollectionWithItemsOnlyQuery,
    GQL_GetCollectionWithItemsOnlyQueryVariables
  > &
    (
      | {
          variables: GQL_GetCollectionWithItemsOnlyQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetCollectionWithItemsOnlyQuery,
    GQL_GetCollectionWithItemsOnlyQueryVariables
  >(GetCollectionWithItemsOnlyDocument, options)
}
export function useGetCollectionWithItemsOnlyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetCollectionWithItemsOnlyQuery,
    GQL_GetCollectionWithItemsOnlyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetCollectionWithItemsOnlyQuery,
    GQL_GetCollectionWithItemsOnlyQueryVariables
  >(GetCollectionWithItemsOnlyDocument, options)
}
// @ts-ignore
export function useGetCollectionWithItemsOnlySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetCollectionWithItemsOnlyQuery,
    GQL_GetCollectionWithItemsOnlyQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetCollectionWithItemsOnlyQuery,
  GQL_GetCollectionWithItemsOnlyQueryVariables
>
export function useGetCollectionWithItemsOnlySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetCollectionWithItemsOnlyQuery,
        GQL_GetCollectionWithItemsOnlyQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetCollectionWithItemsOnlyQuery | undefined,
  GQL_GetCollectionWithItemsOnlyQueryVariables
>
export function useGetCollectionWithItemsOnlySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetCollectionWithItemsOnlyQuery,
        GQL_GetCollectionWithItemsOnlyQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetCollectionWithItemsOnlyQuery,
    GQL_GetCollectionWithItemsOnlyQueryVariables
  >(GetCollectionWithItemsOnlyDocument, options)
}
export type GetCollectionWithItemsOnlyQueryHookResult = ReturnType<
  typeof useGetCollectionWithItemsOnlyQuery
>
export type GetCollectionWithItemsOnlyLazyQueryHookResult = ReturnType<
  typeof useGetCollectionWithItemsOnlyLazyQuery
>
export type GetCollectionWithItemsOnlySuspenseQueryHookResult = ReturnType<
  typeof useGetCollectionWithItemsOnlySuspenseQuery
>
export type GetCollectionWithItemsOnlyQueryResult = Apollo.QueryResult<
  GQL_GetCollectionWithItemsOnlyQuery,
  GQL_GetCollectionWithItemsOnlyQueryVariables
>
export const GetCollectionsDocument = gql`
  query getCollections($marketId: ID!, $first: Int = 4, $cursor: String) {
    collections(marketId: $marketId, first: $first, after: $cursor) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          ...Collection
        }
      }
    }
  }
  ${CollectionFragmentDoc}
`

/**
 * __useGetCollectionsQuery__
 *
 * To run a query within a React component, call `useGetCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsQuery({
 *   variables: {
 *      marketId: // value for 'marketId'
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetCollectionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetCollectionsQuery,
    GQL_GetCollectionsQueryVariables
  > &
    (
      | { variables: GQL_GetCollectionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetCollectionsQuery,
    GQL_GetCollectionsQueryVariables
  >(GetCollectionsDocument, options)
}
export function useGetCollectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetCollectionsQuery,
    GQL_GetCollectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetCollectionsQuery,
    GQL_GetCollectionsQueryVariables
  >(GetCollectionsDocument, options)
}
// @ts-ignore
export function useGetCollectionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetCollectionsQuery,
    GQL_GetCollectionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetCollectionsQuery,
  GQL_GetCollectionsQueryVariables
>
export function useGetCollectionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetCollectionsQuery,
        GQL_GetCollectionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetCollectionsQuery | undefined,
  GQL_GetCollectionsQueryVariables
>
export function useGetCollectionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetCollectionsQuery,
        GQL_GetCollectionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetCollectionsQuery,
    GQL_GetCollectionsQueryVariables
  >(GetCollectionsDocument, options)
}
export type GetCollectionsQueryHookResult = ReturnType<
  typeof useGetCollectionsQuery
>
export type GetCollectionsLazyQueryHookResult = ReturnType<
  typeof useGetCollectionsLazyQuery
>
export type GetCollectionsSuspenseQueryHookResult = ReturnType<
  typeof useGetCollectionsSuspenseQuery
>
export type GetCollectionsQueryResult = Apollo.QueryResult<
  GQL_GetCollectionsQuery,
  GQL_GetCollectionsQueryVariables
>
export const GetMarketCollectionsDocument = gql`
  query getMarketCollections($marketId: ID!, $first: Int = 100) {
    collections(marketId: $marketId, first: $first) {
      edges {
        node {
          id
          ...Collection
        }
      }
    }
  }
  ${CollectionFragmentDoc}
`

/**
 * __useGetMarketCollectionsQuery__
 *
 * To run a query within a React component, call `useGetMarketCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketCollectionsQuery({
 *   variables: {
 *      marketId: // value for 'marketId'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetMarketCollectionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetMarketCollectionsQuery,
    GQL_GetMarketCollectionsQueryVariables
  > &
    (
      | { variables: GQL_GetMarketCollectionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetMarketCollectionsQuery,
    GQL_GetMarketCollectionsQueryVariables
  >(GetMarketCollectionsDocument, options)
}
export function useGetMarketCollectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetMarketCollectionsQuery,
    GQL_GetMarketCollectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetMarketCollectionsQuery,
    GQL_GetMarketCollectionsQueryVariables
  >(GetMarketCollectionsDocument, options)
}
// @ts-ignore
export function useGetMarketCollectionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetMarketCollectionsQuery,
    GQL_GetMarketCollectionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetMarketCollectionsQuery,
  GQL_GetMarketCollectionsQueryVariables
>
export function useGetMarketCollectionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetMarketCollectionsQuery,
        GQL_GetMarketCollectionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetMarketCollectionsQuery | undefined,
  GQL_GetMarketCollectionsQueryVariables
>
export function useGetMarketCollectionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetMarketCollectionsQuery,
        GQL_GetMarketCollectionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetMarketCollectionsQuery,
    GQL_GetMarketCollectionsQueryVariables
  >(GetMarketCollectionsDocument, options)
}
export type GetMarketCollectionsQueryHookResult = ReturnType<
  typeof useGetMarketCollectionsQuery
>
export type GetMarketCollectionsLazyQueryHookResult = ReturnType<
  typeof useGetMarketCollectionsLazyQuery
>
export type GetMarketCollectionsSuspenseQueryHookResult = ReturnType<
  typeof useGetMarketCollectionsSuspenseQuery
>
export type GetMarketCollectionsQueryResult = Apollo.QueryResult<
  GQL_GetMarketCollectionsQuery,
  GQL_GetMarketCollectionsQueryVariables
>
export const GetGlobalFeaturedAdventuresDocument = gql`
  query getGlobalFeaturedAdventures(
    $country: Countries
    $first: Int
    $cursor: String
  ) {
    featuredAdventures(country: $country, first: $first, after: $cursor) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        node {
          id
          ...AdventureCardFragment
        }
      }
    }
  }
  ${AdventureCardFragmentFragmentDoc}
`

/**
 * __useGetGlobalFeaturedAdventuresQuery__
 *
 * To run a query within a React component, call `useGetGlobalFeaturedAdventuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalFeaturedAdventuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalFeaturedAdventuresQuery({
 *   variables: {
 *      country: // value for 'country'
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetGlobalFeaturedAdventuresQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GQL_GetGlobalFeaturedAdventuresQuery,
    GQL_GetGlobalFeaturedAdventuresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetGlobalFeaturedAdventuresQuery,
    GQL_GetGlobalFeaturedAdventuresQueryVariables
  >(GetGlobalFeaturedAdventuresDocument, options)
}
export function useGetGlobalFeaturedAdventuresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetGlobalFeaturedAdventuresQuery,
    GQL_GetGlobalFeaturedAdventuresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetGlobalFeaturedAdventuresQuery,
    GQL_GetGlobalFeaturedAdventuresQueryVariables
  >(GetGlobalFeaturedAdventuresDocument, options)
}
// @ts-ignore
export function useGetGlobalFeaturedAdventuresSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetGlobalFeaturedAdventuresQuery,
    GQL_GetGlobalFeaturedAdventuresQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetGlobalFeaturedAdventuresQuery,
  GQL_GetGlobalFeaturedAdventuresQueryVariables
>
export function useGetGlobalFeaturedAdventuresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetGlobalFeaturedAdventuresQuery,
        GQL_GetGlobalFeaturedAdventuresQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetGlobalFeaturedAdventuresQuery | undefined,
  GQL_GetGlobalFeaturedAdventuresQueryVariables
>
export function useGetGlobalFeaturedAdventuresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetGlobalFeaturedAdventuresQuery,
        GQL_GetGlobalFeaturedAdventuresQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetGlobalFeaturedAdventuresQuery,
    GQL_GetGlobalFeaturedAdventuresQueryVariables
  >(GetGlobalFeaturedAdventuresDocument, options)
}
export type GetGlobalFeaturedAdventuresQueryHookResult = ReturnType<
  typeof useGetGlobalFeaturedAdventuresQuery
>
export type GetGlobalFeaturedAdventuresLazyQueryHookResult = ReturnType<
  typeof useGetGlobalFeaturedAdventuresLazyQuery
>
export type GetGlobalFeaturedAdventuresSuspenseQueryHookResult = ReturnType<
  typeof useGetGlobalFeaturedAdventuresSuspenseQuery
>
export type GetGlobalFeaturedAdventuresQueryResult = Apollo.QueryResult<
  GQL_GetGlobalFeaturedAdventuresQuery,
  GQL_GetGlobalFeaturedAdventuresQueryVariables
>
export const GetMarketAdventuresDocument = gql`
  query getMarketAdventures(
    $market: MarketCode!
    $first: Int
    $cursor: String
  ) {
    market(code: $market) {
      id
      adventures(first: $first, after: $cursor) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            ...AdventureCardFragment
          }
        }
      }
    }
  }
  ${AdventureCardFragmentFragmentDoc}
`

/**
 * __useGetMarketAdventuresQuery__
 *
 * To run a query within a React component, call `useGetMarketAdventuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketAdventuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketAdventuresQuery({
 *   variables: {
 *      market: // value for 'market'
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetMarketAdventuresQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetMarketAdventuresQuery,
    GQL_GetMarketAdventuresQueryVariables
  > &
    (
      | { variables: GQL_GetMarketAdventuresQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetMarketAdventuresQuery,
    GQL_GetMarketAdventuresQueryVariables
  >(GetMarketAdventuresDocument, options)
}
export function useGetMarketAdventuresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetMarketAdventuresQuery,
    GQL_GetMarketAdventuresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetMarketAdventuresQuery,
    GQL_GetMarketAdventuresQueryVariables
  >(GetMarketAdventuresDocument, options)
}
// @ts-ignore
export function useGetMarketAdventuresSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetMarketAdventuresQuery,
    GQL_GetMarketAdventuresQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetMarketAdventuresQuery,
  GQL_GetMarketAdventuresQueryVariables
>
export function useGetMarketAdventuresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetMarketAdventuresQuery,
        GQL_GetMarketAdventuresQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetMarketAdventuresQuery | undefined,
  GQL_GetMarketAdventuresQueryVariables
>
export function useGetMarketAdventuresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetMarketAdventuresQuery,
        GQL_GetMarketAdventuresQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetMarketAdventuresQuery,
    GQL_GetMarketAdventuresQueryVariables
  >(GetMarketAdventuresDocument, options)
}
export type GetMarketAdventuresQueryHookResult = ReturnType<
  typeof useGetMarketAdventuresQuery
>
export type GetMarketAdventuresLazyQueryHookResult = ReturnType<
  typeof useGetMarketAdventuresLazyQuery
>
export type GetMarketAdventuresSuspenseQueryHookResult = ReturnType<
  typeof useGetMarketAdventuresSuspenseQuery
>
export type GetMarketAdventuresQueryResult = Apollo.QueryResult<
  GQL_GetMarketAdventuresQuery,
  GQL_GetMarketAdventuresQueryVariables
>
export const GetGlobalFeaturedCollectionsDocument = gql`
  query getGlobalFeaturedCollections(
    $country: Countries
    $first: Int
    $cursor: String
  ) {
    featuredCollections(country: $country, first: $first, after: $cursor) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          ...Collection
        }
      }
    }
  }
  ${CollectionFragmentDoc}
`

/**
 * __useGetGlobalFeaturedCollectionsQuery__
 *
 * To run a query within a React component, call `useGetGlobalFeaturedCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalFeaturedCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalFeaturedCollectionsQuery({
 *   variables: {
 *      country: // value for 'country'
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetGlobalFeaturedCollectionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GQL_GetGlobalFeaturedCollectionsQuery,
    GQL_GetGlobalFeaturedCollectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetGlobalFeaturedCollectionsQuery,
    GQL_GetGlobalFeaturedCollectionsQueryVariables
  >(GetGlobalFeaturedCollectionsDocument, options)
}
export function useGetGlobalFeaturedCollectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetGlobalFeaturedCollectionsQuery,
    GQL_GetGlobalFeaturedCollectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetGlobalFeaturedCollectionsQuery,
    GQL_GetGlobalFeaturedCollectionsQueryVariables
  >(GetGlobalFeaturedCollectionsDocument, options)
}
// @ts-ignore
export function useGetGlobalFeaturedCollectionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetGlobalFeaturedCollectionsQuery,
    GQL_GetGlobalFeaturedCollectionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetGlobalFeaturedCollectionsQuery,
  GQL_GetGlobalFeaturedCollectionsQueryVariables
>
export function useGetGlobalFeaturedCollectionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetGlobalFeaturedCollectionsQuery,
        GQL_GetGlobalFeaturedCollectionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetGlobalFeaturedCollectionsQuery | undefined,
  GQL_GetGlobalFeaturedCollectionsQueryVariables
>
export function useGetGlobalFeaturedCollectionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetGlobalFeaturedCollectionsQuery,
        GQL_GetGlobalFeaturedCollectionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetGlobalFeaturedCollectionsQuery,
    GQL_GetGlobalFeaturedCollectionsQueryVariables
  >(GetGlobalFeaturedCollectionsDocument, options)
}
export type GetGlobalFeaturedCollectionsQueryHookResult = ReturnType<
  typeof useGetGlobalFeaturedCollectionsQuery
>
export type GetGlobalFeaturedCollectionsLazyQueryHookResult = ReturnType<
  typeof useGetGlobalFeaturedCollectionsLazyQuery
>
export type GetGlobalFeaturedCollectionsSuspenseQueryHookResult = ReturnType<
  typeof useGetGlobalFeaturedCollectionsSuspenseQuery
>
export type GetGlobalFeaturedCollectionsQueryResult = Apollo.QueryResult<
  GQL_GetGlobalFeaturedCollectionsQuery,
  GQL_GetGlobalFeaturedCollectionsQueryVariables
>
export const GetMarketFeaturedCollectionsDocument = gql`
  query getMarketFeaturedCollections(
    $market: MarketCode!
    $first: Int
    $cursor: String
  ) {
    market(code: $market) {
      id
      featuredCollections(first: $first, after: $cursor) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            ...Collection
          }
        }
      }
    }
  }
  ${CollectionFragmentDoc}
`

/**
 * __useGetMarketFeaturedCollectionsQuery__
 *
 * To run a query within a React component, call `useGetMarketFeaturedCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketFeaturedCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketFeaturedCollectionsQuery({
 *   variables: {
 *      market: // value for 'market'
 *      first: // value for 'first'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetMarketFeaturedCollectionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetMarketFeaturedCollectionsQuery,
    GQL_GetMarketFeaturedCollectionsQueryVariables
  > &
    (
      | {
          variables: GQL_GetMarketFeaturedCollectionsQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetMarketFeaturedCollectionsQuery,
    GQL_GetMarketFeaturedCollectionsQueryVariables
  >(GetMarketFeaturedCollectionsDocument, options)
}
export function useGetMarketFeaturedCollectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetMarketFeaturedCollectionsQuery,
    GQL_GetMarketFeaturedCollectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetMarketFeaturedCollectionsQuery,
    GQL_GetMarketFeaturedCollectionsQueryVariables
  >(GetMarketFeaturedCollectionsDocument, options)
}
// @ts-ignore
export function useGetMarketFeaturedCollectionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetMarketFeaturedCollectionsQuery,
    GQL_GetMarketFeaturedCollectionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetMarketFeaturedCollectionsQuery,
  GQL_GetMarketFeaturedCollectionsQueryVariables
>
export function useGetMarketFeaturedCollectionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetMarketFeaturedCollectionsQuery,
        GQL_GetMarketFeaturedCollectionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetMarketFeaturedCollectionsQuery | undefined,
  GQL_GetMarketFeaturedCollectionsQueryVariables
>
export function useGetMarketFeaturedCollectionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetMarketFeaturedCollectionsQuery,
        GQL_GetMarketFeaturedCollectionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetMarketFeaturedCollectionsQuery,
    GQL_GetMarketFeaturedCollectionsQueryVariables
  >(GetMarketFeaturedCollectionsDocument, options)
}
export type GetMarketFeaturedCollectionsQueryHookResult = ReturnType<
  typeof useGetMarketFeaturedCollectionsQuery
>
export type GetMarketFeaturedCollectionsLazyQueryHookResult = ReturnType<
  typeof useGetMarketFeaturedCollectionsLazyQuery
>
export type GetMarketFeaturedCollectionsSuspenseQueryHookResult = ReturnType<
  typeof useGetMarketFeaturedCollectionsSuspenseQuery
>
export type GetMarketFeaturedCollectionsQueryResult = Apollo.QueryResult<
  GQL_GetMarketFeaturedCollectionsQuery,
  GQL_GetMarketFeaturedCollectionsQueryVariables
>
export const GetListingAdventuresByProximityDocument = gql`
  query getListingAdventuresByProximity(
    $afterCursor: String
    $beforeCursor: String
    $listingId: ID!
  ) {
    listing(id: $listingId) {
      id
      adventuresByProximity(
        after: $afterCursor
        before: $beforeCursor
        first: 6
      ) {
        pageInfo {
          hasNextPage
          hasPreviousPage
          endCursor
          startCursor
        }
        edges {
          node {
            ...ListingNearbyAdventure
          }
        }
      }
    }
  }
  ${ListingNearbyAdventureFragmentDoc}
`

/**
 * __useGetListingAdventuresByProximityQuery__
 *
 * To run a query within a React component, call `useGetListingAdventuresByProximityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListingAdventuresByProximityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListingAdventuresByProximityQuery({
 *   variables: {
 *      afterCursor: // value for 'afterCursor'
 *      beforeCursor: // value for 'beforeCursor'
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useGetListingAdventuresByProximityQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetListingAdventuresByProximityQuery,
    GQL_GetListingAdventuresByProximityQueryVariables
  > &
    (
      | {
          variables: GQL_GetListingAdventuresByProximityQueryVariables
          skip?: boolean
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetListingAdventuresByProximityQuery,
    GQL_GetListingAdventuresByProximityQueryVariables
  >(GetListingAdventuresByProximityDocument, options)
}
export function useGetListingAdventuresByProximityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetListingAdventuresByProximityQuery,
    GQL_GetListingAdventuresByProximityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetListingAdventuresByProximityQuery,
    GQL_GetListingAdventuresByProximityQueryVariables
  >(GetListingAdventuresByProximityDocument, options)
}
// @ts-ignore
export function useGetListingAdventuresByProximitySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetListingAdventuresByProximityQuery,
    GQL_GetListingAdventuresByProximityQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetListingAdventuresByProximityQuery,
  GQL_GetListingAdventuresByProximityQueryVariables
>
export function useGetListingAdventuresByProximitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetListingAdventuresByProximityQuery,
        GQL_GetListingAdventuresByProximityQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetListingAdventuresByProximityQuery | undefined,
  GQL_GetListingAdventuresByProximityQueryVariables
>
export function useGetListingAdventuresByProximitySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetListingAdventuresByProximityQuery,
        GQL_GetListingAdventuresByProximityQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetListingAdventuresByProximityQuery,
    GQL_GetListingAdventuresByProximityQueryVariables
  >(GetListingAdventuresByProximityDocument, options)
}
export type GetListingAdventuresByProximityQueryHookResult = ReturnType<
  typeof useGetListingAdventuresByProximityQuery
>
export type GetListingAdventuresByProximityLazyQueryHookResult = ReturnType<
  typeof useGetListingAdventuresByProximityLazyQuery
>
export type GetListingAdventuresByProximitySuspenseQueryHookResult = ReturnType<
  typeof useGetListingAdventuresByProximitySuspenseQuery
>
export type GetListingAdventuresByProximityQueryResult = Apollo.QueryResult<
  GQL_GetListingAdventuresByProximityQuery,
  GQL_GetListingAdventuresByProximityQueryVariables
>
export const GetListingPhotosDocument = gql`
  query getListingPhotos($listingId: ID!) {
    listing(id: $listingId) {
      id
      title
      price
      nicePricingSuffix
      photos {
        image {
          large
        }
        aspectRatio
      }
    }
  }
`

/**
 * __useGetListingPhotosQuery__
 *
 * To run a query within a React component, call `useGetListingPhotosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListingPhotosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListingPhotosQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *   },
 * });
 */
export function useGetListingPhotosQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetListingPhotosQuery,
    GQL_GetListingPhotosQueryVariables
  > &
    (
      | { variables: GQL_GetListingPhotosQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetListingPhotosQuery,
    GQL_GetListingPhotosQueryVariables
  >(GetListingPhotosDocument, options)
}
export function useGetListingPhotosLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetListingPhotosQuery,
    GQL_GetListingPhotosQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetListingPhotosQuery,
    GQL_GetListingPhotosQueryVariables
  >(GetListingPhotosDocument, options)
}
// @ts-ignore
export function useGetListingPhotosSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetListingPhotosQuery,
    GQL_GetListingPhotosQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetListingPhotosQuery,
  GQL_GetListingPhotosQueryVariables
>
export function useGetListingPhotosSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetListingPhotosQuery,
        GQL_GetListingPhotosQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetListingPhotosQuery | undefined,
  GQL_GetListingPhotosQueryVariables
>
export function useGetListingPhotosSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetListingPhotosQuery,
        GQL_GetListingPhotosQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetListingPhotosQuery,
    GQL_GetListingPhotosQueryVariables
  >(GetListingPhotosDocument, options)
}
export type GetListingPhotosQueryHookResult = ReturnType<
  typeof useGetListingPhotosQuery
>
export type GetListingPhotosLazyQueryHookResult = ReturnType<
  typeof useGetListingPhotosLazyQuery
>
export type GetListingPhotosSuspenseQueryHookResult = ReturnType<
  typeof useGetListingPhotosSuspenseQuery
>
export type GetListingPhotosQueryResult = Apollo.QueryResult<
  GQL_GetListingPhotosQuery,
  GQL_GetListingPhotosQueryVariables
>
export const GetMarketServiceRatesDocument = gql`
  query getMarketServiceRates($code: MarketCode!) {
    market(code: $code) {
      id
      customerServiceFeeBaseRate
      hostServiceFeeBaseRate
    }
  }
`

/**
 * __useGetMarketServiceRatesQuery__
 *
 * To run a query within a React component, call `useGetMarketServiceRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketServiceRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketServiceRatesQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetMarketServiceRatesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetMarketServiceRatesQuery,
    GQL_GetMarketServiceRatesQueryVariables
  > &
    (
      | { variables: GQL_GetMarketServiceRatesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetMarketServiceRatesQuery,
    GQL_GetMarketServiceRatesQueryVariables
  >(GetMarketServiceRatesDocument, options)
}
export function useGetMarketServiceRatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetMarketServiceRatesQuery,
    GQL_GetMarketServiceRatesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetMarketServiceRatesQuery,
    GQL_GetMarketServiceRatesQueryVariables
  >(GetMarketServiceRatesDocument, options)
}
// @ts-ignore
export function useGetMarketServiceRatesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetMarketServiceRatesQuery,
    GQL_GetMarketServiceRatesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetMarketServiceRatesQuery,
  GQL_GetMarketServiceRatesQueryVariables
>
export function useGetMarketServiceRatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetMarketServiceRatesQuery,
        GQL_GetMarketServiceRatesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetMarketServiceRatesQuery | undefined,
  GQL_GetMarketServiceRatesQueryVariables
>
export function useGetMarketServiceRatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetMarketServiceRatesQuery,
        GQL_GetMarketServiceRatesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetMarketServiceRatesQuery,
    GQL_GetMarketServiceRatesQueryVariables
  >(GetMarketServiceRatesDocument, options)
}
export type GetMarketServiceRatesQueryHookResult = ReturnType<
  typeof useGetMarketServiceRatesQuery
>
export type GetMarketServiceRatesLazyQueryHookResult = ReturnType<
  typeof useGetMarketServiceRatesLazyQuery
>
export type GetMarketServiceRatesSuspenseQueryHookResult = ReturnType<
  typeof useGetMarketServiceRatesSuspenseQuery
>
export type GetMarketServiceRatesQueryResult = Apollo.QueryResult<
  GQL_GetMarketServiceRatesQuery,
  GQL_GetMarketServiceRatesQueryVariables
>
export const GetListingReviewsDocument = gql`
  query getListingReviews($listingId: ID!, $cursor: String) {
    listing(id: $listingId) {
      id
      reviews(first: 3, after: $cursor) {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            ...ListingReview
          }
        }
      }
    }
  }
  ${ListingReviewFragmentDoc}
`

/**
 * __useGetListingReviewsQuery__
 *
 * To run a query within a React component, call `useGetListingReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListingReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListingReviewsQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetListingReviewsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetListingReviewsQuery,
    GQL_GetListingReviewsQueryVariables
  > &
    (
      | { variables: GQL_GetListingReviewsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetListingReviewsQuery,
    GQL_GetListingReviewsQueryVariables
  >(GetListingReviewsDocument, options)
}
export function useGetListingReviewsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetListingReviewsQuery,
    GQL_GetListingReviewsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetListingReviewsQuery,
    GQL_GetListingReviewsQueryVariables
  >(GetListingReviewsDocument, options)
}
// @ts-ignore
export function useGetListingReviewsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetListingReviewsQuery,
    GQL_GetListingReviewsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetListingReviewsQuery,
  GQL_GetListingReviewsQueryVariables
>
export function useGetListingReviewsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetListingReviewsQuery,
        GQL_GetListingReviewsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetListingReviewsQuery | undefined,
  GQL_GetListingReviewsQueryVariables
>
export function useGetListingReviewsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetListingReviewsQuery,
        GQL_GetListingReviewsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetListingReviewsQuery,
    GQL_GetListingReviewsQueryVariables
  >(GetListingReviewsDocument, options)
}
export type GetListingReviewsQueryHookResult = ReturnType<
  typeof useGetListingReviewsQuery
>
export type GetListingReviewsLazyQueryHookResult = ReturnType<
  typeof useGetListingReviewsLazyQuery
>
export type GetListingReviewsSuspenseQueryHookResult = ReturnType<
  typeof useGetListingReviewsSuspenseQuery
>
export type GetListingReviewsQueryResult = Apollo.QueryResult<
  GQL_GetListingReviewsQuery,
  GQL_GetListingReviewsQueryVariables
>
export const GetCustomerReferralDocument = gql`
  query getCustomerReferral($token: String!) {
    customerReferral(token: $token) {
      recipientFirstName
      referrer {
        firstName
        avatar {
          original
          thumbLg
        }
      }
      referralVoucher {
        code
        amount
        expiresAt
      }
      message
    }
  }
`

/**
 * __useGetCustomerReferralQuery__
 *
 * To run a query within a React component, call `useGetCustomerReferralQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerReferralQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerReferralQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetCustomerReferralQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_GetCustomerReferralQuery,
    GQL_GetCustomerReferralQueryVariables
  > &
    (
      | { variables: GQL_GetCustomerReferralQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetCustomerReferralQuery,
    GQL_GetCustomerReferralQueryVariables
  >(GetCustomerReferralDocument, options)
}
export function useGetCustomerReferralLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetCustomerReferralQuery,
    GQL_GetCustomerReferralQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetCustomerReferralQuery,
    GQL_GetCustomerReferralQueryVariables
  >(GetCustomerReferralDocument, options)
}
// @ts-ignore
export function useGetCustomerReferralSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetCustomerReferralQuery,
    GQL_GetCustomerReferralQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetCustomerReferralQuery,
  GQL_GetCustomerReferralQueryVariables
>
export function useGetCustomerReferralSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetCustomerReferralQuery,
        GQL_GetCustomerReferralQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetCustomerReferralQuery | undefined,
  GQL_GetCustomerReferralQueryVariables
>
export function useGetCustomerReferralSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetCustomerReferralQuery,
        GQL_GetCustomerReferralQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetCustomerReferralQuery,
    GQL_GetCustomerReferralQueryVariables
  >(GetCustomerReferralDocument, options)
}
export type GetCustomerReferralQueryHookResult = ReturnType<
  typeof useGetCustomerReferralQuery
>
export type GetCustomerReferralLazyQueryHookResult = ReturnType<
  typeof useGetCustomerReferralLazyQuery
>
export type GetCustomerReferralSuspenseQueryHookResult = ReturnType<
  typeof useGetCustomerReferralSuspenseQuery
>
export type GetCustomerReferralQueryResult = Apollo.QueryResult<
  GQL_GetCustomerReferralQuery,
  GQL_GetCustomerReferralQueryVariables
>
export const RegionAdventuresDocument = gql`
  query RegionAdventures($regionId: ID!, $cursor: String) {
    region(id: $regionId) {
      adventures(first: 4, after: $cursor) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            ...AdventureCardFragment
          }
        }
      }
    }
  }
  ${AdventureCardFragmentFragmentDoc}
`

/**
 * __useRegionAdventuresQuery__
 *
 * To run a query within a React component, call `useRegionAdventuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegionAdventuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegionAdventuresQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useRegionAdventuresQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_RegionAdventuresQuery,
    GQL_RegionAdventuresQueryVariables
  > &
    (
      | { variables: GQL_RegionAdventuresQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_RegionAdventuresQuery,
    GQL_RegionAdventuresQueryVariables
  >(RegionAdventuresDocument, options)
}
export function useRegionAdventuresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_RegionAdventuresQuery,
    GQL_RegionAdventuresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_RegionAdventuresQuery,
    GQL_RegionAdventuresQueryVariables
  >(RegionAdventuresDocument, options)
}
// @ts-ignore
export function useRegionAdventuresSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_RegionAdventuresQuery,
    GQL_RegionAdventuresQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_RegionAdventuresQuery,
  GQL_RegionAdventuresQueryVariables
>
export function useRegionAdventuresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_RegionAdventuresQuery,
        GQL_RegionAdventuresQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_RegionAdventuresQuery | undefined,
  GQL_RegionAdventuresQueryVariables
>
export function useRegionAdventuresSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_RegionAdventuresQuery,
        GQL_RegionAdventuresQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_RegionAdventuresQuery,
    GQL_RegionAdventuresQueryVariables
  >(RegionAdventuresDocument, options)
}
export type RegionAdventuresQueryHookResult = ReturnType<
  typeof useRegionAdventuresQuery
>
export type RegionAdventuresLazyQueryHookResult = ReturnType<
  typeof useRegionAdventuresLazyQuery
>
export type RegionAdventuresSuspenseQueryHookResult = ReturnType<
  typeof useRegionAdventuresSuspenseQuery
>
export type RegionAdventuresQueryResult = Apollo.QueryResult<
  GQL_RegionAdventuresQuery,
  GQL_RegionAdventuresQueryVariables
>
export const ExploreRegionDocument = gql`
  query exploreRegion($market: MarketCode!, $regionId: ID!) {
    explore(market: $market) {
      region(id: $regionId) {
        id
        slug
        name
        state {
          code
        }
        stories(max: 12) {
          ...StoryCardFragment
          featuredListing {
            ...StoryFeaturedListingFragment
          }
        }
      }
    }
  }
  ${StoryCardFragmentFragmentDoc}
  ${StoryFeaturedListingFragmentFragmentDoc}
`

/**
 * __useExploreRegionQuery__
 *
 * To run a query within a React component, call `useExploreRegionQuery` and pass it any options that fit your needs.
 * When your component renders, `useExploreRegionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExploreRegionQuery({
 *   variables: {
 *      market: // value for 'market'
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useExploreRegionQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_ExploreRegionQuery,
    GQL_ExploreRegionQueryVariables
  > &
    (
      | { variables: GQL_ExploreRegionQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_ExploreRegionQuery,
    GQL_ExploreRegionQueryVariables
  >(ExploreRegionDocument, options)
}
export function useExploreRegionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_ExploreRegionQuery,
    GQL_ExploreRegionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_ExploreRegionQuery,
    GQL_ExploreRegionQueryVariables
  >(ExploreRegionDocument, options)
}
// @ts-ignore
export function useExploreRegionSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_ExploreRegionQuery,
    GQL_ExploreRegionQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_ExploreRegionQuery,
  GQL_ExploreRegionQueryVariables
>
export function useExploreRegionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_ExploreRegionQuery,
        GQL_ExploreRegionQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_ExploreRegionQuery | undefined,
  GQL_ExploreRegionQueryVariables
>
export function useExploreRegionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_ExploreRegionQuery,
        GQL_ExploreRegionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_ExploreRegionQuery,
    GQL_ExploreRegionQueryVariables
  >(ExploreRegionDocument, options)
}
export type ExploreRegionQueryHookResult = ReturnType<
  typeof useExploreRegionQuery
>
export type ExploreRegionLazyQueryHookResult = ReturnType<
  typeof useExploreRegionLazyQuery
>
export type ExploreRegionSuspenseQueryHookResult = ReturnType<
  typeof useExploreRegionSuspenseQuery
>
export type ExploreRegionQueryResult = Apollo.QueryResult<
  GQL_ExploreRegionQuery,
  GQL_ExploreRegionQueryVariables
>
export const RegionTrendingListingsDocument = gql`
  query RegionTrendingListings($market: MarketCode!, $regionId: ID!) {
    explore(market: $market) {
      region(id: $regionId) {
        id
        trendingListings(max: 9) {
          ...ListingCardFragment
        }
      }
    }
  }
  ${ListingCardFragmentFragmentDoc}
`

/**
 * __useRegionTrendingListingsQuery__
 *
 * To run a query within a React component, call `useRegionTrendingListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegionTrendingListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegionTrendingListingsQuery({
 *   variables: {
 *      market: // value for 'market'
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useRegionTrendingListingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_RegionTrendingListingsQuery,
    GQL_RegionTrendingListingsQueryVariables
  > &
    (
      | { variables: GQL_RegionTrendingListingsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_RegionTrendingListingsQuery,
    GQL_RegionTrendingListingsQueryVariables
  >(RegionTrendingListingsDocument, options)
}
export function useRegionTrendingListingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_RegionTrendingListingsQuery,
    GQL_RegionTrendingListingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_RegionTrendingListingsQuery,
    GQL_RegionTrendingListingsQueryVariables
  >(RegionTrendingListingsDocument, options)
}
// @ts-ignore
export function useRegionTrendingListingsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_RegionTrendingListingsQuery,
    GQL_RegionTrendingListingsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_RegionTrendingListingsQuery,
  GQL_RegionTrendingListingsQueryVariables
>
export function useRegionTrendingListingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_RegionTrendingListingsQuery,
        GQL_RegionTrendingListingsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_RegionTrendingListingsQuery | undefined,
  GQL_RegionTrendingListingsQueryVariables
>
export function useRegionTrendingListingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_RegionTrendingListingsQuery,
        GQL_RegionTrendingListingsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_RegionTrendingListingsQuery,
    GQL_RegionTrendingListingsQueryVariables
  >(RegionTrendingListingsDocument, options)
}
export type RegionTrendingListingsQueryHookResult = ReturnType<
  typeof useRegionTrendingListingsQuery
>
export type RegionTrendingListingsLazyQueryHookResult = ReturnType<
  typeof useRegionTrendingListingsLazyQuery
>
export type RegionTrendingListingsSuspenseQueryHookResult = ReturnType<
  typeof useRegionTrendingListingsSuspenseQuery
>
export type RegionTrendingListingsQueryResult = Apollo.QueryResult<
  GQL_RegionTrendingListingsQuery,
  GQL_RegionTrendingListingsQueryVariables
>
export const PaginateUserListingsDocument = gql`
  query PaginateUserListings($id: ID!, $first: Int = 12, $after: String) {
    user(id: $id) {
      id
      listings(first: $first, after: $after) {
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          cursor
          node {
            ...ListingCardFragment
          }
        }
      }
    }
  }
  ${ListingCardFragmentFragmentDoc}
`

/**
 * __usePaginateUserListingsQuery__
 *
 * To run a query within a React component, call `usePaginateUserListingsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginateUserListingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginateUserListingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePaginateUserListingsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_PaginateUserListingsQuery,
    GQL_PaginateUserListingsQueryVariables
  > &
    (
      | { variables: GQL_PaginateUserListingsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_PaginateUserListingsQuery,
    GQL_PaginateUserListingsQueryVariables
  >(PaginateUserListingsDocument, options)
}
export function usePaginateUserListingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_PaginateUserListingsQuery,
    GQL_PaginateUserListingsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_PaginateUserListingsQuery,
    GQL_PaginateUserListingsQueryVariables
  >(PaginateUserListingsDocument, options)
}
// @ts-ignore
export function usePaginateUserListingsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_PaginateUserListingsQuery,
    GQL_PaginateUserListingsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_PaginateUserListingsQuery,
  GQL_PaginateUserListingsQueryVariables
>
export function usePaginateUserListingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_PaginateUserListingsQuery,
        GQL_PaginateUserListingsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_PaginateUserListingsQuery | undefined,
  GQL_PaginateUserListingsQueryVariables
>
export function usePaginateUserListingsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_PaginateUserListingsQuery,
        GQL_PaginateUserListingsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_PaginateUserListingsQuery,
    GQL_PaginateUserListingsQueryVariables
  >(PaginateUserListingsDocument, options)
}
export type PaginateUserListingsQueryHookResult = ReturnType<
  typeof usePaginateUserListingsQuery
>
export type PaginateUserListingsLazyQueryHookResult = ReturnType<
  typeof usePaginateUserListingsLazyQuery
>
export type PaginateUserListingsSuspenseQueryHookResult = ReturnType<
  typeof usePaginateUserListingsSuspenseQuery
>
export type PaginateUserListingsQueryResult = Apollo.QueryResult<
  GQL_PaginateUserListingsQuery,
  GQL_PaginateUserListingsQueryVariables
>
export const PaginateUserReviewsDocument = gql`
  query PaginateUserReviews($id: ID!, $first: Int = 6, $after: String) {
    user(id: $id) {
      id
      reviews(first: $first, after: $after) {
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          cursor
          node {
            ...ListingReview
          }
        }
      }
    }
  }
  ${ListingReviewFragmentDoc}
`

/**
 * __usePaginateUserReviewsQuery__
 *
 * To run a query within a React component, call `usePaginateUserReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginateUserReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginateUserReviewsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePaginateUserReviewsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_PaginateUserReviewsQuery,
    GQL_PaginateUserReviewsQueryVariables
  > &
    (
      | { variables: GQL_PaginateUserReviewsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_PaginateUserReviewsQuery,
    GQL_PaginateUserReviewsQueryVariables
  >(PaginateUserReviewsDocument, options)
}
export function usePaginateUserReviewsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_PaginateUserReviewsQuery,
    GQL_PaginateUserReviewsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_PaginateUserReviewsQuery,
    GQL_PaginateUserReviewsQueryVariables
  >(PaginateUserReviewsDocument, options)
}
// @ts-ignore
export function usePaginateUserReviewsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_PaginateUserReviewsQuery,
    GQL_PaginateUserReviewsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_PaginateUserReviewsQuery,
  GQL_PaginateUserReviewsQueryVariables
>
export function usePaginateUserReviewsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_PaginateUserReviewsQuery,
        GQL_PaginateUserReviewsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_PaginateUserReviewsQuery | undefined,
  GQL_PaginateUserReviewsQueryVariables
>
export function usePaginateUserReviewsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_PaginateUserReviewsQuery,
        GQL_PaginateUserReviewsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_PaginateUserReviewsQuery,
    GQL_PaginateUserReviewsQueryVariables
  >(PaginateUserReviewsDocument, options)
}
export type PaginateUserReviewsQueryHookResult = ReturnType<
  typeof usePaginateUserReviewsQuery
>
export type PaginateUserReviewsLazyQueryHookResult = ReturnType<
  typeof usePaginateUserReviewsLazyQuery
>
export type PaginateUserReviewsSuspenseQueryHookResult = ReturnType<
  typeof usePaginateUserReviewsSuspenseQuery
>
export type PaginateUserReviewsQueryResult = Apollo.QueryResult<
  GQL_PaginateUserReviewsQuery,
  GQL_PaginateUserReviewsQueryVariables
>
export const PaginateUserStoriesDocument = gql`
  query PaginateUserStories($id: ID!, $first: Int = 12, $after: String) {
    user(id: $id) {
      id
      stories(first: $first, after: $after) {
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          cursor
          node {
            ...StoryCardFragment
            featuredListing {
              ...StoryFeaturedListingFragment
            }
          }
        }
      }
    }
  }
  ${StoryCardFragmentFragmentDoc}
  ${StoryFeaturedListingFragmentFragmentDoc}
`

/**
 * __usePaginateUserStoriesQuery__
 *
 * To run a query within a React component, call `usePaginateUserStoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginateUserStoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginateUserStoriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePaginateUserStoriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_PaginateUserStoriesQuery,
    GQL_PaginateUserStoriesQueryVariables
  > &
    (
      | { variables: GQL_PaginateUserStoriesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_PaginateUserStoriesQuery,
    GQL_PaginateUserStoriesQueryVariables
  >(PaginateUserStoriesDocument, options)
}
export function usePaginateUserStoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_PaginateUserStoriesQuery,
    GQL_PaginateUserStoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_PaginateUserStoriesQuery,
    GQL_PaginateUserStoriesQueryVariables
  >(PaginateUserStoriesDocument, options)
}
// @ts-ignore
export function usePaginateUserStoriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_PaginateUserStoriesQuery,
    GQL_PaginateUserStoriesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_PaginateUserStoriesQuery,
  GQL_PaginateUserStoriesQueryVariables
>
export function usePaginateUserStoriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_PaginateUserStoriesQuery,
        GQL_PaginateUserStoriesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_PaginateUserStoriesQuery | undefined,
  GQL_PaginateUserStoriesQueryVariables
>
export function usePaginateUserStoriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_PaginateUserStoriesQuery,
        GQL_PaginateUserStoriesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_PaginateUserStoriesQuery,
    GQL_PaginateUserStoriesQueryVariables
  >(PaginateUserStoriesDocument, options)
}
export type PaginateUserStoriesQueryHookResult = ReturnType<
  typeof usePaginateUserStoriesQuery
>
export type PaginateUserStoriesLazyQueryHookResult = ReturnType<
  typeof usePaginateUserStoriesLazyQuery
>
export type PaginateUserStoriesSuspenseQueryHookResult = ReturnType<
  typeof usePaginateUserStoriesSuspenseQuery
>
export type PaginateUserStoriesQueryResult = Apollo.QueryResult<
  GQL_PaginateUserStoriesQuery,
  GQL_PaginateUserStoriesQueryVariables
>
export const UserProfileSectionsDocument = gql`
  query UserProfileSections(
    $id: ID!
    $storiesFirst: Int = 12
    $storiesCursor: String
    $listingsFirst: Int = 12
    $listingsCursor: String
    $reviewsFirst: Int = 6
    $reviewsCursor: String
  ) {
    user(id: $id) {
      id
      stories(first: $storiesFirst, after: $storiesCursor) {
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          cursor
          node {
            ...StoryCardFragment
            featuredListing {
              ...StoryFeaturedListingFragment
            }
          }
        }
      }
      listings(first: $listingsFirst, after: $listingsCursor) {
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          cursor
          node {
            ...ListingCardFragment
          }
        }
      }
      reviews(first: $reviewsFirst, after: $reviewsCursor) {
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          cursor
          node {
            ...ListingReview
          }
        }
      }
    }
  }
  ${StoryCardFragmentFragmentDoc}
  ${StoryFeaturedListingFragmentFragmentDoc}
  ${ListingCardFragmentFragmentDoc}
  ${ListingReviewFragmentDoc}
`

/**
 * __useUserProfileSectionsQuery__
 *
 * To run a query within a React component, call `useUserProfileSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileSectionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      storiesFirst: // value for 'storiesFirst'
 *      storiesCursor: // value for 'storiesCursor'
 *      listingsFirst: // value for 'listingsFirst'
 *      listingsCursor: // value for 'listingsCursor'
 *      reviewsFirst: // value for 'reviewsFirst'
 *      reviewsCursor: // value for 'reviewsCursor'
 *   },
 * });
 */
export function useUserProfileSectionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_UserProfileSectionsQuery,
    GQL_UserProfileSectionsQueryVariables
  > &
    (
      | { variables: GQL_UserProfileSectionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_UserProfileSectionsQuery,
    GQL_UserProfileSectionsQueryVariables
  >(UserProfileSectionsDocument, options)
}
export function useUserProfileSectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_UserProfileSectionsQuery,
    GQL_UserProfileSectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_UserProfileSectionsQuery,
    GQL_UserProfileSectionsQueryVariables
  >(UserProfileSectionsDocument, options)
}
// @ts-ignore
export function useUserProfileSectionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_UserProfileSectionsQuery,
    GQL_UserProfileSectionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_UserProfileSectionsQuery,
  GQL_UserProfileSectionsQueryVariables
>
export function useUserProfileSectionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_UserProfileSectionsQuery,
        GQL_UserProfileSectionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_UserProfileSectionsQuery | undefined,
  GQL_UserProfileSectionsQueryVariables
>
export function useUserProfileSectionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_UserProfileSectionsQuery,
        GQL_UserProfileSectionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_UserProfileSectionsQuery,
    GQL_UserProfileSectionsQueryVariables
  >(UserProfileSectionsDocument, options)
}
export type UserProfileSectionsQueryHookResult = ReturnType<
  typeof useUserProfileSectionsQuery
>
export type UserProfileSectionsLazyQueryHookResult = ReturnType<
  typeof useUserProfileSectionsLazyQuery
>
export type UserProfileSectionsSuspenseQueryHookResult = ReturnType<
  typeof useUserProfileSectionsSuspenseQuery
>
export type UserProfileSectionsQueryResult = Apollo.QueryResult<
  GQL_UserProfileSectionsQuery,
  GQL_UserProfileSectionsQueryVariables
>
export const CreateCustomerReferralDocument = gql`
  mutation createCustomerReferral(
    $customerReferralInput: CustomerReferralInput!
  ) {
    createCustomerReferral(customerReferralInput: $customerReferralInput) {
      customerReferral {
        ...CustomerReferral
      }
    }
  }
  ${CustomerReferralFragmentDoc}
`
export type GQL_CreateCustomerReferralMutationFn = Apollo.MutationFunction<
  GQL_CreateCustomerReferralMutation,
  GQL_CreateCustomerReferralMutationVariables
>

/**
 * __useCreateCustomerReferralMutation__
 *
 * To run a mutation, you first call `useCreateCustomerReferralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerReferralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerReferralMutation, { data, loading, error }] = useCreateCustomerReferralMutation({
 *   variables: {
 *      customerReferralInput: // value for 'customerReferralInput'
 *   },
 * });
 */
export function useCreateCustomerReferralMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_CreateCustomerReferralMutation,
    GQL_CreateCustomerReferralMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_CreateCustomerReferralMutation,
    GQL_CreateCustomerReferralMutationVariables
  >(CreateCustomerReferralDocument, options)
}
export type CreateCustomerReferralMutationHookResult = ReturnType<
  typeof useCreateCustomerReferralMutation
>
export type CreateCustomerReferralMutationResult =
  Apollo.MutationResult<GQL_CreateCustomerReferralMutation>
export type CreateCustomerReferralMutationOptions = Apollo.BaseMutationOptions<
  GQL_CreateCustomerReferralMutation,
  GQL_CreateCustomerReferralMutationVariables
>
export const GetMyCustomerReferralsDocument = gql`
  query getMyCustomerReferrals {
    currentUser {
      customerReferrals {
        ...CustomerReferral
      }
    }
  }
  ${CustomerReferralFragmentDoc}
`

/**
 * __useGetMyCustomerReferralsQuery__
 *
 * To run a query within a React component, call `useGetMyCustomerReferralsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCustomerReferralsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCustomerReferralsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyCustomerReferralsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GQL_GetMyCustomerReferralsQuery,
    GQL_GetMyCustomerReferralsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetMyCustomerReferralsQuery,
    GQL_GetMyCustomerReferralsQueryVariables
  >(GetMyCustomerReferralsDocument, options)
}
export function useGetMyCustomerReferralsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetMyCustomerReferralsQuery,
    GQL_GetMyCustomerReferralsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetMyCustomerReferralsQuery,
    GQL_GetMyCustomerReferralsQueryVariables
  >(GetMyCustomerReferralsDocument, options)
}
// @ts-ignore
export function useGetMyCustomerReferralsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetMyCustomerReferralsQuery,
    GQL_GetMyCustomerReferralsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetMyCustomerReferralsQuery,
  GQL_GetMyCustomerReferralsQueryVariables
>
export function useGetMyCustomerReferralsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetMyCustomerReferralsQuery,
        GQL_GetMyCustomerReferralsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetMyCustomerReferralsQuery | undefined,
  GQL_GetMyCustomerReferralsQueryVariables
>
export function useGetMyCustomerReferralsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetMyCustomerReferralsQuery,
        GQL_GetMyCustomerReferralsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetMyCustomerReferralsQuery,
    GQL_GetMyCustomerReferralsQueryVariables
  >(GetMyCustomerReferralsDocument, options)
}
export type GetMyCustomerReferralsQueryHookResult = ReturnType<
  typeof useGetMyCustomerReferralsQuery
>
export type GetMyCustomerReferralsLazyQueryHookResult = ReturnType<
  typeof useGetMyCustomerReferralsLazyQuery
>
export type GetMyCustomerReferralsSuspenseQueryHookResult = ReturnType<
  typeof useGetMyCustomerReferralsSuspenseQuery
>
export type GetMyCustomerReferralsQueryResult = Apollo.QueryResult<
  GQL_GetMyCustomerReferralsQuery,
  GQL_GetMyCustomerReferralsQueryVariables
>
export const GetUserMarketDocument = gql`
  query getUserMarket {
    currentUser {
      id
      market {
        id
        rewardVoucherAmount
        referralVoucherAmount
      }
    }
  }
`

/**
 * __useGetUserMarketQuery__
 *
 * To run a query within a React component, call `useGetUserMarketQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserMarketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserMarketQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserMarketQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GQL_GetUserMarketQuery,
    GQL_GetUserMarketQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_GetUserMarketQuery,
    GQL_GetUserMarketQueryVariables
  >(GetUserMarketDocument, options)
}
export function useGetUserMarketLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_GetUserMarketQuery,
    GQL_GetUserMarketQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_GetUserMarketQuery,
    GQL_GetUserMarketQueryVariables
  >(GetUserMarketDocument, options)
}
// @ts-ignore
export function useGetUserMarketSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_GetUserMarketQuery,
    GQL_GetUserMarketQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetUserMarketQuery,
  GQL_GetUserMarketQueryVariables
>
export function useGetUserMarketSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetUserMarketQuery,
        GQL_GetUserMarketQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_GetUserMarketQuery | undefined,
  GQL_GetUserMarketQueryVariables
>
export function useGetUserMarketSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_GetUserMarketQuery,
        GQL_GetUserMarketQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_GetUserMarketQuery,
    GQL_GetUserMarketQueryVariables
  >(GetUserMarketDocument, options)
}
export type GetUserMarketQueryHookResult = ReturnType<
  typeof useGetUserMarketQuery
>
export type GetUserMarketLazyQueryHookResult = ReturnType<
  typeof useGetUserMarketLazyQuery
>
export type GetUserMarketSuspenseQueryHookResult = ReturnType<
  typeof useGetUserMarketSuspenseQuery
>
export type GetUserMarketQueryResult = Apollo.QueryResult<
  GQL_GetUserMarketQuery,
  GQL_GetUserMarketQueryVariables
>
export const SendCustomerReferralDocument = gql`
  mutation sendCustomerReferral(
    $customerReferralId: ID!
    $recipientEmail: String!
  ) {
    sendCustomerReferral(
      customerReferralId: $customerReferralId
      recipientEmail: $recipientEmail
    ) {
      customerReferral {
        ...CustomerReferral
        recipientEmail
      }
    }
  }
  ${CustomerReferralFragmentDoc}
`
export type GQL_SendCustomerReferralMutationFn = Apollo.MutationFunction<
  GQL_SendCustomerReferralMutation,
  GQL_SendCustomerReferralMutationVariables
>

/**
 * __useSendCustomerReferralMutation__
 *
 * To run a mutation, you first call `useSendCustomerReferralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCustomerReferralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCustomerReferralMutation, { data, loading, error }] = useSendCustomerReferralMutation({
 *   variables: {
 *      customerReferralId: // value for 'customerReferralId'
 *      recipientEmail: // value for 'recipientEmail'
 *   },
 * });
 */
export function useSendCustomerReferralMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GQL_SendCustomerReferralMutation,
    GQL_SendCustomerReferralMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    GQL_SendCustomerReferralMutation,
    GQL_SendCustomerReferralMutationVariables
  >(SendCustomerReferralDocument, options)
}
export type SendCustomerReferralMutationHookResult = ReturnType<
  typeof useSendCustomerReferralMutation
>
export type SendCustomerReferralMutationResult =
  Apollo.MutationResult<GQL_SendCustomerReferralMutation>
export type SendCustomerReferralMutationOptions = Apollo.BaseMutationOptions<
  GQL_SendCustomerReferralMutation,
  GQL_SendCustomerReferralMutationVariables
>
export const DriveTimeFilterDocument = gql`
  query driveTimeFilter($country: Countries, $state: String) {
    driveTimeFilter(country: $country, state: $state) {
      available
      originCityName
    }
  }
`

/**
 * __useDriveTimeFilterQuery__
 *
 * To run a query within a React component, call `useDriveTimeFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useDriveTimeFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDriveTimeFilterQuery({
 *   variables: {
 *      country: // value for 'country'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useDriveTimeFilterQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GQL_DriveTimeFilterQuery,
    GQL_DriveTimeFilterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_DriveTimeFilterQuery,
    GQL_DriveTimeFilterQueryVariables
  >(DriveTimeFilterDocument, options)
}
export function useDriveTimeFilterLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_DriveTimeFilterQuery,
    GQL_DriveTimeFilterQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_DriveTimeFilterQuery,
    GQL_DriveTimeFilterQueryVariables
  >(DriveTimeFilterDocument, options)
}
// @ts-ignore
export function useDriveTimeFilterSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_DriveTimeFilterQuery,
    GQL_DriveTimeFilterQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_DriveTimeFilterQuery,
  GQL_DriveTimeFilterQueryVariables
>
export function useDriveTimeFilterSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_DriveTimeFilterQuery,
        GQL_DriveTimeFilterQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_DriveTimeFilterQuery | undefined,
  GQL_DriveTimeFilterQueryVariables
>
export function useDriveTimeFilterSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_DriveTimeFilterQuery,
        GQL_DriveTimeFilterQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_DriveTimeFilterQuery,
    GQL_DriveTimeFilterQueryVariables
  >(DriveTimeFilterDocument, options)
}
export type DriveTimeFilterQueryHookResult = ReturnType<
  typeof useDriveTimeFilterQuery
>
export type DriveTimeFilterLazyQueryHookResult = ReturnType<
  typeof useDriveTimeFilterLazyQuery
>
export type DriveTimeFilterSuspenseQueryHookResult = ReturnType<
  typeof useDriveTimeFilterSuspenseQuery
>
export type DriveTimeFilterQueryResult = Apollo.QueryResult<
  GQL_DriveTimeFilterQuery,
  GQL_DriveTimeFilterQueryVariables
>
export const MapMarkerCalloutDocument = gql`
  query mapMarkerCallout($params: SearchFilters, $type: Searchable!, $id: ID!) {
    search(params: $params) {
      result(type: $type, id: $id) {
        result {
          ... on Listing {
            listingType {
              slug
            }
            subcategory {
              slug
            }
            ...ListingCardFragment
            stories {
              ...StoryCardFragment
            }
          }
          ... on StoryAdventure {
            ...AdventureCardFragment
          }
        }
        pricing {
          total
          customerServiceFee
          lineItems {
            itemType
            quantity
            price
            amount
          }
        }
        discount {
          ... on PromotionalDiscount {
            id
            name
            percentage
          }
        }
      }
    }
  }
  ${ListingCardFragmentFragmentDoc}
  ${StoryCardFragmentFragmentDoc}
  ${AdventureCardFragmentFragmentDoc}
`

/**
 * __useMapMarkerCalloutQuery__
 *
 * To run a query within a React component, call `useMapMarkerCalloutQuery` and pass it any options that fit your needs.
 * When your component renders, `useMapMarkerCalloutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMapMarkerCalloutQuery({
 *   variables: {
 *      params: // value for 'params'
 *      type: // value for 'type'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMapMarkerCalloutQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_MapMarkerCalloutQuery,
    GQL_MapMarkerCalloutQueryVariables
  > &
    (
      | { variables: GQL_MapMarkerCalloutQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GQL_MapMarkerCalloutQuery,
    GQL_MapMarkerCalloutQueryVariables
  >(MapMarkerCalloutDocument, options)
}
export function useMapMarkerCalloutLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_MapMarkerCalloutQuery,
    GQL_MapMarkerCalloutQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_MapMarkerCalloutQuery,
    GQL_MapMarkerCalloutQueryVariables
  >(MapMarkerCalloutDocument, options)
}
// @ts-ignore
export function useMapMarkerCalloutSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_MapMarkerCalloutQuery,
    GQL_MapMarkerCalloutQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_MapMarkerCalloutQuery,
  GQL_MapMarkerCalloutQueryVariables
>
export function useMapMarkerCalloutSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_MapMarkerCalloutQuery,
        GQL_MapMarkerCalloutQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_MapMarkerCalloutQuery | undefined,
  GQL_MapMarkerCalloutQueryVariables
>
export function useMapMarkerCalloutSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_MapMarkerCalloutQuery,
        GQL_MapMarkerCalloutQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_MapMarkerCalloutQuery,
    GQL_MapMarkerCalloutQueryVariables
  >(MapMarkerCalloutDocument, options)
}
export type MapMarkerCalloutQueryHookResult = ReturnType<
  typeof useMapMarkerCalloutQuery
>
export type MapMarkerCalloutLazyQueryHookResult = ReturnType<
  typeof useMapMarkerCalloutLazyQuery
>
export type MapMarkerCalloutSuspenseQueryHookResult = ReturnType<
  typeof useMapMarkerCalloutSuspenseQuery
>
export type MapMarkerCalloutQueryResult = Apollo.QueryResult<
  GQL_MapMarkerCalloutQuery,
  GQL_MapMarkerCalloutQueryVariables
>
export const MapResultsDocument = gql`
  query mapResults($params: SearchFilters) {
    search(params: $params) {
      mapResults {
        id
        type
        slug
        location: coordinates
      }
    }
  }
`

/**
 * __useMapResultsQuery__
 *
 * To run a query within a React component, call `useMapResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMapResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMapResultsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useMapResultsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GQL_MapResultsQuery,
    GQL_MapResultsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GQL_MapResultsQuery, GQL_MapResultsQueryVariables>(
    MapResultsDocument,
    options,
  )
}
export function useMapResultsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_MapResultsQuery,
    GQL_MapResultsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GQL_MapResultsQuery, GQL_MapResultsQueryVariables>(
    MapResultsDocument,
    options,
  )
}
// @ts-ignore
export function useMapResultsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_MapResultsQuery,
    GQL_MapResultsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_MapResultsQuery,
  GQL_MapResultsQueryVariables
>
export function useMapResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_MapResultsQuery,
        GQL_MapResultsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_MapResultsQuery | undefined,
  GQL_MapResultsQueryVariables
>
export function useMapResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_MapResultsQuery,
        GQL_MapResultsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_MapResultsQuery,
    GQL_MapResultsQueryVariables
  >(MapResultsDocument, options)
}
export type MapResultsQueryHookResult = ReturnType<typeof useMapResultsQuery>
export type MapResultsLazyQueryHookResult = ReturnType<
  typeof useMapResultsLazyQuery
>
export type MapResultsSuspenseQueryHookResult = ReturnType<
  typeof useMapResultsSuspenseQuery
>
export type MapResultsQueryResult = Apollo.QueryResult<
  GQL_MapResultsQuery,
  GQL_MapResultsQueryVariables
>
export const SearchDocument = gql`
  query search($pageSize: Int, $cursor: String, $params: SearchFilters) {
    search(params: $params) {
      defaults {
        percentageAvailable
        regions {
          id
          name
          slug
        }
        subcategories {
          id
          name
          slug
        }
        amenities {
          id
          name
          slug
        }
        adventureTypes {
          category
          createdAt
          id
          name
          updatedAt
          slug
        }
      }
      results: results(first: $pageSize, after: $cursor) {
        minPrice
        maxPrice
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            bucketListIds
            startDate
            endDate
            availableDates {
              startDate
              endDate
              total
            }
            pricing {
              total
              customerServiceFee
              taxAmount
              lineItems {
                itemType
                quantity
                price
                amount
              }
            }
            discount {
              ... on LongStayDiscount {
                id
                durationInNights
                percentage
              }
              ... on PromotionalDiscount {
                id
                name
                percentage
              }
            }
            result {
              ... on Listing {
                ...ListingCardFragment
                stories {
                  ...StoryCardFragment
                }
              }
              ... on Story {
                ...StoryCardFragment
                featuredListing {
                  ...StoryFeaturedListingFragment
                }
              }
              ... on StoryAdventure {
                ...AdventureCardFragment
              }
              ... on ListingAdventure {
                ...ListingAdventure
              }
            }
          }
        }
      }
    }
  }
  ${ListingCardFragmentFragmentDoc}
  ${StoryCardFragmentFragmentDoc}
  ${StoryFeaturedListingFragmentFragmentDoc}
  ${AdventureCardFragmentFragmentDoc}
  ${ListingAdventureFragmentDoc}
`

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      cursor: // value for 'cursor'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useSearchQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GQL_SearchQuery,
    GQL_SearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GQL_SearchQuery, GQL_SearchQueryVariables>(
    SearchDocument,
    options,
  )
}
export function useSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_SearchQuery,
    GQL_SearchQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GQL_SearchQuery, GQL_SearchQueryVariables>(
    SearchDocument,
    options,
  )
}
// @ts-ignore
export function useSearchSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_SearchQuery,
    GQL_SearchQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GQL_SearchQuery, GQL_SearchQueryVariables>
export function useSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_SearchQuery,
        GQL_SearchQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_SearchQuery | undefined,
  GQL_SearchQueryVariables
>
export function useSearchSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_SearchQuery,
        GQL_SearchQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GQL_SearchQuery, GQL_SearchQueryVariables>(
    SearchDocument,
    options,
  )
}
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>
export type SearchSuspenseQueryHookResult = ReturnType<
  typeof useSearchSuspenseQuery
>
export type SearchQueryResult = Apollo.QueryResult<
  GQL_SearchQuery,
  GQL_SearchQueryVariables
>
export const SuggestionsDocument = gql`
  query Suggestions(
    $listingId: ID!
    $cursor: String
    $scope: MoreEscapesScope
  ) {
    moreEscapes(
      listingId: $listingId
      first: 3
      after: $cursor
      scope: $scope
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          result {
            __typename
            ... on Listing {
              ...ListingCardFragment
            }
            ... on Story {
              ...StoryCardFragment
              featuredListing {
                ...StoryFeaturedListingFragment
              }
            }
          }
        }
      }
    }
  }
  ${ListingCardFragmentFragmentDoc}
  ${StoryCardFragmentFragmentDoc}
  ${StoryFeaturedListingFragmentFragmentDoc}
`

/**
 * __useSuggestionsQuery__
 *
 * To run a query within a React component, call `useSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestionsQuery({
 *   variables: {
 *      listingId: // value for 'listingId'
 *      cursor: // value for 'cursor'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useSuggestionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GQL_SuggestionsQuery,
    GQL_SuggestionsQueryVariables
  > &
    (
      | { variables: GQL_SuggestionsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GQL_SuggestionsQuery, GQL_SuggestionsQueryVariables>(
    SuggestionsDocument,
    options,
  )
}
export function useSuggestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GQL_SuggestionsQuery,
    GQL_SuggestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GQL_SuggestionsQuery,
    GQL_SuggestionsQueryVariables
  >(SuggestionsDocument, options)
}
// @ts-ignore
export function useSuggestionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GQL_SuggestionsQuery,
    GQL_SuggestionsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GQL_SuggestionsQuery,
  GQL_SuggestionsQueryVariables
>
export function useSuggestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_SuggestionsQuery,
        GQL_SuggestionsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GQL_SuggestionsQuery | undefined,
  GQL_SuggestionsQueryVariables
>
export function useSuggestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GQL_SuggestionsQuery,
        GQL_SuggestionsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GQL_SuggestionsQuery,
    GQL_SuggestionsQueryVariables
  >(SuggestionsDocument, options)
}
export type SuggestionsQueryHookResult = ReturnType<typeof useSuggestionsQuery>
export type SuggestionsLazyQueryHookResult = ReturnType<
  typeof useSuggestionsLazyQuery
>
export type SuggestionsSuspenseQueryHookResult = ReturnType<
  typeof useSuggestionsSuspenseQuery
>
export type SuggestionsQueryResult = Apollo.QueryResult<
  GQL_SuggestionsQuery,
  GQL_SuggestionsQueryVariables
>
